import { rsBranding, logosTiles, logos, verticals as verticals$q, ixlBranding, social, images, productSample, awards as awards$9, animations, productUnits, icons, features } from '@resourcehub/resourcehub-assets';
import React from 'react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var analytics$8 = {
  gtm_id: "GTM-TLH67WS"
};

var headerRsLogo = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    image: {
      asset_static: rsBranding.rsLogoBlackSvg,
      height: "40px",
      width: "93px",
      alt: strings.nav_primary_logo_alt
    },
    link: {
      destination: "/",
      external: false,
      new_window: false
    }
  };
});

var nav_primary_config$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: headerRsLogo({
      strings: strings
    }),
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:+861056341576",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: false,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/buy-spanish/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/buy-french/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/buy-italian/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/buy-german/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/buy-english/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }],
      language_options_other: [{
        url: "/buy-arabic/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/buy-chinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/buy-dutch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/buy-english-british/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/buy-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/buy-greek/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/buy-hebrew/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/buy-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/buy-irish/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/buy-japanese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/buy-korean/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/buy-latin/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/buy-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/buy-polish/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/buy-portuguese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/buy-russian/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/buy-spanish-spain/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/buy-swedish/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/buy-turkish/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/buy-vietnamese/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      homeschool_label: strings.nav_primary_vertical_education_homeschool_label,
      homeschool_destination: "/homeschool/",
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: false,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: false,
      destination: "https://support.rosettastone.com/cn/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/education/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: true,
      destination: "/training-centers/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/business/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards$8 = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.awards_twitter,
      asset_static: logosTiles.logosTilesTwitterSvg
    }
  }, {
    image: {
      alt: strings.awards_bmw,
      asset_static: logosTiles.logosTilesBmwSvg
    }
  }, {
    image: {
      alt: strings.awards_uber,
      asset_static: logosTiles.logosTilesUberSvg
    }
  }, {
    image: {
      alt: strings.awards_williams_sonoma,
      asset_static: logosTiles.logosTilesWsSvg
    }
  }, {
    image: {
      alt: strings.awards_lego,
      asset_static: logosTiles.logosTilesLegoSvg
    }
  }];
});

var branded_quotes$8 = (function (_ref) {
  var strings = _ref.strings;
  return [{
    name: strings.branded_quotes_macworld_name,
    type: strings.branded_quotes_macworld_type,
    quote: strings.branded_quotes_macworld_quote,
    logo: {
      asset_static: logos.logoMacworldSvg
    },
    backdrop: logos.logoMacworldBgSvg
  }, {
    name: strings.branded_quotes_techcrunch_name,
    type: strings.branded_quotes_techcrunch_type,
    quote: strings.branded_quotes_techcrunch_quote,
    logo: {
      asset_static: logos.logoTechcrunchSvg
    },
    backdrop: logos.logoTechcrunchBgSvg
  }, {
    name: strings.branded_quotes_cnn_name,
    type: strings.branded_quotes_cnn_type,
    quote: strings.branded_quotes_cnn_quote,
    logo: {
      asset_static: logos.logoCnnSvg
    },
    backdrop: logos.logoCnnBgSvg
  }];
});

var verticals$p = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/training-centers/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/business/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var pageFooter$3 = function pageFooter(_ref) {
  var strings = _ref.strings;
  return {
    awards: {
      visible: true,
      title: {
        content: strings.awards_header_label,
        align: "center",
        type: "section-title"
      },
      panels: awards$8({
        strings: strings
      })
    },
    branded_quotes: {
      visible: true,
      title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
      },
      panels: branded_quotes$8({
        strings: strings
      })
    },
    verticals: {
      visible: true,
      title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
      },
      panels: verticals$p({
        strings: strings
      })
    }
  };
};

var consumer_pages_config$3 = (function (_ref2) {
  var page = _ref2.page,
      strings = _ref2.strings;

  switch (page) {
    case "cn-consumer-404":
      return {
        page: page,
        helmet: {
          meta_title: "网页未找到 | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.cn/404/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$3({
          strings: strings
        }))
      };

    case "cn-consumer-home":
      return {
        page: page,
        helmet: {
          meta_title: "企业语言培训 | Rosetta Stone",
          meta_description: "企业语言培训 | Rosetta Stone: Rosetta Stone语言培训方案帮助员工提高商务英语和其它业务相关外语的语言能力。咨询价格",
          canonical_url: "https://www.rosettastone.cn/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$3({
          strings: strings
        }))
      };

    case "cn-consumer-dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$3({
          strings: strings
        }))
      };

    case "cn-consumer-dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$3({
          strings: strings
        }))
      };

    default:
      return null;
  }
});

var footerIxlLogo = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    image: {
      asset_static: ixlBranding.ixlLogoSvg,
      height: "45px",
      width: "110px",
      alt: strings.footer_meta_copyright_alt
    },
    link: {
      destination: "https://www.ixl.com/",
      external: false,
      new_window: false
    }
  };
});

var footerRsLogo = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    image: {
      asset_static: rsBranding.rsIconWhiteSvg,
      height: "45px",
      width: "50px",
      alt: strings.footer_meta_copyright_alt
    },
    link: {
      destination: "/",
      external: false,
      new_window: false
    }
  };
});

var consumer_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: true,
      email_capture: false,
      market: "cn",
      domain: ".cn",
      vertical: "hed",
      page: "home",
      // Strings
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.cn/training-centers/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/cn",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        icpLabel: strings.footer_meta_icp_label,
        icpLink: strings.footer_meta_icp_link,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: false,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/education/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/education/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var verticals$o = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/training-centers/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/business/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var pageFooter$2 = function pageFooter(_ref) {
  var strings = _ref.strings;
  return {
    awards: {
      visible: true,
      title: {
        content: strings.awards_header_label,
        align: "center",
        type: "section-title"
      },
      panels: awards$8({
        strings: strings
      })
    },
    branded_quotes: {
      visible: true,
      title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
      },
      panels: branded_quotes$8({
        strings: strings
      })
    },
    verticals: {
      visible: true,
      title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
      },
      panels: verticals$o({
        strings: strings
      })
    }
  };
};

var education_primary_pages_config$8 = (function (_ref2) {
  var page = _ref2.page,
      strings = _ref2.strings;

  switch (page) {
    case "cn-education-primary-contact":
      return {
        page: page,
        helmet: {
          meta_title: "业务 - 请求定价 | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.cn/education/contact/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$2({
          strings: strings
        }))
      };

    case "cn-education-primary-home":
      return {
        page: page,
        helmet: {
          meta_title: "高等教育在线语言学习 | Rosetta Stone",
          meta_description: "Rosetta Stone 高等教育语言学习解决方案可以使学生随时在线学习英语和其它语言。具体价格请咨询。",
          canonical_url: "https://www.rosettastone.cn/education/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$2({
          strings: strings
        }))
      };

    default:
      return null;
  }
});

var education_primary_footer_config$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: true,
      email_capture: false,
      market: "cn",
      domain: ".cn",
      vertical: "k12",
      page: "home",
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.cn/training-centers/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/zh-CN/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        icpLabel: strings.footer_meta_icp_label,
        icpLink: strings.footer_meta_icp_link,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: false,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/training-centers/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/training-centers/language-solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/training-centers/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var verticals$n = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/training-centers/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/business/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var pageFooter$1 = function pageFooter(_ref) {
  var strings = _ref.strings;
  return {
    awards: {
      visible: true,
      title: {
        content: strings.awards_header_label,
        align: "center",
        type: "section-title"
      },
      panels: awards$8({
        strings: strings
      })
    },
    branded_quotes: {
      visible: true,
      title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
      },
      panels: branded_quotes$8({
        strings: strings
      })
    },
    verticals: {
      visible: true,
      title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
      },
      panels: verticals$n({
        strings: strings
      })
    }
  };
};

var education_secondary_pages_config$6 = (function (_ref2) {
  var page = _ref2.page,
      strings = _ref2.strings;

  switch (page) {
    case "cn-education-secondary-contact":
      return {
        page: page,
        helmet: {
          meta_title: "业务 - 请求定价 | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.cn/training-centers/contact/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$1({
          strings: strings
        }))
      };

    case "cn-education-secondary-home":
      return {
        page: page,
        helmet: {
          meta_title: "K-12在线语言学习 | Rosetta Stone",
          meta_description: "Rosetta Stone K-12混合式语言学习解决方案包含了教师教案指导，学生可随时使用，以帮助学习或提高英语或其他语种的语言技能。",
          canonical_url: "https://www.rosettastone.cn/training-centers/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$1({
          strings: strings
        }))
      };

    case "cn-education-secondary-solutions":
      return {
        page: page,
        helmet: {
          meta_title: "K-12在线语言学习方案| Rosetta Stone",
          meta_description: "Rosetta Stone在线语言学习方案激励英语学习者和其它语种的学习者充满自信地开口说话。具体价格请咨询。",
          canonical_url: "https://www.rosettastone.cn/training-centers/solutions/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter$1({
          strings: strings
        }))
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: true,
      email_capture: false,
      market: "cn",
      domain: ".cn",
      vertical: "hed",
      page: "home",
      // Strings
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.cn/training-centers/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/zh-CN/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        icpLabel: strings.footer_meta_icp_label,
        icpLink: strings.footer_meta_icp_link,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: false,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/business/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/business/language-solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      title: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/business/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var verticals$m = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/training-centers/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/business/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var pageFooter = function pageFooter(_ref) {
  var strings = _ref.strings;
  return {
    awards: {
      visible: true,
      title: {
        content: strings.awards_header_label,
        align: "center",
        type: "section-title"
      },
      panels: awards$8({
        strings: strings
      })
    },
    branded_quotes: {
      visible: true,
      title: {
        content: strings.branded_quotes_header_label,
        align: "center",
        type: "section-title"
      },
      panels: branded_quotes$8({
        strings: strings
      })
    },
    verticals: {
      visible: true,
      title: {
        content: strings.verticals_label,
        align: "center",
        type: "section-title"
      },
      panels: verticals$m({
        strings: strings
      })
    }
  };
};

var enterprise_pages_config$8 = (function (_ref2) {
  var page = _ref2.page,
      strings = _ref2.strings;

  switch (page) {
    case "cn-enterprise-contact":
      return {
        page: page,
        helmet: {
          meta_title: "业务 - 请求定价 | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.cn/business/contact/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter({
          strings: strings
        }))
      };

    case "cn-enterprise-home":
      return {
        page: page,
        helmet: {
          meta_title: "企业语言培训 | Rosetta Stone",
          meta_description: "Rosetta Stone语言培训方案帮助员工提高商务英语和其它业务相关外语的语言能力。咨询价格。",
          canonical_url: "https://www.rosettastone.cn/business/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter({
          strings: strings
        }))
      };

    case "cn-enterprise-solutions":
      return {
        page: page,
        helmet: {
          meta_title: "全球企业语言培训 | Rosetta Stone Catalyst",
          meta_description: "Rosetta Stone Catalyst企业语言培训，提供顶级的全球商务语言培训方案，满足企业员工随时随地学习要求。详情请咨询企业版价格。",
          canonical_url: "https://www.rosettastone.cn/business/solutions/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter({
          strings: strings
        }))
      };

    case "cn-enterprise-404":
      return {
        page: page,
        helmet: {
          meta_title: "找不到网站 | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://pt.rosettastone.com/404/",
          lang: "zh"
        },
        content: _objectSpread2({}, pageFooter({
          strings: strings
        }))
      };

    default:
      return null;
  }
});

var enterprise_footer_config$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: true,
      email_capture: false,
      market: "cn",
      domain: ".cn",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.cn/training-centers/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room?c=228009&p=irol-overview",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.cn/business/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/zh-CN/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        icpLabel: strings.footer_meta_icp_label,
        icpLink: strings.footer_meta_icp_link,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: false,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var cn = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config$3({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$8({
        strings: strings
      });
      page_config = enterprise_pages_config$8({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$8({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$8({
        strings: strings
      });
      page_config = education_primary_pages_config$8({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$8({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$6({
        strings: strings
      });
      page_config = education_secondary_pages_config$6({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$6({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$8({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$8,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$7 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://www.rosettastone.de/magazine/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:08007240778",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/englisch/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/franzoesisch/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/japanisch/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/spanisch/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/italienisch/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/deutsch/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }],
      language_options_other: [{
        url: "/arabisch/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/chinesisch/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/englisch-amerikanisch/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/griechisch/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/hebraeisch/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/irisch/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/koreanisch/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/niederlaendisch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, // {
      //     url: "/buy-latin/",
      //     title: strings.locale_ko_kr_label_primary,
      //     small: strings.locale_ko_kr_label_secondary
      // },
      {
        url: "/persisch/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/philippinisch/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/polnisch/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/portugiesisch/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/russisch/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/spanisch-lateinamerika/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/schwedisch/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/tuerkisch/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/vietnamesisch/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/de/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/bildung/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/hochschulen/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/unternehmen/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/ressourcen/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/loesungen/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$l = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/preisanfrage/",
        new_window: false,
        size: "regular",
        text: "Preis anfragen",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Bereit für den nächsten Schritt?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$l = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/bildung/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/unternehmen/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$7 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "de"
        },
        content: {
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$l({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "de"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Ressourcen",
                align: "left"
              },
              body: {
                content: "Lassen Sie die Lernenden für sich selbst sprechen"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$l({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Online-Sprachunterricht für die Bildung | Rosetta Stone",
          meta_description: "Die Sprachlernlösungen von Rosetta Stone für K-12 passen in den Unterricht der Lehrer und sind jederzeit verfügbar, wenn die Schüler Englisch- oder Weltsprachkenntnisse lernen oder verbessern möchten.",
          canonical_url: "https://www.rosettastone.de/bildung/",
          lang: "de"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                controls: true
              },
              title: {
                content: "Die Zukunftsplanung beginnt heute.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Als Vorbereitung auf eine Karriere im internationalen Umfeld ist das Erlernen von Fremdsprachen heute fester Bestandteil der Bildung an Schulen und Hochschulen. Mit den Lösungen von Rosetta Stone lernen Ihre Schüler und Studierenden anhand individueller Lernpfade besonders effektiv, motiviert und flexibel. Wir ermöglichen das eigenständige Lernen oder die Einbindung in Blended Learning-Konzepte. Unser immersiver Ansatz trainiert das Hören, Sprechen und Lesen einer Fremdsprache von der ersten Sekunde an."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Wir von Rosetta Stone verfolgen das Ziel, allen Lernern das bestmögliche Training zu bieten. Rosetta Stone Foundations ist die perfekte Lösung für alle Sprachanfänger, Rosetta Stone Advantage vertieft erste Grundkenntnisse besonders effizient. Dabei spielt es keine Rolle, ob Sie das Sprachtraining für Schüler, Studierende oder Mitarbeiter an Ihrer Bildungseinrichtung anbieten möchten – die Trainingseinheiten werden gezielt auf den Kenntnisstand des individuellen Lerners abgestimmt."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Vielseitige Trainingsformen fördern Effizienz.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }]
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Verbesserte interkulturelle Kompetenz.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "An Schulen und Hochschulen treffen heute verschiedenste Sprachen und Kulturen aufeinander. Das Sprachtraining von Rosetta Stone fördert den verbalen Austausch sowie das Verständnis für andere Kulturen. Fördern Sie Toleranz und Verständnis auf dem Schulhof oder dem Campus und zeigen Sie Ihren Schülern und Studierenden die Vorteile eines offenen und verständnisvollen Miteinanders auf."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Mehr Abwechslung für Ihren Unterricht.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Blended Learning-Konzepte finden heute bereits an vielen Schulen und Hochschulen Anwendung. Mit Blended Learning gestalten Sie die verfügbare Unterrichtszeit besonders abwechslungsreich und effektiv. Wir bieten die technologische Grundlage für einen optimierten Unterricht, der sich flexibel in Ihren Lehrplan integrieren lässt und dem jeder Schüler folgen kann."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Motivation pur für Digital Natives.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Aufgrund zeitlicher und räumlicher Flexibilität eignet sich E-Learning hervorragend für die Hochschulbildung. Doch auch an Schulen ist der technologische Fortschritt längst nicht mehr wegzudenken, denn die Anforderungen der Digital Natives wandeln sich. Mit den mobilen Apps von Rosetta Stone motivieren Sie Ihre Schüler zum Erlernen einer Fremdsprache und geben den Studierenden Ihrer Hochschule die Möglichkeit, flexibel zu lernen – wann und wo sie möchten."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Für gezielte Fortschritte in kürzester Zeit. ",
                learner_feature_1_title: "Individueller Lernpfad",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Eintauchen in eine völlig neue Welt. ",
                learner_feature_2_title: "Immersive Methode",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Sprachen lernen, Länder entdecken. ",
                learner_feature_3_title: "Kulturelles Wissen",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Für mehr Selbstbewusstsein beim Sprechen. ",
                learner_feature_4_title: "Spracherkennung",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Mit Abwechslung und Spaß zu neuem Wissen.",
                learner_feature_5_title: "Vielseitige Trainingsmethoden",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Lernen wann und wo es gerade passt.",
                learner_feature_6_title: "Mobile Apps",
                learner_feature_title: "Ob on- oder offline - unsere preisgekrönte App spricht für sich selbst!"
              },
              data: {}
            }]
          }],
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$l({
            strings: strings
          })
        }
      };

    case "preisanfrage":
      return {
        page: page,
        helmet: {
          meta_title: "Preisanfrage | Rosetta Stone",
          meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
          canonical_url: "https://www.rosettastone.de/bildung/preisanfrage",
          lang: "de"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Vereinbaren Sie noch heute einen Termin mit einem Sprachexperten."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Bitte füllen Sie das Formular unten aus, um einen Termin für ein Gespräch darüber zu vereinbaren, wie wir Ihnen helfen können."
          },
          lead_generation_form: {
            explicitOptIn: {
              content: "Ja, ich stimme dem Erhalt von Informations- und Marketingmaterial über Produktneuigkeiten, Angebote und Veranstaltungen von Rosetta Stone zu. Mit meiner Zustimmung bestätige ich die Verarbeitung meiner Daten gemäß der Datenschutzrichtlinie von Rosetta Stone."
            },
            title: {
              theme: "blue",
              type: "section-title",
              content: "Fast geschafft!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Vorname",
                required: true,
                required_error: "Bitte geben Sie Ihren Vornamen ein."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Nachname",
                required: true,
                required_error: "Bitte geben Sie Ihren Nachnamen ein."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "E-Mail-Adresse",
                required: true,
                required_error: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefonnummer",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Unternehmen*",
                required: true,
                required_error: "Bitte geben Sie den Namen Ihres Unternehmens ein."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Unternehmensgröße",
                required: true,
                required_error: "Bitte geben Sie die Größe Ihres Unternehmens ein.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 oder Weniger",
                  label: "100 oder Weniger"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 oder Mehr",
                  label: "50,001 oder Mehr"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Titel",
                required: true,
                required_error: "Bitte geben Sie Ihre Funktion ein."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Preis anfragen"
            },
            labels: {
              form_principal: "Auftraggeber / Vizepräsident",
              form_privacy1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
              form_privacy2: "Datenschutzrichtlinie von Rosetta Stone ",
              form_privacy3: "teilen darf. Es ist mir ebenfalls bewusst, dass ich mich jederzeit von jeglicher Kommunikation abmelden kann, indem ich den" + "Abmelden" + "Link im Info- und Marketingmaterial klicke oder indem ich Rosetta Stone unter ",
              form_privacy4: " kontaktiere.",
              form_privacyUrl: "https://www.rosettastone.de/datenschutzrichtlinie",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_techcoordinator: "Technologiekoordinator",
              form_updateagreement1: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
              form_updateagreement2: "Mehr erfahren",
              form_updateagreement3: " "
            },
            domain: ".de",
            dataQaLocation: "page",
            awards: awards$7({
              strings: strings
            }),
            branded_quotes: branded_quotes$7({
              strings: strings
            }),
            verticals: verticals$l({
              strings: strings
            })
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          })
        }
      };

    case "preisanfrage-abgeschlossen":
      return {
        page: page,
        helmet: {
          meta_title: "Preisanfrage abgeschlossen | Rosetta Stone",
          meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
          canonical_url: "https://www.rosettastone.de/bildung/preisanfrage-abgeschlossen/",
          lang: "de"
        },
        content: {
          title: {
            align: "center",
            content: "Vielen Dank für Ihr Interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Sehen Sie sich vor dem Gespräch einige zusätzliche Ressourcen an!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/ressourcen/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Ressourcen",
            theme: "blue_white"
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Online-Sprachlernprogramme für den Bildungsbereich | Rosetta Stone",
          meta_description: "Die Online-Sprachlernprogramme von Rosetta Stone motivieren Englischlernende und Sprachschüler aus aller Welt, selbstsicher zu sprechen. Fragen Sie nach den Preisen.",
          canonical_url: "https://www.rosettastone.de/bildung/loesungen/",
          lang: "de"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              image: {
                asset_fluid: null
              },
              title: {
                content: "Optimieren Sie Ihre globale Expansion.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Schüler und Studierende von heute sind mit mobilen Geräten wie Smartphones und Tablets großgeworden. Mit flexiblem E-Learning sorgen Sie bei Digital Natives für Begeisterung. Sie schaffen eine zeitgemäße Erweiterung Ihres Unterrichts, ohne Ihren eigenen Aufwand zu erhöhen. Gruppentrainings, individuelle Lerninhalte und Fortschrittskontrollen fördern die Motivation Ihrer Schüler und Studierenden zusätzlich."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Motivieren Sie Digital Natives mit modernen Trainingsmethoden.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Das Sprechen einer zweiten oder dritten Sprache ist heute absolute Grundvoraussetzung für eine Karriere im internationalen Umfeld. Dennoch fehlt es aufgrund organisatorischer oder finanzieller Aspekte an vielen Schulen und Hochschulen an ausreichender Förderung. Mit den Sprachlernlösungen von Rosetta Stone stellen Sie sich dieser Entwicklung entgegen und positionieren sich als attraktive Bildungseinrichtung."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Fördern Sie die Zukunft Ihrer Schüler und Studierenden.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "Das Erlernen einer Fremdsprache erfordert viel Engagement und Durchhaltevermögen. Als Teil einer Gruppe lernen Ihre Schüler und Studierenden schneller und motivierter. Verantwortliche von Bildungseinrichtungen können diese Entwicklung unterstützen, indem sie die richtigen Online- und Offline-Tools zum gemeinsamen Lernen bereitstellen. Blended Learning-Konzepte und mobile Apps bereichern nicht nur den Unterricht, sondern schaffen auf allen Seiten mehr Freiräume."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Etablieren Sie Sprachtraining als gemeinschaftliche Aktivität.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Wir lassen Ihre Schüler und Studierenden vollkommen in eine neue Sprachumgebung eintauchen, um das Sprechen, Lesen, Schreiben und Hören spielend und effizient zu trainieren. ",
                feature_1_title: "Immersiver Lernansatz.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Mit direktem Feedback zur Aussprache unterbinden wir Fehler von Beginn an. Ihre Schüler und Studierenden erlernen die korrekte Diktion und haben mehr Selbstvertrauen beim Sprechen. ",
                feature_2_title: "Training der Aussprache.",
                feature_3_img: null,
                feature_3_subtitle: null,
                feature_3_title: null,
                feature_4_img: "icon_24",
                feature_4_subtitle: "Mit Rosetta Stone erlernen Ihre Schüler und Studierenden eine von bis zu 24 Sprachen – unabhängig davon, ob bereits erste Grundkenntnisse vorhanden sind oder nicht. ",
                feature_4_title: "24 Sprachen.",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Wir bieten spezielle Offline-Übungsbücher und Materialien, die Ihren Unterricht erweitern und sämtliche Online-Übungen gezielt vertiefen. ",
                feature_5_title: "Unterrichtsergänzung.",
                feature_6_img: null,
                feature_6_subtitle: null,
                feature_6_title: null,
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Mit einem Einstufungstest vor Trainingsbeginn identifizieren wir die individuellen Bedürfnisse und Fähigkeiten Ihrer Schüler, um herausfordernde aber dennoch machbare Aufgaben zu stellen. ",
                feature_7_title: "Einstufungstest.",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Egal ob eine Sprache von Grund auf erlernt werden muss oder ob bereits Grundkenntnisse vorhanden sind: Mit Rosetta Stone Foundations und Rosetta Stone Advantage erhält jeder Schüler das passende Training. ",
                feature_8_title: "Anfänger und Fortgeschrittene.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Ob Vokabeln, Grammatik oder Aussprache: Wir setzen auf spezielle Trainingsmethoden, mit denen Ihrer Schüler und Studierenden ihre Lese-, Hör- und Sprachfertigkeiten spielend weiterentwickeln.",
                feature_9_title: "Games und Activities.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Unsere Trainings beinhalten spezielle Lese- und Schreibübungen mit sofortigem Feedback. Auf diese Weise werden die wesentlichen Sprachfähigkeiten Hören, Lesen und Schreiben effizient trainiert.  ",
                feature_10_title: "Lese- und Schreibübungen.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Mit unseren mobilen Apps lernen Ihre Schüler und Studierenden an mobilen Endgeräten – wann und wo sie möchten. Dadurch erfüllen unsere flexiblen Lösungen auch die Anforderungen von Digital Natives.",
                feature_11_title: "Mobile Apps.",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Unsere Reporting Tools zeigen die Lernfortschritte einzelner Schüler, Lerngruppen oder Klassen transparent auf und erleichtern es Ihren Lehrkräften, den Überblick zu bewahren.",
                feature_12_title: "Reporting Tools.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "Mit unserem flexiblen Lizenzsystem können Sie schnell neue Schüler oder Studierende für das Training freischalten oder nicht genutzte Lizenzen übertragen.",
                feature_13_title: "Übertragbare Lizenzen",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Unser erfahrenes Team stellt effektive Trainingsmodelle für Sie zusammen und unterstützt Sie bei der technischen und organisatorischen Umsetzung des Sprachtrainings in Ihrer Bildungseinrichtung.",
                feature_14_title: "Implementierungs-Support.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Wir unterstützen Sie dabei, dass die Einbindung unserer Sprachlernlösungen für alle Beteiligten ein voller Erfolg wird und schulen die verantwortlichen Personen an Ihrer Bildungseinrichtung.",
                feature_15_title: "Training-Services.",
                feature_section_title: "Jede Ressource, die Sie benötigen, steht Ihnen zur Verfügung",
                meta_description: "Die Online-Sprachlernprogramme von Rosetta Stone motivieren Englischlernende und Sprachschüler aus aller Welt, selbstsicher zu sprechen. Fragen Sie nach den Preisen.",
                meta_title: "Online-Sprachlernprogramme für den Bildungsbereich | Rosetta Stone",
                pricing_subtitle: null,
                pricing_title: null,
                section_1_body: "Fremdsprachenunterricht ist fester Bestandteil der Bildung an Schulen und Hochschulen. Mitunter entscheiden sich Schüler und Studierende auch freiwillig dazu, eine weitere Fremdsprache zu erlernen, um sich beispielsweise auf einen Auslandsaufenthalt vorzubereiten. Egal woher die Motivation Ihrer Schüler stammt: Mit Rosetta Stone bieten Sie an Ihrer Bildungseinrichtung das passende Training für alle Bedürfnisse. ",
                section_1_cta_caption: null,
                section_1_link: null,
                section_1_logo: null,
                section_1_play_text: null,
                section_1_quote: null,
                section_1_secondary_cta: "Angebot anfordern",
                section_1_title: "Erfüllen Sie individuelle Bedürfnisse mit nur einer Lösung. ",
                section_1_video_url: null,
                section_2_body: "Schüler und Studierende von heute sind mit mobilen Geräten wie Smartphones und Tablets großgeworden. Mit flexiblem E-Learning sorgen Sie bei Digital Natives für Begeisterung. Sie schaffen eine zeitgemäße Erweiterung Ihres Unterrichts, ohne Ihren eigenen Aufwand zu erhöhen. Gruppentrainings, individuelle Lerninhalte und Fortschrittskontrollen fördern die Motivation Ihrer Schüler und Studierenden zusätzlich.",
                section_2_link: null,
                section_2_logo: null,
                section_2_quote: null,
                section_2_title: "Motivieren Sie Digital Natives mit modernen Trainingsmethoden.",
                section_3_body: "Das Sprechen einer zweiten oder dritten Sprache ist heute absolute Grundvoraussetzung für eine Karriere im internationalen Umfeld. Dennoch fehlt es aufgrund organisatorischer oder finanzieller Aspekte an vielen Schulen und Hochschulen an ausreichender Förderung. Mit den Sprachlernlösungen von Rosetta Stone stellen Sie sich dieser Entwicklung entgegen und positionieren sich als attraktive Bildungseinrichtung. ",
                section_3_link: null,
                section_3_logo: null,
                section_3_play_text: null,
                section_3_quote: null,
                section_3_title: "Fördern Sie die Zukunft Ihrer Schüler und Studierenden. ",
                section_3_video_url: null,
                section_4_body: "Das Erlernen einer Fremdsprache erfordert viel Engagement und Durchhaltevermögen. Als Teil einer Gruppe lernen Ihre Schüler und Studierenden schneller und motivierter. Verantwortliche von Bildungseinrichtungen können diese Entwicklung unterstützen, indem sie die richtigen Online- und Offline-Tools zum gemeinsamen Lernen bereitstellen. Blended Learning-Konzepte und mobile Apps bereichern nicht nur den Unterricht, sondern schaffen auf allen Seiten mehr Freiräume.\n",
                section_4_link: null,
                section_4_logo: null,
                section_4_quote: null,
                section_4_title: "Etablieren Sie Sprachtraining als gemeinschaftliche Aktivität. ",
                title: "de-edu-solutions"
              }
            }]
          }],
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$l({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$l({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.de/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/bildung/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/hochschulen/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/unternehmen/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/oeffentlichersektor/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_publicsector_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.de/ueber-uns",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/magazine",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/kontakt/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/de/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/faq",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/systemanforderungen",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.de/vereinbarungen"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.de/nutzungsbedingungen"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneDE",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneDE",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/ressourcen/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/loesungen/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$k = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/preisanfrage/",
        new_window: false,
        size: "regular",
        text: "Preis anfragen",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Bereit für den nächsten Schritt?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$k = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/bildung/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/unternehmen/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$7 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "de"
        },
        content: {
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$k({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "de"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Ressourcen",
                align: "left"
              },
              body: {
                content: "Lassen Sie die Lernenden für sich selbst sprechen"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$k({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Geschäftssprachentraining, das funktioniert | Rosetta Stone",
          meta_description: "Die Schulungslösungen von Rosetta Stone helfen den Mitarbeitern, Sprachkenntnisse in Englisch für Unternehmen und viele gefragte Geschäftssprachen zu entwickeln. Preis anfragen",
          canonical_url: "https://www.rosettastone.de/unternehmen/",
          lang: "de"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Effizientes Training ab der ersten Minute",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Eine neue Sprache zu erlernen, ist mit viel Aufwand verbunden und verlangt Durchhaltevermögen. Rosetta Stone hat einen einzigartigen Ansatz entwickelt, bei dem die Kenntnisse von Beginn an besonders effizient aufgebaut werden. Ihre Mitarbeiter wählen branchenspezifische Inhalte aus, die für sie besonders relevant sind und lernen auf Grundlage eines Einstufungstests. Erste Kenntnisse können schon bald im Arbeitsalltag eingesetzt werden."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Eine Fremdsprache zu erlernen, ist eine Sache. Die Kenntnisse in der realen Welt anzuwenden, eine ganz andere. Mit unseren speziell konzipierten Trainingsmethoden stärken wir das Selbstbewusstsein Ihrer Mitarbeiter beim Sprechen. Großer Beliebtheit erfreuen sich dabei die Live-Tutorings mit Muttersprachlern, die Fragen beantworten oder die Aussprache verbessern. Dank flexibler Terminauswahl lässt sich das Live-Tutoring wunderbar in den Alltag integrieren."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Gezieltes Lernen mit Muttersprachlern",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }]
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Gezieltes Lernen mit Muttersprachlern",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Eine Fremdsprache zu erlernen, ist eine Sache. Die Kenntnisse in der realen Welt anzuwenden, eine ganz andere. Mit unseren speziell konzipierten Trainingsmethoden stärken wir das Selbstbewusstsein Ihrer Mitarbeiter beim Sprechen. Großer Beliebtheit erfreuen sich dabei die Live-Tutorings mit Muttersprachlern, die Fragen beantworten oder die Aussprache verbessern. Dank flexibler Terminauswahl lässt sich das Live-Tutoring wunderbar in den Alltag integrieren."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Flexibles Lernen – immer und überall auch Offline",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Ob vor der Arbeit, zwischen zwei Terminen oder nach Feierabend: Mit den mobilen Apps von Rosetta Stone lernen Ihre Mitarbeiter wann und wo sie möchten. Unsere Trainingsmethoden sind für mobile Endgeräte wie Tablets oder Smartphones optimiert und somit auch ideal auf die Zielgruppe der Digital Natives abgestimmt. Geben Sie Ihren Mitarbeitern die Flexibilität, die sie sich wünschen und positionieren Sie sich als attraktiver Arbeitgeber."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Fremdsprachen-Kenntnisse sofort einsetzen",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Hören, sprechen, lesen: Mit Rosetta Stone tauchen Ihre Mitarbeiter direkt in eine völlig neue Sprachwelt ein. Unser immersiver Lernansatz ist darauf ausgerichtet, dass die neuen Sprachkenntnisse Ihrer Mitarbeiter im Arbeitsalltag sofort Anwendung finden. Die vermittelten Inhalte sind relevant; jede investierte Minute zahlt sich aus – das wirkt sich positiv auf Ihren Return on Investment aus."
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Übertragbar auf andere Mitarbeiter mit 24 Sprachen in einer Lizenz.",
                learner_feature_1_title: "Flexible Lizenzen",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Die Lernfortschritte von Lernern sind transparent.",
                learner_feature_2_title: "Reporting Tools",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Ideal auf Vorkenntnisse und Ziele abgestimmt.",
                learner_feature_3_title: "Individuelle Inhalte",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Mitarbeiter erhalten direktes Feedback.",
                learner_feature_4_title: "Training der Aussprache",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Unbegrenztes Training mit Muttersprachlern.",
                learner_feature_5_title: "Live-Tutoring",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Flexibles Lernen - immer und überall auch Offline",
                learner_feature_6_title: "Mobile App",
                learner_feature_title: "Ob on- oder offline - unsere preisgekrönte App spricht für sich selbst!"
              },
              data: {}
            }]
          }],
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$k({
            strings: strings
          })
        }
      };

    case "preisanfrage":
      return {
        page: page,
        helmet: {
          meta_title: "Preisanfrage | Rosetta Stone",
          meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
          canonical_url: "https://www.rosettastone.de/unternehmen/preisanfrage/",
          lang: "de"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Vereinbaren Sie noch heute einen Termin mit einem Sprachexperten."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Bitte füllen Sie das Formular unten aus, um einen Termin für ein Gespräch darüber zu vereinbaren, wie wir Ihnen helfen können."
          },
          lead_generation_form: {
            explicitOptIn: {
              content: "Ja, ich stimme dem Erhalt von Informations- und Marketingmaterial über Produktneuigkeiten, Angebote und Veranstaltungen von Rosetta Stone zu. Mit meiner Zustimmung bestätige ich die Verarbeitung meiner Daten gemäß der Datenschutzrichtlinie von Rosetta Stone."
            },
            title: {
              theme: "blue",
              type: "section-title",
              content: "Fast geschafft!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Vorname",
                required: true,
                required_error: "Bitte geben Sie Ihren Vornamen ein."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Nachname",
                required: true,
                required_error: "Bitte geben Sie Ihren Nachnamen ein."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "E-Mail-Adresse",
                required: true,
                required_error: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefonnummer",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Unternehmen*",
                required: true,
                required_error: "Bitte geben Sie den Namen Ihres Unternehmens ein."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Unternehmensgröße",
                required: true,
                required_error: "Bitte geben Sie die Größe Ihres Unternehmens ein.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 oder Weniger",
                  label: "100 oder Weniger"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 oder Mehr",
                  label: "50,001 oder Mehr"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Titel",
                required: true,
                required_error: "Bitte geben Sie Ihre Funktion ein."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Preis anfragen"
            },
            labels: {
              form_principal: "Auftraggeber / Vizepräsident",
              form_privacy1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
              form_privacy2: "Datenschutzrichtlinie von Rosetta Stone ",
              form_privacy3: 'teilen darf. Es ist mir ebenfalls bewusst, dass ich mich jederzeit von jeglicher Kommunikation abmelden kann, indem ich den "Abmelden" Link im Info- und Marketingmaterial klicke oder indem ich Rosetta Stone unter ',
              form_privacy4: " kontaktiere.",
              form_privacyUrl: "https://www.rosettastone.de/datenschutzrichtlinie",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_techcoordinator: "Technologiekoordinator",
              form_updateagreement1: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
              form_updateagreement2: "Mehr erfahren",
              form_updateagreement3: " "
            },
            domain: ".de",
            dataQaLocation: "page"
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          })
        }
      };

    case "preisanfrage-abgeschlossen":
      return {
        page: page,
        helmet: {
          meta_title: "Preisanfrage abgeschlossen | Rosetta Stone",
          meta_description: "Sprachbarrieren schränken die Fähigkeit globaler Dienstleistungs- und Beratungsunternehmen ein, Kunden zu bedienen, mit Mitarbeitern zu interagieren und das Wachstum des Geschäfts weltweit zu fördern. Sprachtrainingslösungen helfen Dienstleistungs- und Beratungsunternehmen, den Anteil der abrechenbaren Arbeitszeit zu maximieren – ein Beleg für den relevanten ROI, den unsere Sprachtrainings organisationsweit erzielen.",
          canonical_url: "https://www.rosettastone.de/unternehmen/preisanfrage-abgeschlossen/",
          lang: "de"
        },
        content: {
          title: {
            align: "center",
            content: "Vielen Dank für Ihr Interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Sehen Sie sich vor dem Gespräch einige zusätzliche Ressourcen an!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/ressourcen/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Ressourcen",
            theme: "blue_white"
          },
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Globales Geschäftssprachentraining  | Rosetta Stone Catalyst",
          meta_description: "Das weltweite Geschäftssprachentraining mit Rosetta Stone Catalyst bietet die Top-Geschäftssprachen, die Mitarbeiter von überall aus lernen können. Firmenpreis anfordern",
          canonical_url: "https://www.rosettastone.de/unternehmen/loesungen/",
          lang: "de"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                controls: true
              },
              title: {
                content: "Optimieren Sie Ihre globale Expansion.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/preisanfrage/",
                    new_window: false,
                    size: "regular",
                    text: "Preis anfragen",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Digitales Sprachtraining wird auf Management-Ebene immer beliebter, doch die Ausgaben müssen skalier- und messbar sein. Rosetta Stone steht Ihnen bei der Implementierung des kosteneffizienten Trainings zur Seite. Minimieren Sie Ihren administrativen Aufwand, geben Sie Ihren Mitarbeitern die Möglichkeit flexible zu lernen und behalten Sie mit unseren Reporting Tools stets den Überblick über Ihren ROI."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Setzen Sie auf skalierbares digitales Training.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Standortübergreifendes Arbeiten wird immer wichtiger, doch Kommunikationsprobleme sorgen für ärgerliche Fehler. Mit den Sprachlernlösungen von Rosetta Stone optimieren Sie die interne Kommunikation über verschiedene Standorte hinweg. Ihre Mitarbeiter wählen für sie relevante Inhalte aus, lernen vollkommen flexibel und gewinnen Selbstvertrauen beim Sprechen. Das verbessert die Performance, die Produktivität und die Zusammenarbeit im Team."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Verbessern Sie die interne Kommunikation und Produktivität.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "Viele Unternehmen bieten bereits Sprachtraining an, doch klassischer Unterricht kann die Anforderungen der Mitarbeiter nicht mehr erfüllen. Mit den flexiblen digitalen Sprachlernlösungen von Rosetta Stone steigern Sie die Lernmotivation und Zufriedenheit Ihrer Mitarbeiter. Erfüllen Sie die Bedürfnisse von Digital Natives und positionieren Sie sich als attraktiver Arbeitgeber."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Steigern Sie die Zufriedenheit Ihrer Mitarbeiter.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ihre Mitarbeiter entscheiden, welche Inhalte für sie besonders relevant sind und lernen anhand eines individuellen Lernpfads. Gelerntes findet im Berufsalltag direkt Anwendung. ",
                feature_1_title: "Individuelle Inhalte.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Mit direktem Feedback zur Aussprache Ihrer Mitarbeiter unterbinden wir Fehler von Beginn an. Ihre Mitarbeiter erlernen die korrekte Diktion und haben mehr Selbstvertrauen beim Sprechen. ",
                feature_2_title: "Training der Aussprache.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Unsere 1:1-Trainings mit Muttersprachlern dienen der gezielten Verbesserung der Aussprache und steigern das Selbstbewusstsein Ihrer Mitarbeiter bei der Anwendung neuer Kenntnisse.",
                feature_3_title: "Live-Tutoring.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Mit Rosetta Stone erlernen Ihre Mitarbeiter eine von bis zu 24 Sprachen – unabhängig davon, ob bereits erste Grundkenntnisse vorhanden sind oder die Sprache vollkommen neu erlernt werden muss. ",
                feature_4_title: "24 Sprachen.",
                feature_5_img: null,
                feature_5_subtitle: null,
                feature_5_title: null,
                feature_6_img: null,
                feature_6_subtitle: null,
                feature_6_title: null,
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Mit einem Einstufungstest vor Trainingsbeginn identifizieren wir die individuellen Bedürfnisse und Fähigkeiten Ihrer Mitarbeiter, um herausfordernde aber dennoch machbare Aufgaben zu stellen. ",
                feature_7_title: "Einstufungstest.",
                feature_8_img: null,
                feature_8_subtitle: null,
                feature_8_title: null,
                feature_9_img: "icon_games",
                feature_9_subtitle: "Ob Vokabeln, Grammatik oder Aussprache: Wir setzen auf spezielle Trainingsmethoden, mit denen Ihre Mitarbeiter ihre Lese-, Hör- und Sprachfertigkeiten spielend weiterentwickeln.",
                feature_9_title: "Games und Activities.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Unsere Trainings beinhalten spezielle Lese- und Schreibübungen mit sofortigem Feedback. Auf diese Weise werden die wesentlichen Sprachfähigkeiten Hören, Lesen und Schreiben effizient trainiert.  ",
                feature_10_title: "Lese- und Schreibübungen.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Mit unseren mobilen Apps lernen Ihre Mitarbeiter an mobilen Endgeräten – wann und wo sie möchten. Die flexiblen Lösungen bedienen dadurch auch die Anforderungen von Digital Natives.",
                feature_11_title: "Mobile Apps.",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Unsere Reporting Tools zeigen die Lernfortschritte von Personen oder Gruppen sowie an einzelnen Standorten transparent auf, damit Sie jederzeit den Überblick über Ihren ROI behalten.",
                feature_12_title: "Reporting Tools.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "Mit unserem flexiblen Lizenzsystem können Sie schnell neue Mitarbeiter für das Training freischalten oder nicht genutzte Lizenzen übertragen, was sich positiv auf den ROI auswirkt. ",
                feature_13_title: "Übertragbare Lizenzen.",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Unser erfahrenes Team stellt effektive Trainingsmodelle für Sie zusammen und unterstützt Sie bei der technischen und organisatorischen Umsetzung des Sprachtrainings in Ihrem Unternehmen. ",
                feature_14_title: "Implementierungs-Support.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Wir unterstützen Sie dabei, dass die Einbindung unserer Sprachlernlösungen für alle Beteiligten ein voller Erfolg wird und schulen die verantwortlichen Personen in Ihrem Unternehmen. ",
                feature_15_title: "Training-Services.",
                feature_section_title: "Jede Ressource, die Sie benötigen, steht Ihnen zur Verfügung",
                meta_description: "Das weltweite Geschäftssprachentraining mit Rosetta Stone Catalyst bietet die Top-Geschäftssprachen, die Mitarbeiter von überall aus lernen können. Firmenpreis anfordern",
                meta_title: "Globales Geschäftssprachentraining  | Rosetta Stone Catalyst",
                pricing_subtitle: null,
                pricing_title: null,
                section_1_body: "Die Globalisierung sorgt für eine zunehmende Anzahl internationaler Kooperationen, doch Sprachbarrieren erschweren die Erschließung neuer Märkte. Rosetta Stone bietet Ihnen ein standardisiertes digitales Sprachtraining für alle Ihre Mitarbeiter an allen Standorten. Setzen Sie auf schnelle Erfolge mit unseren bewährten Trainingsmethoden und fördern Sie die interkulturelle Kompetenz Ihrer Mitarbeiter. ",
                section_1_cta_caption: null,
                section_1_link: null,
                section_1_logo: null,
                section_1_play_text: "Video abspielen",
                section_1_quote: null,
                section_1_secondary_cta: "Angebot anfordern",
                section_1_title: "Optimieren Sie Ihre globale Expansion.",
                section_1_video_url: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                section_2_body: "Digitales Sprachtraining wird auf Management-Ebene immer beliebter, doch die Ausgaben müssen skalier- und messbar sein. Rosetta Stone steht Ihnen bei der Implementierung des kosteneffizienten Trainings zur Seite. Minimieren Sie Ihren administrativen Aufwand, geben Sie Ihren Mitarbeitern die Möglichkeit flexible zu lernen und behalten Sie mit unseren Reporting Tools stets den Überblick über Ihren ROI. ",
                section_2_link: null,
                section_2_logo: null,
                section_2_quote: null,
                section_2_title: "Setzen Sie auf skalierbares digitales Training. ",
                section_3_body: "Standortübergreifendes Arbeiten wird immer wichtiger, doch Kommunikationsprobleme sorgen für ärgerliche Fehler. Mit den Sprachlernlösungen von Rosetta Stone optimieren Sie die interne Kommunikation über verschiedene Standorte hinweg. Ihre Mitarbeiter wählen für sie relevante Inhalte aus, lernen vollkommen flexibel und gewinnen Selbstvertrauen beim Sprechen. Das verbessert die Performance, die Produktivität und die Zusammenarbeit im Team. ",
                section_3_link: null,
                section_3_logo: null,
                section_3_play_text: "Video abspielen",
                section_3_quote: null,
                section_3_title: "Verbessern Sie die interne Kommunikation und Produktivität.",
                section_3_video_url: "https://resources.rosettastone.com/CDN/us/videos/International_Markets/German/Catalyst_2_German.mp4",
                section_4_body: "Viele Unternehmen bieten bereits Sprachtraining an, doch klassischer Unterricht kann die Anforderungen der Mitarbeiter nicht mehr erfüllen. Mit den flexiblen digitalen Sprachlernlösungen von Rosetta Stone steigern Sie die Lernmotivation und Zufriedenheit Ihrer Mitarbeiter. Erfüllen Sie die Bedürfnisse von Digital Natives und positionieren Sie sich als attraktiver Arbeitgeber. \n",
                section_4_link: null,
                section_4_logo: null,
                section_4_quote: null,
                section_4_title: "Steigern Sie die Zufriedenheit Ihrer Mitarbeiter. ",
                title: "de-corp-solutions"
              }
            }]
          }],
          awards: awards$7({
            strings: strings
          }),
          branded_quotes: branded_quotes$7({
            strings: strings
          }),
          verticals: verticals$k({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$k({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.de/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/bildung/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/hochschulen/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/unternehmen/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/oeffentlichersektor/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_publicsector_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.de/ueber-uns",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/magazine",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/kontakt/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/de/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.de/systemanforderungen/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.de/vereinbarungen/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://www.rosettastone.de/nutzungsbedingungen/"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneDE",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneDE",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var de = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$7({
        strings: strings
      });
      page_config = enterprise_pages_config$7({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$7({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$7({
        strings: strings
      });
      page_config = education_primary_pages_config$7({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$7({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$7({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$7,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$6 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://www.rosettastone.es/magazine/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18003063467",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/ingles/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/frances/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/arabe/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/aleman/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/espanol/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }],
      language_options_other: [{
        url: "/chino/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/espanol-latinoamericano/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/filipino/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/griego/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/hebreo/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/hindu/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/holandes/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/ingles-americano/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/irlandes/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/japones/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, // {
      //     url: "/buy-latin/",
      //     title: strings.locale_la_va_label_primary,
      //     small: strings.locale_la_va_label_secondary
      // },
      {
        url: "/persa/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/polaco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/portugues/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/ruso/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/sueco/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/es",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacion-primaria-y-secundaria/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/educacion-superior/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_market_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresas/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$j = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$j = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$6 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "",
          lang: "es"
        },
        content: {
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$j({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$j({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$j({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.com/empresas/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.com/empresas/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/soluciones/",
          lang: "es"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://resources.rosettastone.com/CDN/cn/Business/Language-Training-For-Global-Business.mp4"
              },
              title: {
                content: "Nuestras soluciones de aprendizaje para educación primaria y secundaria (K-12) brindan apoyo a los estudiantes de cualquier idioma.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Los estudiantes se sienten inspirados para aprender un nuevo idioma. Algunos eligen programas de aprendizaje de idioma inglés para principiantes y esperan el momento de poder hablar con sus pares. Otros estudian en una clase de lengua extranjera con el anhelo de que un día podrán disfrutar de la experiencia de vivir en una cultura diferente. Cualesquiera sean sus objetivos de idioma, los estudiantes pueden desarrollar su confianza a la hora de hablar a través de nuestras premiadas soluciones de aprendizaje para K-12."
              },
              quote: {
                quote: "\"Quer\xEDamos que los estudiantes ELL aprendieran ingl\xE9s y tambi\xE9n ayudar a los hablantes de ingl\xE9s a aprender otro idioma para romper las barreras entre las familias\" -- ESL/Gerente de Idioma Extranjero, Cincinnati Public Schools",
                link: "https://www.rosettastone.es/empresas/recursos/content/cincinnati-public-schools-case-study/",
                resourcesLink: "/recursos/",
                market: ["ES"],
                vertical: ["recECBjZxFEWVVls8"]
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$j({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$j({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$i = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$i = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$5 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$i({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$i({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.es/educacion-superior/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$i({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$i({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "El aprendizaje de idiomas para la educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para la educación superior brinda a los estudiantes acceso en línea al instante para aprender inglés y otros idiomas internacionales. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$i({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$i({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$i({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/educacion-superior/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$i({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$h = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      completion_redirect: null,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$h = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-primaria-y-secundaria/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$6 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$h({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de recursos | Rosetta Stone",
          meta_description: "Recopilación de informes, infografías, videos, seminarios web y más sobre por qué la capacitación en idiomas es la opción correcta.",
          canonical_url: "https://www.rosettastone.es/empresas/recursos/",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deje que los estudiantes hablen por sí mismos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$h({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Formación en idiomas de negocios | Rosetta Stone",
          meta_description: "Las soluciones de formación de Rosetta Stone ayudan a los empleados a desarrollar competencias lingüísticas para el mundo de los negocios en inglés y en muchos otros idiomas de negocios en demanda actualmente. Consulte precios.",
          canonical_url: "https://www.rosettastone.es/empresas/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$h({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/empresas/solicitud-de-precios/",
          lang: "es"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserva hoy tiempo con un experto en aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Completa el formulario a continuación para programar un tiempo y analizar cómo podemos ayudarte."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta muy poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduce tu nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduce tu apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico*",
                required: true,
                required_error: "Introduce tu dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduce el nombre de tu empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduce el tamaño de tu empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título",
                required: true,
                required_error: "Introduce tu función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".es",
            dataQaLocation: "page"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de asesoramiento y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, motivar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de formación en idiomas ayudan a las empresas de asesoramiento profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en formación lingüística en toda la organización.",
          canonical_url: "https://www.rosettastone.es/empresas/solicitud-de-precios-completa/",
          lang: "es"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por tu interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "¡Consulta algunos recursos adicionales antes de la reunión!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Formación global en idiomas de negocios | Rosetta Stone",
          meta_description: "La formación global en idiomas de negocios de Rosetta Stone Catalyst ofrece a los empleados la posibilidad de aprender los principales idiomas utilizados en el mundo empresarial desde cualquier sitio. Consulte precios para empresas.",
          canonical_url: "https://www.rosettastone.es/empresas/soluciones/",
          lang: "es"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://resources.rosettastone.com/CDN/cn/Business/Language-Training-For-Global-Business.mp4"
              },
              title: {
                content: "Las nuevas competencias lingüísticas para el mundo empresarial hace que trabajar todos juntos sea posible.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Las brechas lingüísticas dejan muchas buenas ideas sin expresar o poco claras. A través de Rosetta Stone® Catalyst™, los empleados aprenden competencias lingüísticas que convertirán las señales confusas en una clara comunicación con sus compañeros de trabajo y clientes."
              },
              quote: {
                quote: "«Creo realmente que aporta un gran beneficio tanto para el alumno como para una empresa global como Amgen.» --Director de Rendimiento Comercial de Amgen",
                link: "https://www.rosettastone.es/empresas/recursos/content/amgen-client-spotlight/",
                resourcesLink: "/recursos/",
                market: ["ES"],
                vertical: ["recECBjZxFEWVVls8"]
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$6({
            strings: strings
          }),
          branded_quotes: branded_quotes$6({
            strings: strings
          }),
          verticals: verticals$h({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$h({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/a-cerca-de/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/prensa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/pf",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/requerimientos-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var es = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$6({
        strings: strings
      });
      page_config = enterprise_pages_config$6({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$6({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$6({
        strings: strings
      });
      page_config = education_primary_pages_config$6({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$6({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$5({
        strings: strings
      });
      page_config = education_secondary_pages_config$5({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$5({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$6({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$6,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$5 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://www.rosettastone.fr/magazine/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/l-anglais/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/le-japonais/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/l-allemand/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/le-francais/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/l-espagnol/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/l-italien/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }],
      language_options_other: [{
        url: "/l-arabe/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/le-chinois/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/le-neerlandais/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/l-anglais-americain/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/le-filipino/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/le-grec/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/l-hebreu/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/l-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/l-irlandais/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/le-coreen/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, // {
      //     url: "/buy-latin/",
      //     title: strings.locale_la_va_label_primary,
      //     small: strings.locale_la_va_label_secondary
      // },
      {
        url: "/le-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/le-polonais/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/le-portugais/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/le-russe/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/l-espagnol-d-amerique-latine/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/le-suedois/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/le-turc/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/le-vietnamien/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/fr/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/ecoles-primaires-secondaires/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/education-superieure/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/entreprises/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/ressources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$g = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/demande-de-prix/",
        new_window: false,
        size: "regular",
        text: "Demande de tarification",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Vous cherchez une liste de pas?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$g = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/ecoles-primaires-secondaires/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/education-superieure/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/entreprises/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$5 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$g({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Ressources",
                align: "left"
              },
              body: {
                content: "Laissez les apprenants parler pour eux-mêmes"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$g({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "L’apprentissage des langues de la maternelle au lycée | Rosetta Stone",
          meta_description: "Rosetta Stone training solutions help employees develop language skills in English for business and many in-demand business languages. Request pricing.  ",
          canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
          lang: "fr"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$g({
            strings: strings
          })
        }
      };

    case "demande-de-prix":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/demande-de-prix/",
          lang: "fr"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Vous y êtes presque!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Prénom",
                required: true,
                required_error: "Veuillez entrer votre prénom."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Nom",
                required: true,
                required_error: "Veuillez entrer votre nom."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Adresse e-mail",
                required: true,
                required_error: "Veuillez entrer votre adresse e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numéro de téléphone*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Société",
                required: true,
                required_error: "Veuillez entrer le nom de votre société."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Taille de la société",
                required: true,
                required_error: "Veuillez entrer la taille de votre société.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Moins",
                  label: "100 ou Moins"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Plus",
                  label: "50,001 ou Plus"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Titre",
                required: true,
                required_error: "Veuillez entrer votre fonction."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Demande de tarification"
            },
            labels: {
              form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
              form_privacy2: "ici.",
              form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
              form_updateagreement2: "ici",
              form_updateagreement3: "pour plus d'informations."
            },
            domain: ".fr",
            dataQaLocation: "page"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          })
        }
      };

    case "demande-de-prix-terminee":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix terminee | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/demande-de-prix-terminee/",
          lang: "fr"
        },
        content: {
          title: {
            align: "center",
            content: "Nous vous remercions pour votre intérêt !",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/ressources/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Ressources",
            theme: "blue_white"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programmes d’apprentissage des langues en ligne pour l´Education primaire et secondaire| Rosetta Stone",
          meta_description: "Les programmes d’apprentissage des langues en ligne de Rosetta Stone motivent les étudiants en anglais et les apprenants des langues étrangères en leur donnant la confiance nécessaire pour commencer à s’exprimer. Demandez nos tarifs",
          canonical_url: "https://www.rosettastone.fr/ecoles-primaires-secondaires/solutions/",
          lang: "fr"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/cn/Business/Language-Training-For-Global-Business.mp4",
                controls: true
              },
              title: {
                content: "Nos solutions pour l’enseignement primaire et secondaire prennent en charge tous les types d’apprenants des langues.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Les étudiants des langues ont chacun leurs raisons pour apprendre une nouvelle langue. L’un commence par la langue anglaise pour débutantet espère être capable de parler à ses ses camarades. L’autre s’inscrit dans un cours de langue donné en classe, espérant vivre un jour dans un autre pays. Quels que soient leurs objectifs en apprenant une langue, les élèves auront les moyens de converser en confiance avec nos solutions d’apprentissage pour l’enseignement primaire et secondaire."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$g({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$g({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/education-superieure/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/entreprises/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/mobile-apps/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/avis",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/a-propos/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/presse",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/lp/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/fr/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/configurations-recquises/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.fr/mentions-legales/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Terms_And_Conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/uk/pdfs/website-privacy-policy-uk.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/ressources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$f = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/demande-de-prix/",
        new_window: false,
        size: "regular",
        text: "Demande de tarification",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Vous cherchez une liste de pas?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$f = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/ecoles-primaires-secondaires/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education-superieure/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/entreprises/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var education_secondary_pages_config$4 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Ressources",
                align: "left"
              },
              body: {
                content: "Laissez les apprenants parler pour eux-mêmes"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$f({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$f({
            strings: strings
          })
        }
      };

    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$f({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$f({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Apprentissage des langues en ligne pourl'enseignemente supérieur | Rosetta Stone",
          meta_description: "Les solutions d’apprentissage des langues Rosetta Stone pour l’enseignement supérieur donnent aux étudiants un accès direct, en ligne, à l’apprentissage de l’anglais et des langues parlées dans le monde.",
          canonical_url: "https://www.rosettastone.fr/education-superieure/",
          lang: "fr"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$f({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$f({
            strings: strings
          })
        }
      };

    case "demande-de-prix":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/education-superieure/demande-de-prix/",
          lang: "fr"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Vous y êtes presque!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Prénom",
                required: true,
                required_error: "Veuillez entrer votre prénom."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Nom",
                required: true,
                required_error: "Veuillez entrer votre nom."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Adresse e-mail",
                required: true,
                required_error: "Veuillez entrer votre adresse e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numéro de téléphone*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Société",
                required: true,
                required_error: "Veuillez entrer le nom de votre société."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Taille de la société",
                required: true,
                required_error: "Veuillez entrer la taille de votre société.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Moins",
                  label: "100 ou Moins"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Plus",
                  label: "50,001 ou Plus"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Titre",
                required: true,
                required_error: "Veuillez entrer votre fonction."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Demande de tarification"
            },
            labels: {
              form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
              form_privacy2: "ici.",
              form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
              form_updateagreement2: "ici",
              form_updateagreement3: "pour plus d'informations."
            },
            domain: ".fr",
            dataQaLocation: "page"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$f({
            strings: strings
          })
        }
      };

    case "demande-de-prix-terminee":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix terminee | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/education-superieure/demande-de-prix-terminee/",
          lang: "fr"
        },
        content: {
          title: {
            align: "center",
            content: "Nous vous remercions pour votre intérêt !",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/ressources/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Ressources",
            theme: "blue_white"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$f({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: true,
      email_capture: false,
      market: "fr",
      domain: ".fr",
      vertical: "hed",
      page: "home",
      // Strings
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/education-superieure/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/entreprises/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/mobile-apps",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/avis",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/a-propos/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/presse",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/lp/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/fr/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/faq",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/configurations-recquises",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.fr/mentions-legales/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Terms_And_Conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/uk/pdfs/website-privacy-policy-uk.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/ressources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$e = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/demande-de-prix/",
        new_window: false,
        size: "regular",
        text: "Demande de tarification",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Vous cherchez une liste de pas?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$e = (function (_ref) {
  var strings = _ref.strings;
  return [{
    image: {
      alt: strings.verticals_education_primary,
      asset_static: verticals$q.educationPrimaryCirclePng
    },
    link: {
      destination: "/ecoles-primaires-secondaires/"
    },
    name: strings.verticals_education_primary,
    title: {
      content: strings.verticals_education_primary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_education_secondary,
      asset_static: verticals$q.educationSecondaryCirclePng
    },
    link: {
      destination: "/education-superieure/"
    },
    name: strings.verticals_education_secondary,
    title: {
      content: strings.verticals_education_secondary,
      type: "card-title"
    }
  }, {
    image: {
      alt: strings.verticals_enterprise,
      asset_static: verticals$q.enterpriseCirclePng
    },
    link: {
      destination: "/entreprises/"
    },
    name: strings.verticals_enterprise,
    title: {
      content: strings.verticals_enterprise,
      type: "card-title"
    }
  }];
});

var enterprise_pages_config$5 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$e({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "fr"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Ressources",
                align: "left"
              },
              body: {
                content: "Laissez les apprenants parler pour eux-mêmes"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$e({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Formation en langues  des affaires | Rosetta Stone",
          meta_description: "Les solutions de formation de Rosetta Stone aident les employés à acquérir des compétences linguistiques en anglais des affaires et bien d’autres langues étrangères.",
          canonical_url: "https://www.rosettastone.fr/entreprises/",
          lang: "fr"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$e({
            strings: strings
          })
        }
      };

    case "demande-de-prix":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/enterprises/demande-de-prix/",
          lang: "fr"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Réservez du temps avec un expert linguistique dès aujourd'hui."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Veuillez remplir le formulaire ci-dessous pour planifier un créneau afin de discuter de la façon dont nous pouvons vous aider."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Vous y êtes presque!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Prénom",
                required: true,
                required_error: "Veuillez entrer votre prénom."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Nom",
                required: true,
                required_error: "Veuillez entrer votre nom."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Adresse e-mail",
                required: true,
                required_error: "Veuillez entrer votre adresse e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numéro de téléphone*",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Société",
                required: true,
                required_error: "Veuillez entrer le nom de votre société."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Taille de la société",
                required: true,
                required_error: "Veuillez entrer la taille de votre société.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Moins",
                  label: "100 ou Moins"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Plus",
                  label: "50,001 ou Plus"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Titre",
                required: true,
                required_error: "Veuillez entrer votre fonction."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Demande de tarification"
            },
            labels: {
              form_privacy1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
              form_privacy2: "ici.",
              form_privacy3: "Je comprends que je peux choisir à tout moment de ne pas participer à de telles communications en cliquant sur le lien fourni dans la communication ou en contactant Rosetta Stone à l'adresse",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
              form_updateagreement2: "ici",
              form_updateagreement3: "pour plus d'informations."
            },
            domain: ".fr",
            dataQaLocation: "page"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          })
        }
      };

    case "demande-de-prix-terminee":
      return {
        page: page,
        helmet: {
          meta_title: "Demande de prix terminee | Rosetta Stone",
          meta_description: "Les services professionnels mondiaux et les cabinets de conseil se heurtent à des barrières linguistiques qui limitent leur capacité à servir les clients, à engager les employés et à développer leurs activités à l'échelle mondiale. Les solutions de formation linguistique aident les cabinets de conseil professionnels à maximiser les heures facturables par employé, ce qui prouve notre retour sur investissement significatif dans la formation linguistique dans toute l'organisation.",
          canonical_url: "https://www.rosettastone.fr/enterprises/demande-de-prix-terminee/",
          lang: "fr"
        },
        content: {
          title: {
            align: "center",
            content: "Nous vous remercions pour votre intérêt !",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Découvrez quelques ressources supplémentaires avant votre réunion!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/ressources/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Ressources",
            theme: "blue_white"
          },
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Formation globale linguistique pour les affaires | Rosetta Stone Catalyst",
          meta_description: "La formation globale linguistique pour les affaires de Rosetta Stone Catalyst offre des cours dans les principales langues des affaires que les employés peuvent apprendre où qu’ils se trouvent.  Demandez nos tarifs pour entreprises.",
          canonical_url: "https://www.rosettastone.fr/entreprises/solutions/",
          lang: "fr"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/cn/Business/Language-Training-For-Global-Business.mp4",
                controls: true
              },
              title: {
                content: "L’acquisition de nouvelles compétences linguistiques permet la collaboration au sein de l´entreprise.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "L’ignorance de la langue d’un collaborateur signifie souvent une communication imparfaite ou faussée des bonnes idées qu’il pourrait partager. Avec Rosetta Stone® Catalyst™, les employés acquièrent des compétences linguistiques qui transformeront les informations contradictoires en une communication claire entre vos collaborateurs et vos clients."
              },
              quoteAttribution: {
                align: "left",
                link: {
                  destination: "https://www.rosettastone.fr/entreprises/ressources/content/amgen-client-spotlight/",
                  theme: "black",
                  align: "left"
                },
                quote: "« Je pense réellement qu’il s’agit d’un atout majeur pour l’apprenant tout comme pour une multinationale comme Amgen. »",
                attribution: "Manager, Business Performance, Amgen, Thousand Oaks, Californie"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/demande-de-prix/",
                    new_window: false,
                    size: "regular",
                    text: "Demande de tarification",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$5({
            strings: strings
          }),
          branded_quotes: branded_quotes$5({
            strings: strings
          }),
          verticals: verticals$e({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$e({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: true,
      email_capture: false,
      market: "fr",
      domain: ".fr",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_pricing_label,
      sub_label: null,
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      footer_opt_in_text_before_button: strings.footer_cta_opt_in_text_before_button,
      footer_opt_in_learn_more_button_text: strings.footer_cta_opt_in_learn_more_button_text,
      footer_opt_in_text_after_button: strings.footer_cta_opt_in_text_after_button,
      footer_opt_in_learn_more_text_1: strings.footer_cta_opt_in_learn_more_text_1,
      footer_opt_in_learn_more_link_text_1: strings.footer_cta_opt_in_learn_more_link_text_1,
      footer_opt_in_learn_more_text_2: strings.footer_cta_opt_in_learn_more_text_2,
      footer_opt_in_learn_more_text_3: strings.footer_cta_opt_in_learn_more_text_3,
      footer_opt_in_learn_more_privacyemail: strings.footer_cta_opt_in_learn_more_privacyemail,
      footer_opt_in_learn_more_privacyUrl: strings.footer_cta_opt_in_learn_more_privacyUrl,
      footer_how_hear_blog: strings.footer_cta_how_hear_blog,
      footer_how_hear_email: strings.footer_cta_how_hear_email,
      footer_how_hear_event: strings.footer_cta_how_hear_event,
      footer_how_hear_online: strings.footer_cta_how_hear_online,
      footer_how_hear_referral: strings.footer_cta_how_hear_referral,
      footer_how_hear_title: strings.footer_cta_how_hear_title,
      footer_how_hear_search: strings.footer_cta_how_hear_search,
      footer_how_hear_social: strings.footer_cta_how_hear_social,
      footer_how_hear_webinar: strings.footer_cta_how_hear_webinar,
      footer_how_hear_other: strings.footer_cta_how_hear_other,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/ecoles-primaires-secondaires/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/education-superieure/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/entreprises/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/mobile-apps/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/avis",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.fr/lp/a-propos/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/presse",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/lp/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/fr/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.fr/configurations-recquises/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.fr/mentions-legales/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/fr/pdfs/France_Terms_And_Conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/uk/pdfs/website-privacy-policy-uk.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var fr = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$5({
        strings: strings
      });
      page_config = enterprise_pages_config$5({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$5({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$5({
        strings: strings
      });
      page_config = education_primary_pages_config$5({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$5({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$4({
        strings: strings
      });
      page_config = education_secondary_pages_config$4({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$4({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$5({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$5,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$4 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: true,
      destination: "/contatti/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/inglese/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/il-francese/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/arabo/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/il-tedesco/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/lo-spagnolo/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }],
      language_options_other: [{
        url: "/il-cinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/il-coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/lo-spagnolo-america-latina/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/il-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/il-greco/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/ebraico/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/lhindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/lolandese/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/inglese-americano/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/irlandese/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/Giapponese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/il-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/il-polacco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/il-portoghese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/il-russo/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/lo-svedese/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/il-turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/il-vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      for_young_learners_label: strings.nav_primary_vertical_for_young_learners_label,
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/it-IT/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/istruzione-primaria-e-secondaria/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/istruzione-superiore/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/aziende/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$d = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$d = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$4 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$d({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Risorse",
                align: "left"
              },
              body: {
                content: "Lascia che gli studenti parlino da soli"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$d({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "L’apprendimento delle lingue  dalla scuola materna alla scuola secondaria superiore | Rosetta Stone",
          meta_description: "Le soluzioni di apprendimento linguistico di Rosetta Stone per la scuola primaria e secondaria  vanno di pari passo e si integrano con l'insegnamento in classe e sono disponibili in qualsiasi momento per gli studenti che desiderano apprendere  o migliorare la propria conoscenza dell'inglese e di altre lingue straniere.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$d({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programmi di apprendimento linguistico online per l´istruzione primaria e secondaria | Rosetta Stone",
          meta_description: "I programmi di apprendimento linguistico on line di Rosetta Stone motivano gli studenti d’inglese  e delle altre lingue straniere, dando loro la fiducia e la sicurezza necessarie per esprimersi. Richiedi le nostre tariffe.",
          canonical_url: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/soluzioni/",
          lang: "it"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              image: {
                asset_fluid: null
              },
              title: {
                content: "Le nostre soluzioni per l’insegnamento primario e secondario supportano tutti gli studenti di lingue.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Ogni studente di lingue ha le proprie motivazioni per decidere di apprendere una nuova lingua. Vi è quello che inizia con la lingua inglese per principianti e spera di poter parlare con i suoi compagni di classe. Un altro s’iscrive ad un corso di lingua impartito in classe, sperando di vivere un giorno in un altro paese. Qualunque siano i loro obiettivi di apprendimento di una lingua, gli studenti avranno i mezzi per esprimersi con fiducia e sicurezza grazie alle nostre soluzioni di apprendimento per l'istruzione primaria e secondaria."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$d({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$d({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$c = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$c = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$c({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$c({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$c({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$c({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Apprendimento linguistico online per l'istruzione superiore | Rosetta Stone",
          meta_description: "Le soluzioni d’apprendimento linguistico Rosetta Stone per la f’istruzione superiore forniscono agli studenti accesso diretto online all’apprendimento dell’inglese e delle lingue parlate nel mondo. ",
          canonical_url: "https://www.rosettastone.it/istruzione-superiore/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$c({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$c({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$c({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$c({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/risorse/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluzioni/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$b = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/richiesta-prezzi/",
        new_window: false,
        size: "regular",
        text: "Richiedi prezzi",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Pronto per il prossimo passo?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$b = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$4 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "it"
        },
        content: {
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Formazione linguistica per le imprese | Rosetta Stone",
          meta_description: "Le soluzioni di formazione Rosetta Stone aiutano i dipendenti ad acquisire competenze linguistiche in inglese per le imprese ed in molte altre lingue straniere. Richiedete le nostre tariffe.",
          canonical_url: "https://www.rosettastone.it/aziende/",
          lang: "it"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi/",
          lang: "it"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Prenota subito un incontro con un esperto di apprendimento delle lingue."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Compila il modulo in basso per prenotare un incontro e capire come possiamo aiutarti."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Ci sei quasi!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Immetti il tuo nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Cognome",
                required: true,
                required_error: "Immetti il tuo cognome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Indirizzo e-mail",
                required: true,
                required_error: "Immetti il tuo indirizzo e-mail.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Numero di telefono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Azienda",
                required: true,
                required_error: "Immetti il nome della tua azienda."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Dimensioni azienda",
                required: true,
                required_error: "Immetti le dimensioni della tua azienda.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Meno",
                  label: "100 o Meno"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Più",
                  label: "50,001 o Più"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Qualifica",
                required: true,
                required_error: "Immetti il tuo ruolo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Richiedi prezzi"
            },
            labels: {
              form_privacy1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
              form_privacy2: "qui.",
              form_privacy3: "Comprendo che posso scegliere di non ricevere tali comunicazioni in qualsiasi momento facendo clic sul collegamento fornito nella comunicazione o contattando Rosetta Stone all'indirizzo",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca ",
              form_updateagreement2: "qui",
              form_updateagreement3: "per maggiori informazioni."
            },
            domain: ".it",
            dataQaLocation: "page"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          })
        }
      };

    case "richiesta-prezzi-completata":
      return {
        page: page,
        helmet: {
          meta_title: "Richiesta prezzi completa | Rosetta Stone",
          meta_description: "Le società di consulenza e servizi professionali globali devono affrontare barriere linguistiche che limitano la loro capacità di servire i clienti, coinvolgere i dipendenti e far crescere la loro attività a livello globale. Le soluzioni per la formazione linguistica aiutano le società di consulenza professionale a ottimizzare le ore fatturabili per dipendente, dimostrando l'importante ROI della formazione linguistica in tutta l'organizzazione.",
          canonical_url: "https://www.rosettastone.it/aziende/richiesta-prezzi-completata/",
          lang: "it"
        },
        content: {
          title: {
            align: "center",
            content: "Ti ringraziamo per l'interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulta alcune risorse aggiuntive prima dell'incontro.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/risorse/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Risorse",
            theme: "blue_white"
          },
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Formazione linguistica per le imprese  mondiali | Rosetta Stone Catalyst",
          meta_description: "La Formazione linguistica per le imprese mondiali con Rosetta Stone Catalyst offre corsi nelle principali lingue commerciali che i dipendenti possono apprendere ovunque si trovino. Richiedi le nostre tariffe per le aziende.",
          canonical_url: "https://www.rosettastone.it/aziende/soluzioni/",
          lang: "it"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              direction: "image-right",
              image: {
                asset_fluid: null
              },
              title: {
                content: "L’acquisizione di nuove competenze linguistiche consente la collaborazione all’interno dell’impresa.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "La non conoscenza delle lingue spesso comporta una comunicazione imperfetta o distorta di buone idee che potrebbero essere condivise. Con Rosetta Stone® Catalyst ™, i dipendenti acquisiscono competenze linguistiche che trasformano informazioni e messaggi contrastanti in comunicazioni chiare con colleghi, dipendenti e clienti."
              },
              quote: {
                quote: "« Penso davvero che questo sia un vantaggio importante per lo studente  e per una multinazionale come Amgen. » – Dirigente, Business Performance, Amgen",
                link: "https://www.rosettastone.it/aziende/risorse/content/amgen-client-spotlight/",
                resourcesLink: "/resources/",
                market: ["IT"],
                vertical: ["recECBjZxFEWVVls8"]
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/richiesta-prezzi/",
                    new_window: false,
                    size: "regular",
                    text: "Richiedi prezzi",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }],
          awards: awards$4({
            strings: strings
          }),
          branded_quotes: branded_quotes$4({
            strings: strings
          }),
          verticals: verticals$b({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$b({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/lp/l1/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-primaria-e-secondaria/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/istruzione-superiore/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/aziende/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/mobili/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/recensioni/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.it/chi-siamo/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/stampa/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/contatti/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/it-IT/work",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.it/requisiti-di-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      // TODO: Make Cookies Instead of Antipircacy
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.it/accordi/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var it = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$4({
        strings: strings
      });
      page_config = enterprise_pages_config$4({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$4({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$4({
        strings: strings
      });
      page_config = education_primary_pages_config$4({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$4({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$3({
        strings: strings
      });
      page_config = education_secondary_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$3({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$4({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$4,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$3 = {
  gtm_id: "GTM-TLH67WS"
};

var nav_primary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18005115689",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/comprar-ingles/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/comprar-italiano/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/comprar-frances/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/comprar-aleman/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/comprar-espanol-espana/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }],
      language_options_other: [{
        url: "/comprar-arabe/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/comprar-chino/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/comprar-holandes/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/comprar-ingles-britanico/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/comprar-filipino/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/comprar-griego/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/comprar-hebreo/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/comprar-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/comprar-irlandes/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/comprar-japones/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/comprar-latin/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/comprar-coreano/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/comprar-persa/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/comprar-polaco/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/comprar-portugues/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/comprar-ruso/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/comprar-espanol/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/comprar-sueco/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/comprar-turco/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/comprar-vietnamita/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      homeschool_label: strings.nav_primary_vertical_education_homeschool_label,
      homeschool_destination: "https://www.rosettastone.com/homeschool/",
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: true,
      destination: "https://www.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/es",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacion-basica/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/estudiantes/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/estudiantes/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresa/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var email_collection_bar$8 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "EH_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "REGÍSTRATE",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Correo electrónico",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Obtén noticias y ofertas de Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Gracias por registrarte.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "El correo electrónico parece que no es válido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Regístrate para mantenerte informado.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Al registrarte, estás de acuerdo con los",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "términos y condiciones",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
          meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
          canonical_url: "https://espanol.rosettastone.com/",
          lang: "es"
        },
        content: {
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$8({
            strings: strings
          })
        }
      };

    case "locaciones":
      return {
        page: page,
        helmet: {
          meta_title: "Locaciones Retail | Rosetta Stone",
          meta_description: "Descubre locaciones retail donde puedes comprar Rosetta Stone. ¡Vísitanos!",
          canonical_url: "https://espanol.rosettastone.com/locaciones/",
          trustpilot: true,
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              title: {
                align: "left",
                content: "Estas Tiendas Retail de Rosetta Stone Pueden Ayudarte a Hablar Otro Idioma",
                type: "page-title",
                heading: "h1"
              },
              sub_title: {
                type: "page-sub-title",
                heading: "h2",
                align: "center",
                content: "Aprende a pronunciar como un local con nuestro aprendizaje de idiomas que siempre va contigo, disponible en estos sitios retail de Rosetta Stone."
              },
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              dangerous: true,
              padding: "50px 0",
              direction: "image-right",
              body: {
                align: "left",
                dangerous: true,
                content: "Visita una de nuestras locaciones retail y descubre porque Rosetta Stone lleva más de 25 años en experiencia ayudando a millones de estudiantes de idiomas a hablar otro idioma. Con más de 24 idiomas para escoger, nuestras lecciones son interactivas, dinámicas y nuestra <a href='https://espanol.rosettastone.com/movil/' target='_blank'>aplicación móvil</a> galardonada te ayudará a sobresalir en conversaciones reales"
              },
              dataQa: "QA"
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$8({
            strings: strings
          })
        }
      };

    case "movil":
      return {
        page: page,
        helmet: {
          meta_title: "Aplicación Móvil del Programa de Rosetta Stone®",
          meta_description: "Aprende un nuevo idioma con la aplicación móvil en iOS y Android de Rosetta Stone®. Todo la metodología y las funciones al alcance de tu celular.",
          canonical_url: "https://espanol.rosettastone.es/movil/",
          lang: "es"
        },
        content: {
          topImageTextSections: {
            panels: [{
              dataQa: "1",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-right",
              maxWidth: 60,
              padding: "150px 0",
              body: {
                dangerously: true,
                content: strings.mobile_apps_top_section_one_body_content,
                align: "left"
              },
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_one_title_content,
                heading: "h1",
                type: "section-title",
                theme: "black"
              },
              image: {
                asset_static: images.mobileAppsImage_1Jpg
              },
              custom: {
                cta: {
                  destination: "https://espanol.rosettastone.com/freetrial/",
                  new_window: true,
                  size: "regular",
                  text: strings.mobile_apps_top_section_one_custom_cta_text,
                  theme: "blue_white"
                },
                awards: [{
                  asset_static: awards$9.awardPcMagPng,
                  destination: "https://www.pcmag.com/roundup/261786/the-best-language-learning-software",
                  new_window: true,
                  width: "250px",
                  align_items: "flex-start"
                }]
              }
            }, {
              dataQa: "2",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-left",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_two_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_two_body_content,
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_2Jpg
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_two_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_three
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_four,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_four
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_five,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_five
              }, {
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_six
              }]
            }, {
              dataQa: "3",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-right",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_three_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_three_body_content,
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_3Png
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_three_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_three
              }]
            }]
          },
          mobileOsLogos: {
            layout: "list",
            title: {
              align: "center",
              theme: "black",
              type: "section-title",
              content: strings.mobile_apps_os_logos_title_content,
              heading: "h2"
            },
            subtitle: {
              align: "center",
              theme: "black",
              type: "section-sub-title",
              content: strings.mobile_apps_os_logos_subtitle_content
            },
            padding: "25px 0 100px",
            panels: [{
              image: {
                alt: "",
                asset_static: logos.logoIosSvg,
                destination: "https://rosettastone.onelink.me/zwaO/f670c3a0",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoAppleWatchSvg
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoAndroidSvg,
                destination: "https://play.google.com/store/apps/details?id=air.com.rosettastone.mobile.CoursePlayer&hl=en_US&gl=US",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoSamsungSvg
              }
            }]
          },
          bottomImageTextSection: {
            panels: [{
              dataQa: "4",
              layout: "list",
              justifyContent: "space-between",
              alignItems: {
                mobile: "center"
              },
              direction: "image-left",
              maxWidth: 60,
              title: {
                align: "left",
                content: strings.mobile_apps_bottom_section_one_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_bottom_section_one_body_content,
                align: "left"
              },
              image: {
                asset_static: images.homepageWomanOnBalconyMobileJpg
              }
            }]
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$8({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "la",
      domain: ".espanol",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/comprar-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "/comprar-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/comprar-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/comprar-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/comprar-espanol-espana/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/comprar-japones/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_japanese_label
        }, {
          visible: true,
          destination: "/comprar-chino/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_chinese_label
        }, {
          visible: true,
          destination: "/regalo/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gift_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/idiomas/aprender-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/idiomas/curso-de-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/idiomas/aprender-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/idiomas/aprender-portugues/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_portuguese_label
        }, {
          visible: true,
          destination: "/idiomas/idioma-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/pruebaloya/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/movil/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/opiniones-clientes/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonios/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/locaciones/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/descuento-militar/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_military_discount_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/es/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/pf/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contacto/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar$7 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "EH_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "REGÍSTRATE",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Correo electrónico",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Obtén noticias y ofertas de Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Gracias por registrarte.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "El correo electrónico parece que no es válido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Regístrate para mantenerte informado.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Al registrarte, estás de acuerdo con los",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "términos y condiciones",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_seo_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          trustpilot: true,
          lang: "es"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://espanol.rosettastone.com/pruebagratis/?ocid=seo-stickyes",
              text: "PRUEBA NUESTRO DEMO GRATIS"
            }
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$7({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_seo_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "la",
      domain: ".espanol",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/comprar-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "/comprar-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/comprar-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/comprar-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/comprar-espanol-espana/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/comprar-japones/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_japanese_label
        }, {
          visible: true,
          destination: "/comprar-chino/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_chinese_label
        }, {
          visible: true,
          destination: "/regalo/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gift_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/idiomas/aprender-ingles/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/idiomas/curso-de-frances/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/idiomas/aprender-italiano/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/idiomas/aprender-portugues/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_portuguese_label
        }, {
          visible: true,
          destination: "/idiomas/idioma-aleman/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/pruebaloya/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/movil/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/opiniones-clientes/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonios/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/locaciones/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/descuento-militar/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_military_discount_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/es/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/pf/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contacto/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var lead_generation_bar$a = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$a = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresa/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizaje de Idiomas en línea para K-12 | Rosetta Stone",
          meta_description: "Las soluciones para el aprendizaje de idiomas K-12 de Rosetta Stone se fusionan con la instrucción del profesor en el salón de clase y el acceso en cualquier momento en que los estudiantes deseen aprender o mejorar su conocimiento del idioma inglés o su competencia lingüística a nivel mundial.  ",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/",
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                content: "Aprendizaje de idiomas en línea",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Hablar un idioma nuevo es el objetivo y los profesores saben que se requiere bastante práctica. Rosetta Stone tiene un enfoque único que puede lograr que sus estudiantes hablen inglés o un idioma del mundo desde el principio, de manera que se sientan confiados y listos para expresarse tanto dentro como fuera del salón de clase."
              },
              image: {
                asset_fluid: null
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Desde la primera lección, cada palabra que los estudiantes escuchan, dicen y leen es en su idioma nuevo. Eso es inmersión, el enfoque más natural para el aprendizaje de idiomas: ir de las palabras a las frases a las oraciones sin miedo, de manera que cuando llegue el momento de hacer preguntas y ofrecer respuestas, los profesores tengan la confianza de saber que sus estudiantes van a estar listos."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Proporciona a los estudiantes más maneras de aprender.",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/customer-spotlight-phoenix-union-high-school-district/",
                align: "left"
              },
              quote: "«A los niños los impulsa la tecnología, de manera que a ellos les encanta usar el programa. Esa ventaja nos permite llegar a aquellos estudiantes a los que no podríamos llegar de otra manera».",
              attribution: "Enlace de Idiomas del Mundo, Escuelas de la Ciudad Pueblo"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Diga adiós al miedo a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Hablar un idioma nuevo puede sonar extraño al principio. El miedo a cometer errores en el salón de clase puede incluso inhibir totalmente a los estudiantes al momento de hablar. Nuestro motor de reconocimiento del habla TruAccent™ guía la pronunciación, sin ningún tipo de juzgamiento, de manera que el aprendizaje de idiomas se acelera a medida que crece la confianza al hablar."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/equity-for-english-learners-snapshot/",
                align: "left"
              },
              quote: "«El programa de Rosetta Stone aumenta la confianza en la expresión oral de los estudiantes proporcionándoles oportunidades para practicar, escuchando su propia pronunciación y reduciendo su filtro afectivo».",
              attribution: "Administrador de Servicios Educacionales, Departamento de Inglés, Distrito Escolar Unificado Corona-Norco."
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Tutoría en vivo permite mantener una conversación real.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Los profesores desean que sus estudiantes se sientan cómodos al hablar su idioma nuevo, pero es un gran salto ir del aprendizaje de idiomas al mundo real. Nuestras sesiones de tutoría proporcionan a los estudiantes la oportunidad de practicar con hablantes nativos en su propio nivel de conocimiento. La tutoría en nuestro espacio seguro es otra manera inteligente de aprender."
              },
              image: {
                asset_fluid: null
              },
              quote: "«La respuesta de los estudiantes al programa ha sido abrumadoramente positiva. Nuestro salón de clase participativo es más como una familia . . .»",
              attribution: "Coordinador de Currículo y Profesor de Español, Colegio Bethel",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content//implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Aprendizaje de idiomas que los estudiantes pueden llevar a todo lado.",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Los horarios de clase son aún la norma para los estudiantes, pero las escuelas están también facilitando la enseñanza fuera del salón de clase. Nuestra aplicación móvil permite a sus estudiantes tener acceso a lecciones y actividades en el momento adecuado, dándoles libertad para que ellos la conviertan en una experiencia de aprendizaje."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/case-study-guthrie-virtual-school/",
                align: "left"
              },
              quote: "«“El método Rosetta Stone es la herramienta de aprendizaje de idiomas más potente del mercado. Tras analizar la oferta disponible, consideramos que dicha metodología es pertinente y utiliza la tecnología en la educación de manera eficaz. Es un método comprobado, que funciona; la mejor opción a nuestro alcance.”»",
              attribution: "Dra. Alexandra Bogarín, Secretaria de Educación, Cultura y Deporte"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Idiomas inglés y del mundo que se ajustan a los objetivos del estudiante.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver a los estudiantes con un idioma acelera el aprendizaje.",
                learner_feature_2_title: "Inmersión lingüística a ritmo propio",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Los estudiantes se divierten a la vez que refuerzan las lecciones aprendidas. ",
                learner_feature_3_title: "Juegos y Actividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "El asistente de pronunciación que cada estudiante puede utilizar.",
                learner_feature_4_title: "Reconocimiento de Voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "En un espacio en línea, seguro, en cada nivel de aprendizaje del estudiante.",
                learner_feature_5_title: "Tutoría en Vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Pone el acceso al aprendizaje en la mano del estudiante.",
                learner_feature_6_title: "Aplicación móvil",
                learner_feature_title: "Online or off, our award-winning app speaks for itself"
              },
              data: {}
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de Aprendizaje de Idiomas K-12 en línea | Rosetta Stone",
          meta_description: "Los programas de aprendizaje de idiomas de Rosetta Stone motivan a los estudiantes del idioma inglés y de los idiomas del mundo a hablar con confianza y seguridad. Pregunte sobre nuestros precios.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/soluciones/",
          lang: "es-419"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594888236"
              },
              title: {
                content: "Nuestras soluciones de aprendizaje K-12 brindan apoyo a cualquier estudiante de idiomas.",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Los estudiantes tienen su propia motivación para aprender un idioma nuevo. Unos toman cursos de aprendizaje del idioma inglés para principiantes y esperan poder hablar con sus compañeros. Otros estudian en una clase de idioma extranjero esperando algún día vivir en una cultura diferente. Cualesquiera que sean sus objetivos de idiomas, los estudiantes pueden desarrollar confianza y seguridad al hablar con nuestras soluciones galardonadas de aprendizaje K-12."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Los estudiantes que hablan poco o nada de inglés pueden titubear al momento de entrar a clases. Ese sentimiento de aislamiento puede durar hasta que aprendan a hablar inglés confiadamente. Inglés Educativo de Rosetta Stone® incluye recursos completos para los estudiantes del idioma inglés, sus profesores y sus familias. El programa va en línea con los programas de equidad que apuntan a dar a cada estudiante igual acceso a las herramientas de aprendizaje para lograr el éxito académico."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Incluya estudiantes del idioma inglés en su programa de equidad.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              },
              quote: "Leer la instantánea",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/la-influencia-del-ingles-en-los-empleados/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "El interés puede empezar con una película, un libro, un amigo por Internet o a la vuelta de la esquina. No importa la manera cómo los estudiantes se interesen a nivel mundial, el siguiente paso más importante es que ellos aprendan un idioma del mundo. Escoger un programa escolar Rosetta Stone Educativo ayuda a los estudiantes a desarrollar la capacitación lingüística que necesitan para llegar tan lejos como sus intereses globales los lleve."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Conecte a los estudiantes con los idiomas y las culturas.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              },
              quote: "Ver hoja de datos",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/empresa-5razones/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "Cada día en el salón de clase cuenta cuando los estudiantes desean aprender. Para aquellos estudiantes que también están aprendiendo inglés, es muy importante que continúen por el buen camino. Inglés Educativo de Rosetta Stone® hace posible que las familias se involucren en el aprendizaje del idioma inglés del estudiante. El apoyo total que proporciona ayuda a los estudiantes a conectarse más rápidamente con los profesores y compañeros y a lograr un mejor éxito académico."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Convierta el aprendizaje del idioma inglés en un esfuerzo familiar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Activa el aprendizaje con lecciones y actividades en el idioma nuevo, a un ritmo propio, que envuelven a los estudiantes a medida que ellos aprenden a hablar, leer, escribir, escuchar y pensar de una manera totalmente diferente. ",
                feature_1_title: "Inmersión Dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Una realimentación inmediata de la pronunciación sirve de guía a los estudiantes para que hablen el idioma nuevo de una manera correcta, haciendo que el aprendizaje se convierta en una experiencia gratificante y construya la base para lograr una mayor confianza al hablar. ",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Ejercicios y conversaciones estructuradas con hablantes nativos se ajustan al nivel actual de conocimiento del idioma de los estudiantes y los ayuda a sentirse cómodos al hablar su idioma nuevo. ",
                feature_3_title: "Tutoría en Vivo. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra el idioma inglés y los idiomas del mundo en un programa de idiomas para desarrollar y perfeccionar la capacidad lingüística de los estudiantes en cada nivel de aprendizaje, desde el nivel de principiante hasta el nivel avanzado. ",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Inglés Educativo incluye recursos semanales para ayudar a las familias a desarrollar una capacidad lingüística en inglés de manera conjunta y seminarios web mensuales en español, resaltando el apoyo familiar a los servicios del idioma inglés.  ",
                feature_5_title: "Recursos para conexión familiar. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Las Guías de Enseñanza fuera de línea, los Libros de trabajo y las Guías de actividades en el salón de clase proporcionan a los profesores los recursos que apoyan la instrucción en el salón de clase y complementan las lecciones en línea.  ",
                feature_6_title: "Dinámica del salón de clase. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Inglés Educativo incluye una prueba de ubicación y progreso para los grados 6-12 que permite a los profesores determinar el punto inicial de aprendizaje del idioma inglés para cada estudiante. ",
                feature_7_title: "Prueba. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Los estudiantes se involucran inmediatamente con un contenido dinámico que se adapta al ritmo y progreso de cada estudiante en un espacio interactivo que se enfoca en el aprendizaje de los estudiantes a expresarse oralmente. ",
                feature_8_title: "Contenido fundacional y avanzado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Refuerzo de vocabulario, gramática y pronunciación de una manera divertida y participativa que desarrolla la capacidad de lectura, audición y expresión oral de los estudiantes. ",
                feature_9_title: "Juegos y actividades.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Las actividades para cada nivel del estudiante incluyen Leer en Voz Alta con realimentación instantánea de la pronunciación, escritura para propósitos específicos y comprensión auditiva y de lectura.",
                feature_10_title: "Lectura y escritura.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permite a los estudiantes utilizar teléfonos inteligentes y tabletas, tanto dentro como fuera del salón de clase, para tener acceso a lecciones y actividades que aumentan la retención de habilidades y el vocabulario.",
                feature_11_title: "Aplicaciones móviles. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Revisión instantánea del rendimiento individual, grupal y a nivel del salón de clase con seguimiento del progreso y conocimiento que permite a los profesores y a los administradores informar los resultados obtenidos por los estudiantes de una manera fácil.",
                feature_12_title: "Herramientas de informe.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "El manejo simplificado de licencias permite a los profesores y administradores a reasignar estudiantes rápidamente a fin de asegurar la utilización total del número de licencias y apoyar el programa de retorno de la inversión (ROI).",
                feature_13_title: "Licencias transferibles. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos efectivos y asiste en la planificación, despliegue y promoción del programa en escuelas y distritos escolares.",
                feature_14_title: "Apoyo durante la implementación. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Existen niveles de capacitación disponibles para el administrador y los profesores que contribuyen al lanzamiento exitoso del programa, el mismo que se fusionará de manera efectiva con la instrucción del profesor en el salón de clase.",
                feature_15_title: "Servicios de capacitación. ",
                feature_section_title: "Cada recurso que necesita está a su alcance"
              }
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$a({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-basica/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$a({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$9 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$9 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresa/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
          lang: "es"
        },
        content: {
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "AAprendizaje de Idiomas en línea para educación superior | Rosetta Stone",
          meta_description: "Las soluciones de aprendizaje de idiomas de Rosetta Stone para educación superior proporcionan a los estudiantes acceso instantáneo en línea para que aprendan inglés y los idiomas del mundo. Pregunte sobre nuestros precios. ",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/",
          lang: "es"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              direction: "image-right",
              video: {
                controls: true,
                currentVideoUrl: "https://vimeo.com/594871446"
              },
              title: {
                content: "Saber idiomas empresariales permite a los empleados expresarse eficazmente",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo.Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              product_sample_panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              content: [{
                body: {
                  dataQa: "2",
                  content: "Los empleados aprenden con mayor eficacia cuando pueden escuchar, hablar, leer y escribir en su nuevo idioma. Eso es lo que nuestro método Dynamic Immersion® logra: desarrolla confianza en el idioma desde la primera lección."
                },
                data_qa: "2",
                direction: "image-left",
                title: {
                  dataQa: "2",
                  content: "Aprenda de manera natural",
                  type: "section-title",
                  heading: "h2",
                  theme: "black",
                  align: "left"
                }
              }],
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/hitachi-data-systems-caso-de-exito",
                align: "left"
              },
              quote: "“Rosetta Stone nos ayuda a romper barreras y a lograr la participación del empleado.“",
              attribution: "VP de Aprendizaje y Colaboración, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Empiece a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "El miedo de los estudiantes a cometer errores los puede inhibir al hablar un idioma nuevo. Nuestro motor del habla TruAccent™ permite a los empleados mejorar su pronunciación de manera que se sientan seguros y confiados cuando tengan que hablar de negocios."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/catalyst-overview/",
                align: "left"
              },
              quote: "“Los beneficios clave del aprendizaje de idiomas de Rosetta Stone son la posibilidad de aprender a cualquier hora, en cualquier lugar, a su propio ritmo. . .”",
              attribution: "Director, HR CoC Global Learning, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Que le escuchen",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Pasar de las lecciones a hablar con los compañeros de trabajo y los clientes es un gran salto. Las sesiones de tutoría con hablantes nativos proporcionan práctica de conversación de manera que los estudiantes hablan su nuevo idioma de una manera natural."
              },
              image: {
                asset_fluid: null
              },
              quote: "“Al implementar un programa empresarial global, hemos visto un ahorro significativo en los costos . . .”",
              attribution: "Asesor Senior de Talento Humano, Kimberly-Clark Corporation",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Acceso móvil",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Es difícil encontrar tiempo para sentarse en una clase y aprender un idioma. Nuestras aplicaciones móviles proporcionan a los estudiantes acceso a lecciones y actividades en el momento adecuado. Así, cualquier momento puede convertirse en una gran experiencia de aprendizaje."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/tripadvisor-com-caso-de-exito/",
                align: "left"
              },
              quote: "“¡ME ENCANTA! Rosetta Stone me permite aprender un idioma nuevo a mi propio ritmo de aprendizaje después de las horas de trabajo!”",
              attribution: "Empleado de TripAdvisor, Singapur"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Hay un idioma que se ajusta a los objetivos de cada empleado.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodearse del idioma es la manera más rápida de aprender.",
                learner_feature_2_title: "Inmersión lingüística a su propio ritmo",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Lecciones que siguen el ritmo de los estudiantes y no al revés.",
                learner_feature_3_title: "Contenido que Atrae",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Los empleados pueden revisar su pronunciación en cualquier momento.",
                learner_feature_4_title: "Reconocimiento de Habla TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Mantener una conversación con hablantes nativos es, definitivamente, una señal de éxito. ",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "El aprendizaje y la practica van tomados de la mano. ",
                learner_feature_6_title: "Aplicación Móvil",
                learner_feature_title: "Características del aprendizaje empresarial"
              },
              data: {}
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$9({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/educacion-superior/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$9({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/soluciones/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      title: strings.nav_secondary_enterprise_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label,
      title: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$8 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitud-de-precios/",
        new_window: false,
        size: "regular",
        text: "Solicitar de precios",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$8 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacion-basica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/educacion-superior/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$3 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "es-419"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "",
                align: "left"
              },
              body: {
                content: ""
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Capacitación Lingüística Empresarial | Rosetta Stone",
          meta_description: "Las soluciones de capacitación lingüística de Rosetta Stone ayudan a los empleados a desarrollar una competencia lingüística empresarial en el idioma inglés y en muchos otros idiomas de alta demanda. Solicite precios.",
          canonical_url: "https://espanol.rosettastone.com/empresa/",
          lang: "es-419"
        },
        content: {
          sections: [{
            panels: [{
              layout: "list",
              direction: "image-right",
              video: {
                currentVideoUrl: "https://vimeo.com/594871446",
                controls: true
              },
              title: {
                content: "Saber idiomas empresariales permite a los empleados expresarse eficazmente",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Aprender nuevos idiomas empresariales requiere práctica. Rosetta Stone logra que los empleados hablen y perfeccionen su pronunciación rápidamente de manera que estén listos para comunicarse y hablar sobre su negocio en poco tiempo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aprenda de manera natural",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Los empleados aprenden con mayor eficacia cuando pueden escuchar, hablar, leer y escribir en su nuevo idioma. Eso es lo que nuestro método Dynamic Immersion® logra: desarrolla confianza en el idioma desde la primera lección."
              },
              data_qa: "2",
              direction: "image-left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/hitachi-data-systems-caso-de-exito",
                align: "left"
              },
              quote: "“Rosetta Stone nos ayuda a romper barreras y a lograr la participación del empleado.“",
              attribution: "VP de Aprendizaje y Colaboración, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Empiece a hablar",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "El miedo de los estudiantes a cometer errores los puede inhibir al hablar un idioma nuevo. Nuestro motor del habla TruAccent™ permite a los empleados mejorar su pronunciación de manera que se sientan seguros y confiados cuando tengan que hablar de negocios."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/catalyst-overview/",
                align: "left"
              },
              quote: "“Los beneficios clave del aprendizaje de idiomas de Rosetta Stone son la posibilidad de aprender a cualquier hora, en cualquier lugar, a su propio ritmo. . .”",
              attribution: "Director, HR CoC Global Learning, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Que le escuchen",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Pasar de las lecciones a hablar con los compañeros de trabajo y los clientes es un gran salto. Las sesiones de tutoría con hablantes nativos proporcionan práctica de conversación de manera que los estudiantes hablan su nuevo idioma de una manera natural."
              },
              image: {
                asset_fluid: null
              },
              quote: "“Al implementar un programa empresarial global, hemos visto un ahorro significativo en los costos . . .”",
              attribution: "Asesor Senior de Talento Humano, Kimberly-Clark Corporation",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/implementing-online-language-learning/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Acceso móvil",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Es difícil encontrar tiempo para sentarse en una clase y aprender un idioma. Nuestras aplicaciones móviles proporcionan a los estudiantes acceso a lecciones y actividades en el momento adecuado. Así, cualquier momento puede convertirse en una gran experiencia de aprendizaje."
              },
              image: {
                asset_fluid: null
              },
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/tripadvisor-com-caso-de-exito/",
                align: "left"
              },
              quote: "“¡ME ENCANTA! Rosetta Stone me permite aprender un idioma nuevo a mi propio ritmo de aprendizaje después de las horas de trabajo!”",
              attribution: "Empleado de TripAdvisor, Singapur"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Hay un idioma que se ajusta a los objetivos de cada empleado.",
                learner_feature_1_title: "24 Idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Rodearse del idioma es la manera más rápida de aprender.",
                learner_feature_2_title: "Inmersión lingüística a su propio ritmo",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "Lecciones que siguen el ritmo de los estudiantes y no al revés.",
                learner_feature_3_title: "Contenido que Atrae",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Los empleados pueden revisar su pronunciación en cualquier momento.",
                learner_feature_4_title: "Reconocimiento de Habla TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Mantener una conversación con hablantes nativos es, definitivamente, una señal de éxito. ",
                learner_feature_5_title: "Tutoría en vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "El aprendizaje y la practica van tomados de la mano. ",
                learner_feature_6_title: "Aplicación Móvil",
                learner_feature_title: "Características del aprendizaje empresarial"
              }
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Capacitación Global Lingüística Empresarial | Rosetta Stone Catalyst",
          meta_description: "La capacitación global lingüística empresarial de Rosetta Stone Catalyst ofrece los idiomas empresariales más utilizados que los empleados pueden aprender desde cualquier lugar.  Solicite nuestros precios corporativos.",
          canonical_url: "https://espanol.rosettastone.com/empresa/soluciones/",
          lang: "es-419"
        },
        content: {
          sections: [{
            layout: "list",
            panels: [{
              layout: "list",
              direction: "image-right",
              video: {
                currentVideoUrl: "https://vimeo.com/594888918",
                controls: true
              },
              title: {
                content: "Nuevas competencias lingüísticas empresariales hacen posible trabajar en conjunto",
                align: "left",
                heading: "h2",
                type: "section-title"
              },
              justifyContent: "space-between",
              body: {
                content: "Poder comunicarse con los compañeros de trabajo es muy importante. Con la capacitación lingüística Catalyst, las instrucciones son claras, los empleados escuchan y entienden las directrices y cometen menos errores. Eso significa que se logra una mayor productividad en el trabajo."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitud-de-precios/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar de precios",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "2",
                content: "Poder comunicarse con los compañeros de trabajo es muy importante. Con la capacitación lingüística Catalyst, las instrucciones son claras, los empleados escuchan y entienden las directrices y cometen menos errores. Eso significa que se logra una mayor productividad en el trabajo."
              },
              data_qa: "2",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "2",
                content: "Aumento de la productividad",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              },
              quote: "Leer la instantánea",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/la-influencia-del-ingles-en-los-empleados/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "3",
                content: "Depender de los proveedores de idiomas locales con enfoques diferentes produce resultados costosos y desiguales. Catalyst proporciona, de manera eficiente, la misma excelente experiencia de aprendizaje a todos los empleados en cualquier sitio, las 24 horas del día."
              },
              data_qa: "3",
              direction: "image-right",
              layout: "list",
              title: {
                dataQa: "3",
                content: "Globalización",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              },
              quote: "Ver hoja de datos",
              align: "left",
              link: {
                theme: "black",
                destination: "https://espanol.rosettastone.com/empresa/recursos/content/empresa-5razones/",
                align: "left"
              }
            }]
          }, {
            panels: [{
              body: {
                dataQa: "4",
                content: "La mayoría de candidatos busca el camino para avanzar al siguiente nivel. Poder hablar un idioma usando Catalyst será importante para los empleados al momento de aceptar un trabajo y de decidir quedarse con su negocio."
              },
              data_qa: "4",
              direction: "image-left",
              layout: "list",
              title: {
                dataQa: "4",
                content: "Atrae talento",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              image: {
                asset_fluid: null
              }
            }]
          }, {
            panels: [{
              data_qa: "5",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Active el aprendizaje con lecciones y actividades a su propio ritmo utilizando solo el nuevo idioma de un empleado mientras aprenden a hablar, leer, escribir, escuchar y pensar de una manera completamente nueva.",
                feature_1_title: "Inmersión dinámica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "La respuesta inmediata a la pronunciación guía a los empleados a hablar el idioma correctamente, hace que el aprendizaje sea gratificante al instante y sienta las bases para una mayor confianza en el habla.",
                feature_2_title: "TruAccent.",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Los ejercicios estructurados, las conversaciones con hablantes nativos y las sesiones guiadas por un instructor y 1: 1 se alinean con el nivel de competencia actual de un empleado y se enfocan en hablar.",
                feature_3_title: "Tutoría en vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "ntegre el inglés y los idiomas del mundo en cualquier programa de capacitación en idiomas para desarrollar y refinar las habilidades lingüísticas de los empleados en todos los niveles de aprendizaje, desde principiantes hasta avanzados.",
                feature_4_title: "24 idiomas.",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Las pruebas previas de inglés, español y francés y otras autoevaluaciones de idiomas del mundo identifican diversas necesidades lingüísticas y garantizan que la capacitación sea productiva desde el principio.",
                feature_5_title: "Valoraciones",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Recomienda una ruta de aprendizaje de idiomas adaptada para cada empleado en función de los objetivos y la competencia del alumno, y ofrece el nivel adecuado de desafío y compromiso.",
                feature_6_title: "Colocación de aprendiz.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Evalúe las habilidades de lectura y audición para determinar la competencia lingüística utilizando la escala del Marco Común Europeo de Referencia (MCER).",
                feature_7_title: "Pruebas de aptitud en inglés, español y francés.",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Las lecciones para principiantes se centran en temas cotidianos, mientras que las lecciones avanzadas van desde cultura e historia a temas específicos de la industria con contenido de sectores en profundidad.",
                feature_8_title: "Contenido fundacional y avanzado.",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforzar el vocabulario, la gramática y la pronunciación en actividades atractivas que desarrollan las habilidades de lectura, comprensión auditiva y expresión oral.",
                feature_9_title: "Juegos y actividades.",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "El aprendizaje digital tiene actividades para cada nivel de aprendiz, incluyendo Lectura en voz alta con comentarios del habla, escritura para propósitos específicos y comprensión auditiva y de lectura.",
                feature_10_title: "Leyendo y escribiendo.",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permite a los empleados usar teléfonos inteligentes y tabletas en cualquier momento y en cualquier lugar para tener acceso a las lecciones y actividades que aumentan la retención de habilidades y vocabulario.",
                feature_11_title: "Aplicaciones móviles.",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Informes integrados del rendimiento individual, grupal y de ubicación, con progreso de uso y seguimiento de competencia que permite a los administradores alinear la capacitación con los objetivos comerciales.",
                feature_12_title: "Herramientas de reporte.",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "La administración simplificada de licencias permite a los gerentes y administradores reasignar e incorporar a los empleados rápidamente y contribuye a un retorno de la inversión más sólido.",
                feature_13_title: "Licencias transferibles.",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nuestro equipo incorpora objetivos de aprendizaje de idiomas en modelos efectivos y asiste en la planificación, implementación y promoción del programa en toda la organización.",
                feature_14_title: "Apoyo a la implementación.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Los niveles de capacitación para administradores están disponibles para ayudar a un lanzamiento exitoso del programa, uno en el que los empleados comenzarán a aprender y hablar su nuevo idioma rápidamente.",
                feature_15_title: "Servicios de entrenamiento.",
                feature_section_title: "Todos los recursos que necesita a su alcance"
              }
            }]
          }],
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$8({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/empresa/solicitud-de-precios/",
          lang: "es-419"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Reserve hoy mismo tiempo con un experto en el aprendizaje de idiomas."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Complete el formulario a continuación para programar un horario para analizar cómo podemos ayudarlo."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "¡Falta poco!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nombre",
                required: true,
                required_error: "Introduzca su nombre."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Apellido",
                required: true,
                required_error: "Introduzca su apellido."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Dirección de correo electrónico",
                required: true,
                required_error: "Introduzca su dirección de correo electrónico.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Número de teléfono",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Introduzca el nombre de su empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamaño de la empresa",
                required: true,
                required_error: "Introduzca el tamaño de su empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 o Menos",
                  label: "100 o Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 o Más",
                  label: "50,001 o Más"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Título*",
                required: true,
                required_error: "Introduzca su función."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar precios"
            },
            labels: {
              form_privacy1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
              form_privacy2: "aquí.",
              form_privacy3: "Entiendo que puedo optar por no recibir dichas comunicaciones en cualquier momento haciendo clic en el enlace proporcionado en la comunicación o contactando a Rosetta Stone en",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
              form_updateagreement2: "aquí",
              form_updateagreement3: "para más información."
            },
            domain: ".espanol",
            dataQaLocation: "page"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          })
        }
      };

    case "solicitud-de-precios-completa":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitud de precios completa | Rosetta Stone",
          meta_description: "Las empresas de consultoría y los servicios profesionales mundiales se enfrentan a barreras idiomáticas que limitan su capacidad para atender a los clientes, involucrar a los empleados y hacer crecer su negocio a nivel mundial. Las soluciones de capacitación lingüística ayudan a las empresas de consultoría profesional a maximizar las horas facturables por empleado, lo que demuestra nuestro significativo retorno de la inversión en capacitación lingüística en toda la organización.",
          canonical_url: "https://espanol.rosettastone.com/empresas/solicitud-de-precios-completa/",
          lang: "es-419"
        },
        content: {
          title: {
            align: "center",
            content: "¡Gracias por su interés!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Consulte algunos recursos adicionales antes de la reunión.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$3({
            strings: strings
          }),
          branded_quotes: branded_quotes$3({
            strings: strings
          }),
          verticals: verticals$8({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/demo/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_demo_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-basica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/educacion-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/empresa/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/movil/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_mobile_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/resenas-clientes/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_products_reviews_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://espanol.rosettastone.com/acerca/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/contacto/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/es/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/pf/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://espanol.rosettastone.com/requerimientos-sistema/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var la = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config$2({
        strings: strings
      });
      break;

    case "consumer-seo":
      page_config = consumer_seo_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = consumer_seo_footer_config$2({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$3({
        strings: strings
      });
      page_config = enterprise_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$3({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$3({
        strings: strings
      });
      page_config = education_primary_pages_config$3({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$3({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$2({
        strings: strings
      });
      page_config = education_secondary_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$2({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$3({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$3,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$2 = {
  gtm_id: "GTM-TLH67WS"
};

var nav_primary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: false,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/buy-spanish/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/buy-french/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/buy-italian/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/buy-german/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/buy-english/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }],
      language_options_other: [{
        url: "/buy-arabic/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/buy-chinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/buy-dutch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/buy-english-british/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/buy-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/buy-greek/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/buy-hebrew/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/buy-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/buy-irish/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/buy-japanese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/buy-korean/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/buy-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/buy-polish/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/buy-portuguese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/buy-russian/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/buy-spanish-spain/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/buy-swedish/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/buy-turkish/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/buy-vietnamese/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: true,
      destination: "https://www.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/pt/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/educacaobasica/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/ensino-superior/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/empresas/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var email_collection_bar$6 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "PT_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "POR",
    button: {
      text: "Inscreva-se",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "E-mail",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Receba notícias e ofertas da Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Obrigado por registra-se.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "Este email é inválido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Inscreva-se para saber mais.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Ao me inscrever, eu aceito os\n",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "termos e condições",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone® Oficial - O Melhor Curso de Idiomas Online",
          meta_description: "Rosetta Stone é a melhor maneira de aprender Inglês e outros idiomas. Com a melhor ferramenta de reconhecimento de voz do mundo, on-line ou off-line, nosso aplicativo premiado fala por si.",
          canonical_url: "https://pt.rosettastone.com/",
          lang: "pt"
        },
        content: {
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$6({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: false,
      email_capture: true,
      market: "br",
      domain: ".br",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }, {
          visible: true,
          destination: "/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/learn-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_spanish_label
        }, {
          visible: true,
          destination: "/learn-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/learn-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/learn-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }, {
          visible: true,
          destination: "/learn-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/learn-japanese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_japanese_label
        }, {
          visible: true,
          destination: "/learn-chinese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_chinese_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_ingles_label
        }, {
          visible: true,
          destination: "/learn-language/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_languages_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/demo/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonials/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "/speech-recognition/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_speech_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }, {
          visible: true,
          destination: "/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/retail/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/student-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_student_discount_label
        }, {
          visible: true,
          destination: "/lp/military/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "//pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "/system-requirements/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "/lp/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar$5 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "PT_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "POR",
    button: {
      text: "Inscreva-se",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "E-mail",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Receba notícias e ofertas da Rosetta Stone.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Obrigado por registra-se.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "Este email é inválido.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Inscreva-se para saber mais.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "Ao me inscrever, eu aceito os\n",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "termos e condições",
      theme: "white",
      underline: "on"
    }
  };
});

var consumer_seo_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          trustpilot: true,
          lang: "en"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://www.rosettastone.com/lp/tryitnow/?ocid=seo-sticky",
              text: "Comece o teste grátis"
            }
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$5({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_seo_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: true,
      contact_modal: false,
      email_capture: true,
      market: "br",
      domain: ".br",
      vertical: "business",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }, {
          visible: true,
          destination: "/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/learn-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_spanish_label
        }, {
          visible: true,
          destination: "/learn-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/learn-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/learn-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }, {
          visible: true,
          destination: "/learn-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/learn-japanese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_japanese_label
        }, {
          visible: true,
          destination: "/learn-chinese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_chinese_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_ingles_label
        }, {
          visible: true,
          destination: "/learn-language/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_languages_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/demo/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonials/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "/speech-recognition/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_speech_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }, {
          visible: true,
          destination: "/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/retail/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/student-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_student_discount_label
        }, {
          visible: true,
          destination: "/lp/military/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "//pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "/system-requirements/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "/lp/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var lead_generation_bar$7 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$7 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
          lang: "en"
        },
        content: {
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources\n | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    internal: true,
                    theme: "yellow_black",
                    size: "regular",
                    text: "Solicitar preços"
                  }
                }
              }
            }]
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "As soluções de aprendizado de idiomas da Rosetta Stone no ensino fundamental e médio se combinam com o ensino do professor em sala de aula e estão acessíveis sempre que os alunos desejarem aprender ou melhorar as habilidades de inglês ou outros idiomas.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://vimeo.com/591688104",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Torne o aprendizado de idiomas on-line.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "O objetivo é falar um novo idioma e os professores sabem que isso exige muita prática. A Rosetta Stone tem uma abordagem única que pode fazer com que os alunos falem inglês ou outro idioma desde o princípio. Dessa forma, estarão seguros e prontos para falar por si mesmos na sala de aula e fora dela."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Desde a primeira aula, cada palavra que o aluno ouve, fala e lê está no novo idioma. Isso é imersão, a abordagem mais natural de aprendizado de idiomas. Passando de palavras para expressões e frases, sem medo. Então, quando chegar o momento de perguntar e responder, os professores podem ter a segurança de que os alunos estarão prontos."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Proporcione aos alunos mais formas de aprender.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-pueblo-city-schools/",
                theme: "black",
                align: "left"
              },
              quote: "“As crianças se concentram em tecnologia, então adoram usar o programa. O Programa Rosetta Stone permite que cheguemos a alunos aos quais não poderíamos chegar de nenhuma outra forma.”",
              attribution: "– Responsável por idiomas internacionais, Escolas da Cidade de Pueblo"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Diga adeus à timidez na fala.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Falar um novo idioma pode soar estranho no começo. O medo de cometer um erro na sala de aula pode até fazer com que os alunos não falem absolutamente nada por timidez. O mecanismo de reconhecimento de voz TruAccent™ guia a pronúncia, sem fazer julgamentos, então o aprendizado do idioma acelera conforme cresce a segurança do aluno na fala."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-corona-norco-unified-school-district/",
                theme: "black",
                align: "left"
              },
              quote: "“O programa da Rosetta Stone aumenta a segurança oral dos alunos ao proporcionar oportunidades de praticar a audição da própria pronúncia e diminuir o seu filtro afetivo.”",
              attribution: "– Administrador de serviços educacionais do Departamento de Estudantes de Inglês, Distrito Escolar Unificado de Corona-Norco"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "As aulas ao vivo tornam a conversa real.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Os professores querem que os alunos se sintam à vontade ao falar no novo idioma. No entanto, é um grande salto do aprendizado de idiomas para o mundo real. As nossas sessões de aulas ao vivo proporcionam aos alunos a chance de praticar no seu próprio nível com falantes nativos. Isso faz da tutoria (aulas ao vivo) no nosso ambiente on-line seguro outra forma inteligente de aprender."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/customer-spotlight-bethel-public-schools/",
                theme: "black",
                align: "left"
              },
              quote: "“A resposta dos alunos ao programa tem sido extremamente positiva. A nossa sala de aula colaborativa parece mais uma família…”",
              attribution: "– Coordenadora de currículo e professora de espanhol, Bethel High School"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Os alunos podem aprender o idioma em qualquer lugar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "As aulas com horários fixos ainda são a norma para os alunos. No entanto, as escolas também estão facilitando o aprendizado fora da sala de aula. O nosso aplicativo móvel permite que os alunos tenham acesso às lições e atividades sempre que for o momento certo. Isso proporciona a eles a liberdade de transformar qualquer momento em um momento de aprendizado."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/customer-spotlight-phoenix-union-high-school-district/",
                theme: "black",
                align: "left"
              },
              quote: "“Vemos que os alunos que seguem o programa da Rosetta Stone® ficam motivados e seguros, mais dispostos a participar das atividades em sala de aula e adquirem vocabulário a uma velocidade muito maior.”",
              attribution: "– Professora de estudantes de inglês, Distrito Escolar Unificado de Ensino Médio de Phoenix"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglês e outros idiomas de acordo com os objetivos dos alunos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver o aluno pelo idioma acelera o aprendizado. ",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Os alunos se divertem enquanto reforçam as lições que aprenderam.",
                learner_feature_3_title: "Jogos e atividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "É o auxiliar de pronúncia que qualquer aluno pode usar.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Oferecidas em um ambiente on-line seguro no nível de cada aluno.",
                learner_feature_5_title: "Aulas ao vivo (tutoria)",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Coloca o acesso ao aprendizado nas mãos de cada aluno.",
                learner_feature_6_title: "Aplicativo móvel",
                learner_feature_title: "Características para o aluno do ensino fundamental e médio"
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              video: {
                currentVideoUrl: "https://vimeo.com/594888236",
                controls: true
              },
              title: {
                heading: "h2",
                content: "As nossas soluções de aprendizado no ensino fundamental e médio apoiam qualquer aluno de idiomas.",
                align: "left"
              },
              body: {
                content: "Cada estudante tem a própria motivação para aprender um novo idioma. Um está fazendo um curso de inglês para principiantes e espera poder se comunicar com os colegas. Outro está em um curso de idioma estrangeiro na esperança de um dia ter a experiência de viver em outro país. Quaisquer que sejam os objetivos do aprendizado de idiomas, os alunos podem desenvolver a própria auto-confiança na fala com as nossas premiadas soluções de aprendizado no ensino fundamental e médio."
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Inclue os estudantes de inglês no programa de igualdade de oportunidades.",
                align: "left"
              },
              body: {
                content: "Alunos que falam pouco ou nada de inglês podem hesitar ao entrar na sala de aula. Essa sensação de isolamento pode continuar até que aprendam a falar inglês com segurança. O programa English for Education da Rosetta Stone® inclui recursos completos para os estudantes de inglês, seus professores e famílias. Isso se alinha aos programas de igualdade de oportunidades cujo objetivo é proporcionar a todos os alunos o mesmo acesso às ferramentas de aprendizado para o sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Conecta os alunos a idiomas e culturas.",
                align: "left"
              },
              body: {
                content: "O interesse pode começar com um filme, livro ou amigo na internet ou um vizinho. Não importa como os alunos tomem consciência do mundo, a próxima etapa mais útil para eles é aprender um idioma internacional. Escolher um programa da Rosetta Stone para escolas ajuda os alunos a desenvolver as habilidades linguísticas que precisam para ir tão longe quanto os seus interesses globalizados os levarem."
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Torne o aprendizado de inglês um esforço familiar.",
                align: "left"
              },
              body: {
                content: "Todos os dias na sala de aula contam quando os alunos estão dispostos a aprender. Para aqueles que também estão aprendendo inglês, é fundamental que continuem no caminho certo. O programa English for Education da Rosetta Stone® possibilita o envolvimento das famílias no aprendizado de inglês dos alunos. Este apoio envolvente ajuda os alunos a se conectarem mais rapidamente com professores e colegas e a atingir maior sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que envolvem os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica. ",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Aulas  ao vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "O programa English for Education inclui recursos semanais para ajudar as famílias a desenvolver juntas o domínio de inglês e webinars mensais em portuguêsl realçando o apoio familiar para os aprendizes de inglês.",
                feature_5_title: "Recursos para a conexão das famílias. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Guias do professor, livros de exercícios e guias para atividades off-line em sala de aula  proporcionam aos professores recursos que apoiam o ensino na sala de aula e complementam as lições on-line.",
                feature_6_title: "Ferramentas para a sala de aula. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "O programa English for Education inclui um teste de nivelamento e progresso para alunos do ensino fundamental II e médio para permitir que os professores determinem o ponto de partida do aprendizado de inglês para cada aluno.",
                feature_7_title: "Testes. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada um em  ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala.",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "A nossa equipe incorpora objetivos de aprendizado de idiomas a modelos eficazes e auxilia no planejamento, implantação e promoção do programa em escolas e redes de ensino. ",
                feature_14_title: "Apoio para a implementação. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine efetivamente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento.",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$7({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/educacaobasica/solicitacao-de-precos-conlcuida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$7({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_terms_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$6 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$6 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/recursos/",
          lang: "pt"
        },
        content: {
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    internal: true,
                    theme: "yellow_black",
                    size: "regular",
                    text: "Solicitar preços"
                  }
                }
              }
            }]
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Aprendizado de idiomas on-line no ensino superior | Rosetta Stone",
          meta_description: "As soluções de aprendizado de idiomas da Rosetta Stone no ensino superior oferece aos alunos acesso on-line instantâneo para o aprendizado de inglês e outros idiomas. Solicite informações.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://vimeo.com/591688104",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Coloque o aprendizado de idiomas ao alcance de todos os alunos.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Os alunos criam conexões globais deslizando o dedo no smartphone. No entanto, as instituições de ensino enfrentam restrições no orçamento para cursos de idiomas. Isso limita as possíveis opções acadêmicas e profissionais, assim como a visão de mundo dos alunos. Em uma economia global, habilidades linguísticas em idiomas internacionais são uma exigência para o trabalho no século XXI."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Diversos alunos do ensino superior podem passar em um teste padrão de proficiência em língua inglesa. No entanto, as habilidades linguísticas necessárias para o sucesso no mundo acadêmico frequentemente são muito diferentes. As soluções de aprendizado de idiomas da Rosetta Stone ajudam a desenvolver a segurança dos alunos estrangeiros com o inglês e a prepará-los para o sucesso."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Acelere o aprendizado de inglês.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-northern-border-university/",
                theme: "black",
                align: "left"
              },
              quote: "“Nesta era da internet, com o inglês sendo o idioma global, os alunos precisam dominar o idioma para que tenham auto-confiança e sejam competitivos nos estudos agora e mais adiante na carreira.”",
              attribution: "– Chefe da reitoria de ano preparatório e estudos de apoio, Northern Border University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "O aprendizado de idiomas on-line combina com o estilo de vida dos alunos.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "Cultura, entretenimento, esportes e literatura agora estão a apenas um clique de distância. A incorporação de um programa da Rosetta Stone no currículo de ensino de idiomas proporciona aos alunos acesso on-line ilimitado a orientações de pronúncia e prática de fala que não é possível durante as horas de aula."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/etudo-de-caso-liberty-university/",
                theme: "black",
                align: "left"
              },
              quote: "“Após o teste piloto dos cursos de conversação, os alunos fizeram a entrevista de proficiência oral (OPIc) do Conselho Americano de Ensino de Idiomas Estrangeiros (ACTFL). Depois de apenas um semestre de estudo, os alunos dos cursos básicos tiveram resultados pelo menos no nível pré-intermediário na OPIc.”",
              attribution: "– Chefe de departamento na Faculdade de Estudos Gerais, Liberty University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "A aula ao vivo faz com que os alunos de idiomas falem.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "Alunos, professores e funcionários querem se sentir à vontade falando um novo idioma. Passar do aprendizado de idiomas para o mundo real exige prática. As sessões de aulas ao vivo permitem que os alunos pratiquem no seu próprio nível com falantes nativos. Isso faz da aula ao vivo no nosso ambiente on-line seguro outra forma inteligente de aprender."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-canterbury-christ-church-university/",
                theme: "black",
                align: "left"
              },
              quote: "“As soluções da Rosetta Stone são uma excelente ferramenta para ajudar os participantes a avaliar o próprio nível e a ter acesso a uma gama de experiências de aprendizado interativas e diversificadas que promovem o progresso independente.”",
              attribution: "– Coordenador de cursos, Canterbury Christ Church University"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "O laboratório de idiomas passa para a nuvem.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "Aplicativos móveis enriquecem o ensino para que o aprendizado de idiomas possa ocorrer em qualquer lugar, a qualquer hora. Os alunos têm maior flexibilidade e acesso aos materiais do curso, enquanto os professores podem concentrar o período de aulas na orientação individual e atividades colaborativas de aprendizado."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-humboldt-state-university/",
                theme: "black",
                align: "left"
              },
              quote: "“[O teste de nivelamento adaptativo realizado no início do semestre e novamente no final] permite que os alunos saibam onde começaram e quanto progrediram no processo de aprendizado do idioma.”",
              attribution: "– Diretor do laboratório de cultura e idiomas internacionais, Humboldt State University"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Inglês e outros idiomas de acordo com os objetivos dos alunos.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Envolver o aluno pelo idioma acelera o aprendizado. ",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_games",
                learner_feature_3_subtitle: "Os alunos se divertem enquanto reforçam as lições que aprenderam.",
                learner_feature_3_title: "Jogos e atividades",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "É o auxiliar de pronúncia que qualquer aluno pode usar.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Oferecida em um ambiente on-line seguro no nível de cada aluno.",
                learner_feature_5_title: "Aula ao vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Coloca o acesso ao aprendizado nas mãos de cada aluno.",
                learner_feature_6_title: "Aplicativo para dispositivo móvel",
                learner_feature_title: "Online ou offline, nosso aplicativo premiado fala por si."
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              video: {
                currentVideoUrl: "https://vimeo.com/594888236",
                controls: true
              },
              title: {
                heading: "h2",
                content: "As nossas soluções de aprendizado no ensino fundamental e médio apoiam qualquer aluno de idiomas.",
                align: "left"
              },
              body: {
                content: "Cada estudante tem a própria motivação para aprender um novo idioma. Um está fazendo um curso de inglês para principiantes e espera poder se comunicar com os colegas. Outro está em um curso de idioma estrangeiro na esperança de um dia ter a experiência de viver em outro país. Quaisquer que sejam os objetivos do aprendizado de idiomas, os alunos podem desenvolver a própria auto-confiança na fala com as nossas premiadas soluções de aprendizado no ensino fundamental e médio."
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Inclue os estudantes de inglês no programa de igualdade de oportunidades.",
                align: "left"
              },
              body: {
                content: "Alunos que falam pouco ou nada de inglês podem hesitar ao entrar na sala de aula. Essa sensação de isolamento pode continuar até que aprendam a falar inglês com segurança. O programa English for Education da Rosetta Stone® inclui recursos completos para os estudantes de inglês, seus professores e famílias. Isso se alinha aos programas de igualdade de oportunidades cujo objetivo é proporcionar a todos os alunos o mesmo acesso às ferramentas de aprendizado para o sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Conecta os alunos a idiomas e culturas.",
                align: "left"
              },
              body: {
                content: "O interesse pode começar com um filme, livro ou amigo na internet ou um vizinho. Não importa como os alunos tomem consciência do mundo, a próxima etapa mais útil para eles é aprender um idioma internacional. Escolher um programa da Rosetta Stone para escolas ajuda os alunos a desenvolver as habilidades linguísticas que precisam para ir tão longe quanto os seus interesses globalizados os levarem."
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Torne o aprendizado de inglês um esforço familiar.",
                align: "left"
              },
              body: {
                content: "Todos os dias na sala de aula contam quando os alunos estão dispostos a aprender. Para aqueles que também estão aprendendo inglês, é fundamental que continuem no caminho certo. O programa English for Education da Rosetta Stone® possibilita o envolvimento das famílias no aprendizado de inglês dos alunos. Este apoio envolvente ajuda os alunos a se conectarem mais rapidamente com professores e colegas e a atingir maior sucesso acadêmico."
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que envolvem os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica. ",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Aulas  ao vivo.",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integra o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "O programa English for Education inclui recursos semanais para ajudar as famílias a desenvolver juntas o domínio de inglês e webinars mensais em portuguêsl realçando o apoio familiar para os aprendizes de inglês.",
                feature_5_title: "Recursos para a conexão das famílias. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Guias do professor, livros de exercícios e guias para atividades off-line em sala de aula  proporcionam aos professores recursos que apoiam o ensino na sala de aula e complementam as lições on-line.",
                feature_6_title: "Ferramentas para a sala de aula. ",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "O programa English for Education inclui um teste de nivelamento e progresso para alunos do ensino fundamental II e médio para permitir que os professores determinem o ponto de partida do aprendizado de inglês para cada aluno.",
                feature_7_title: "Testes. ",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada um em  ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala.",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "A nossa equipe incorpora objetivos de aprendizado de idiomas a modelos eficazes e auxilia no planejamento, implantação e promoção do programa em escolas e redes de ensino. ",
                feature_14_title: "Apoio para a implementação. ",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine efetivamente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento.",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$6({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/ensino-superior/solicitacao-de-precos-conluida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$6({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_terms_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/recursos/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solucoes/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      options: null
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$5 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/solicitacao-de-precos/",
        new_window: false,
        size: "regular",
        text: "Solicitar preços",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Listo para el siguiente paso?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$5 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/educacaobasica/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/ensino-superior/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/empresas/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$2 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://pt.rosettastone.com/empresas/recursos/",
          lang: "pt"
        },
        content: {
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Centro de resources | Rosetta Stone",
          meta_description: "Recopilación de informa, infografías, videos, seminários web e mais sóbrios para a capacitação em idiomas é a opção correcta.\n",
          canonical_url: "https://pt.rosettastone.com/empresas/recursos/",
          lang: "pt"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Recursos",
                align: "left"
              },
              body: {
                content: "Deixe os alunos falarem por si mesmos"
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Treinamento em idiomas para negócios | Rosetta Stone",
          meta_description: "As soluções de treinamento da Rosetta Stone ajudam os funcionários a desenvolver as habilidades linguísticas para os negócios em inglês e em diversos idiomas requisitados para os negócios. Solicite informações.",
          canonical_url: "https://pt.rosettastone.com/empresas/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              layout: "list",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://resources.rosettastone.com/CDN/us/rs-i-demo-6/demos/br-en/movies/RS-BrazilVO-English-Demo-480p.mp4",
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Saber idiomas para os negócios permite que os funcionários se expressem.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              body: {
                content: "Aprender novos idiomas para os negócios exige prática. A Rosetta Stone faz com que os profissionais falem e aperfeiçoem a pronúncia imediatamente. Dessa forma, estarão prontos para falar por si mesmos e pela sua empresa sem perda de tempo."
              }
            }]
          }, {
            panels: [{
              visible: true,
              dataQa: "2",
              layout: "list",
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              body: {
                dataQa: "2",
                content: "Os funcionários aprendem melhor quando tudo o que ouvem, falam, leem e escrevem está no novo idioma. É isso que o nosso método de Dynamic Immersion® proporciona, desenvolvendo a segurança no idioma desde a primeira aula."
              },
              data_qa: "2",
              direction: "image-left",
              title: {
                dataQa: "2",
                content: "Aprenda naturalmente.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/hitachi-data-systems-estudo-de-caso/",
                theme: "black",
                align: "left"
              },
              quote: "“A Rosetta Stone ajuda a romper barreiras e a impulsionar o engajamento dos funcionários.”",
              attribution: "– Vice-Presidente de Aprendizado e Colaboração, Hitachi Data Systems"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "3",
                content: "Comece a falar.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "3",
                content: "O medo de errar pode fazer com que os alunos sintam timidez de falar em um novo idioma. O nosso mecanismo de reconhecimento de voz TruAccent™ permite que os funcionários equilibrem a própria pronúncia, então terão mais segurança quando chegar na hora de discutir negócios."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/e-on/",
                theme: "black",
                align: "left"
              },
              quote: "“Os principais benefícios do ensino de idiomas da Rosetta Stone são a capacidade de aprender a qualquer hora, em qualquer lugar, no seu próprio ritmo…”",
              attribution: "– Diretor de R.H., Código de Conduta e Aprendizado Global, E.ON"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-left",
              title: {
                dataQa: "4",
                content: "Seja ouvido.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "4",
                content: "É um grande salto das aulas para falar com colegas de trabalho e clientes. As sessões de aulas ao vivo com falantes nativos proporcionam prática de conversação para que os alunos falem naturalmente no novo idioma."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/case-study-kimberly-clark-corporation/",
                theme: "black",
                align: "left"
              },
              quote: "“Observamos uma economia significativa com a implementação de um programa em toda a empresa…”",
              attribution: "– Consultor Sênior de Gestão de Talentos, Kimberly-Clark Corporation"
            }]
          }, {
            panels: [{
              layout: "list",
              direction: "image-right",
              title: {
                dataQa: "5",
                content: "Passe para os dispositivos móveis.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              },
              body: {
                dataQa: "5",
                content: "É difícil encontrar tempo para sentar em uma sala de aula para estudar um idioma. Os nossos aplicativos móveis oferecem aos alunos acesso a lições e atividades sempre que for o momento certo. Dessa forma, qualquer momento livre pode se tornar uma excelente oportunidade de aprendizado."
              },
              image: {
                asset_fluid: null
              },
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/tripadvisor-com-case-study/",
                theme: "black",
                align: "left"
              },
              quote: "“ADORO! A Rosetta Stone permite que eu aprenda um novo idioma sozinho no meu próprio ritmo de aprendizado fora do horário de trabalho.”",
              attribution: "– Funcionário da TripAdvisor em Singapura"
            }]
          }, {
            panels: [{
              pageData: {
                learner_feature_1_icon_name: "icon_24",
                learner_feature_1_subtitle: "Há um idioma que corresponde aos objetivos de cada funcionário.",
                learner_feature_1_title: "24 idiomas",
                learner_feature_2_icon_name: "icon_dynamic",
                learner_feature_2_subtitle: "Estar cercado por um idioma é a forma mais rápida de aprender.",
                learner_feature_2_title: "Imersão no ritmo do aluno",
                learner_feature_3_icon_name: "icon_foundational",
                learner_feature_3_subtitle: "As lições acompanham o ritmo dos alunos, não o contrário.",
                learner_feature_3_title: "Conteúdo envolvente",
                learner_feature_4_icon_name: "icon_truaccent",
                learner_feature_4_subtitle: "Os funcionários podem verificar a própria pronúncia  a  qualquer momento.",
                learner_feature_4_title: "Reconhecimento de voz TruAccent™",
                learner_feature_5_icon_name: "icon_tutoring",
                learner_feature_5_subtitle: "Conversar com falantes nativos é um sinal claro de sucesso.",
                learner_feature_5_title: "Aulas ao vivo",
                learner_feature_6_icon_name: "icon_mobile",
                learner_feature_6_subtitle: "Para aprender e praticar basta passar o dedo.",
                learner_feature_6_title: "Aplicativo para dispositivo móvel",
                learner_feature_title: "Receba as informações que você precisa sobre valores."
              }
            }]
          }, {
            panels: [{
              pageData: {
                admin_feature_1_icon_name: "icon_placement",
                admin_feature_1_subtitle: "Faz a correspondência entre os objetivos e quão rápido os alunos desejam atingi-los. ",
                admin_feature_1_title: "Nivelamento personalizado",
                admin_feature_2_icon_name: "icon_assessments",
                admin_feature_2_subtitle: "Descobrir o que os funcionários sabem é o melhor ponto de partida.",
                admin_feature_2_title: "Avaliação",
                admin_feature_3_icon_name: "icon_proficiency",
                admin_feature_3_subtitle: "Utilizado no início e durante o programa para acompanhar o progresso.",
                admin_feature_3_title: "Testes de proficiência em inglês",
                admin_feature_4_icon_name: "icon_reporting",
                admin_feature_4_subtitle: "Relatórios de desempenho dos alunos em tempo real ajudam a medir o ROI.",
                admin_feature_4_title: "Relatórios",
                admin_feature_5_icon_name: "icon_implementation",
                admin_feature_5_subtitle: "Serviços especializados ajudam os administradores a fazer com que os alunos comecem bem.",
                admin_feature_5_title: "Apoio para a implementação",
                admin_feature_6_icon_name: "icon_training",
                admin_feature_6_subtitle: "Personalizados para o tamanho e as necessidades da sua organização.",
                admin_feature_6_title: "Treinamento",
                admin_feature_title: "Características para o administrador de alunos"
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Programas de aprendizado de idiomas on-line para ensino fundamental e médio | Rosetta Stone",
          meta_description: "Os programas de aprendizado de idiomas on-line da Rosetta Stone incentivam os alunos de inglês e outros idiomas a falar com segurança. Pergunte os preços.",
          canonical_url: "https://pt.rosettastone.com/empresas/solucoes/",
          lang: "pt"
        },
        content: {
          sections: [{
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Novas habilidades nos idiomas de negócios fazem com que seja possível trabalhar juntos.",
                align: "left"
              },
              body: {
                content: "As lacunas linguísticas fazem com que boas ideias deixem de ser faladas ou não fiquem claras. Com o Catalyst™ da Rosetta Stone®, os funcionários desenvolvem habilidades linguísticas que transformam sinais contraditórios em uma comunicação clara com colegas de trabalho e clientes."
              },
              quote: "“Realmente acredito que é um benefício enorme para o aluno, assim como para uma corporação global como a Amgen.”",
              attribution: "Gerente de Desempenho Empresarial, Amgen",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/amgen-client-spotlight/",
                align: "left",
                theme: "black"
              },
              direction: "image-right",
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/solicitacao-de-precos/",
                    new_window: false,
                    size: "regular",
                    text: "Solicitar preços",
                    theme: "yellow_black"
                  }
                }
              }
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Aumente a produtividade.",
                align: "left"
              },
              body: {
                content: "A comunicação com os colegas de trabalho é fundamental. Com o treinamento do Catalyst, as instruções ficam claras, os funcionários ouvem e entendem as diretivas e há menos erros. Isso melhora significativamente qualidade do trabalho realizado."
              },
              quote: "Leia o Snaphot",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/language-training-productivity-ebook-snapshot/",
                align: "left",
                theme: "black"
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Globalize.",
                align: "left"
              },
              body: {
                content: "Depender de fornecedores de idiomas locais com abordagens distintas produz resultados caros e desiguais. O Catalyst oferece de maneira eficaz a mesma experiência de aprendizado premiada para os seus funcionários em qualquer lugar do mundo, 24 horas por dia."
              },
              quote: "Veja a planilha de dados",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/meet-global-challenges/",
                align: "left",
                theme: "black"
              },
              direction: "image-right"
            }]
          }, {
            panels: [{
              width: "100%",
              align: "left",
              image: {
                asset_fluid: null
              },
              title: {
                heading: "h2",
                content: "Atraia o talento.",
                align: "left"
              },
              body: {
                content: "A maioria dos candidatos busca por oportunidade de desenvolvimento. A oportunidade de aprender um novo idioma utilizando o Catalyst será um diferencial em sua oferta de trabalho aos profissionais que concorrem a oportunidades de trabalho em sua empresa e também um fator de retenção de talentos."
              },
              quote: "Leia o roteiro",
              attribution: "",
              link: {
                destination: "https://pt.rosettastone.com/empresas/recursos/content/rosetta-playbook-september-2017-final-web/",
                align: "left",
                theme: "black"
              },
              direction: "image-left"
            }]
          }, {
            panels: [{
              data_qa: "4",
              img_bg_top: images.solSection_7StoneBlueSvg,
              img_bg_bottom: images.solSection_7StoneYellowSvg,
              data: {
                feature_1_img: "icon_dynamic",
                feature_1_subtitle: "Ative o aprendizado com lições no ritmo do aluno e atividades no novo idioma que circundam os alunos enquanto aprendem a falar, ler, escrever, ouvir e pensar de uma forma totalmente nova.",
                feature_1_title: "Imersão dinâmica.",
                feature_2_img: "icon_truaccent",
                feature_2_subtitle: "Feedback imediato da pronúncia guia o aluno a falar corretamente no novo idioma, tornando o aprendizado instantaneamente recompensador e estabelecendo a base para maior segurança na fala.",
                feature_2_title: "TruAccent. ",
                feature_3_img: "icon_tutoring",
                feature_3_subtitle: "Exercícios estruturados e conversas com falantes nativos se alinham com o nível atual de proficiência do aluno e ajudam a que se sinta à vontade para falar no novo idioma.",
                feature_3_title: "Tutoria ao vivo. ",
                feature_4_img: "icon_24",
                feature_4_subtitle: "Integre o inglês e outros idiomas em qualquer programa de idiomas para desenvolver e refinar as habilidades linguísticas de alunos de todos os níveis, de principiantes a avançados.",
                feature_4_title: "24 idiomas. ",
                feature_5_img: "icon_assessments",
                feature_5_subtitle: "Os pré-testes em inglês, espanhol e francês e outras autoavaliações em idiomas do mundo identificam necessidades diversas de idiomas e garantem que o treinamento seja produtivo desde o início.",
                feature_5_title: "Assessments. ",
                feature_6_img: "icon_placement",
                feature_6_subtitle: "Recomenda um caminho de aprendizado de idiomas adaptado para cada funcionário com base nas metas e proficiência do aluno, oferecendo o nível certo de desafio e engajamento.",
                feature_6_title: "Colocação do aprendiz.",
                feature_7_img: "icon_proficiency",
                feature_7_subtitle: "Avalie as habilidades de leitura e compreensão auditiva para determinar a proficiência linguística usando a escala do Quadro Europeu Comum de Referência (QECR).",
                feature_7_title: "Testes de proficiência em inglês, espanhol e francês",
                feature_8_img: "icon_foundational",
                feature_8_subtitle: "Os alunos interagem instantaneamente com conteúdos ricos que se adaptam ao ritmo e progresso de cada aluno em um ambiente interativo que se concentra em alunos que estão aprendendo a falar.",
                feature_8_title: "Conteúdo básico e avançado. ",
                feature_9_img: "icon_games",
                feature_9_subtitle: "Reforçam vocabulário, gramática e pronúncia de formas divertidas e envolventes que desenvolvem as habilidades de leitura, compreensão oral e fala dos alunos. ",
                feature_9_title: "Jogos e atividades. ",
                feature_10_img: "icon_reading",
                feature_10_subtitle: "Atividades para alunos de todos os níveis incluem leitura em voz alta com feedback instantâneo da pronúncia, escrita para fins específicos e compreensão oral e de leitura.",
                feature_10_title: "Leitura e escrita. ",
                feature_11_img: "icon_mobile",
                feature_11_subtitle: "Permitem que os alunos usem smartphones e tablets dentro e fora da sala de aula para acessar lições e atividades que aumentam a retenção de habilidades e o vocabulário.",
                feature_11_title: "Aplicativos móveis. ",
                feature_12_img: "icon_reporting",
                feature_12_subtitle: "Uma visão instantânea do desempenho de indivíduos, grupos e classes com acompanhamento do progresso de uso e proficiência que permite que professores e administradores facilmente relatem os resultados dos alunos.",
                feature_12_title: "Ferramentas de relatório. ",
                feature_13_img: "icon_transferable",
                feature_13_subtitle: "O gerenciamento simplificado de licenças permite que professores e administradores rapidamente redistribuam os alunos, assegurando que todas as licenças estejam em uso e apoiando o ROI do programa.",
                feature_13_title: "Licenças transferíveis. ",
                feature_14_img: "icon_implementation",
                feature_14_subtitle: "Nossa equipe incorpora metas de aprendizagem de idiomas em modelos eficazes e auxilia no planejamento, implantação e promoção do programa em toda a organização.",
                feature_14_title: "Suporte à implementação.",
                feature_15_img: "icon_training",
                feature_15_subtitle: "Níveis de treinamento para administradores e professores estão disponíveis para contribuir para o sucesso no lançamento do programa de maneira que se combine eficazmente com o ensino do professor na sala de aula.",
                feature_15_title: "Serviços de treinamento. ",
                feature_section_title: "Todos os recursos que você precisa estão ao seu alcance."
              }
            }]
          }],
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$5({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/empresas/solicitacao-de-precos/",
          lang: "pt"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Marque um horário com um especialista no aprendizado de idiomas hoje mesmo."
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Preencha o formulário abaixo para agendar um horário para discutir como podemos ajudar você."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Você está quase lá!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "Nome",
                required: true,
                required_error: "Insira seu nome."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Sobrenome",
                required: true,
                required_error: "Insira seu sobrenome."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Endereço de email",
                required: true,
                required_error: "Insira seu endereço de email.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Telefone",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Empresa",
                required: true,
                required_error: "Insira o nome da sua empresa."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Tamanho da empresa",
                required: true,
                required_error: "Insira o tamanho da empresa.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 ou Menos",
                  label: "100 ou Menos"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 ou Mais",
                  label: "50,001 ou Mais"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Cargo",
                required: true,
                required_error: "Insira seu cargo."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Solicitar preços"
            },
            labels: {
              form_privacy1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
              form_privacy2: "aqui.",
              form_privacy3: "Entendo que posso optar por não receber essas comunicações a qualquer momento clicando no link fornecido na comunicação ou entrando em contato com a Rosetta Stone em",
              form_privacy4: ".",
              form_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
              form_updateagreement2: "aqui",
              form_updateagreement3: "para maiores informações."
            },
            domain: ".br",
            dataQaLocation: "page"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          })
        }
      };

    case "solicitacao-de-precos-concluida":
      return {
        page: page,
        helmet: {
          meta_title: "Solicitação de preços concluída | Rosetta Stone",
          meta_description: "Serviços profissionais e empresas de consultoria do mundo todo enfrentam barreiras linguísticas que limitam sua capacidade de atender aos clientes, engajar funcionários e expandir seus negócios globalmente. As soluções de treinamento em idiomas ajudam as empresas de consultoria profissional a maximizar as horas faturáveis por funcionário — o que comprova o ROI significativo de nosso treinamento em idiomas em toda a organização.",
          canonical_url: "https://pt.rosettastone.com/empresas/solicitacao-de-precos-concluida/",
          lang: "pt"
        },
        content: {
          title: {
            align: "center",
            content: "Agradecemos seu interesse!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Confira alguns resources adicionais antes da sua reunião.",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/recursos/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Recursos",
            theme: "blue_white"
          },
          awards: awards$2({
            strings: strings
          }),
          branded_quotes: branded_quotes$2({
            strings: strings
          }),
          verticals: verticals$5({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://pt.rosettastone.com/educacaobasica/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/ensino-superior/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/empresas/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.es/magazine/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/contato/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/pt/school",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_terms_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneLatino/",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var pt = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config$1({
        strings: strings
      });
      break;

    case "consumer-seo":
      page_config = consumer_seo_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = consumer_seo_footer_config$1({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$2({
        strings: strings
      });
      page_config = enterprise_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$2({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$2({
        strings: strings
      });
      page_config = education_primary_pages_config$2({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$2({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config$1({
        strings: strings
      });
      page_config = education_secondary_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config$1({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$2({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$2,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics$1 = {
  gtm_id: "GTM-NDSR53K"
};

var nav_primary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://www.rosettastone.co.uk/magazine/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: false,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18003063467",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/spanish/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/french/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/italian/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/german/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/english/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/japanese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }],
      language_options_other: [{
        url: "/arabic/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/chinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/dutch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/english-american/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }, {
        url: "/tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/greek/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/hebrew/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/irish/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/korean/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/polish/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/portuguese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/russian/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/spanish-latin-america/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/swedish/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/turkish/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/vietnamese/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      for_young_learners_label: strings.nav_primary_vertical_for_young_learners_label,
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: false,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/en/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/schools/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/highereducation/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/enterprise/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var education_primary_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: "https://educationblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/enterprise/resources/education/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var awards$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var lead_generation_bar$4 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/pricing-request/",
        new_window: false,
        size: "regular",
        text: "Price Enquiry",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Ready to begin your organisation’s complete language journey?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$4 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/enterprise/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        alt: "Schools",
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/schools"
      },
      name: "Schools",
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }]
  };
});

var education_primary_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Digital Language Learning for Schools | Rosetta Stone",
          meta_description: "Rosetta Stone digital language learning for schools integrates easily into classrooms and any language programme. Ask us about pricing.",
          canonical_url: "https://www.rosettastone.co.uk/schools/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1",
            panels: [{
              body: {
                content: "Rosetta Stone offers a unique approach that has students speaking from the start. Our online language learning method prepares students to speak for themselves, anywhere their new language takes them."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Move language learning online.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              video: {
                controls: true,
                currentVideoUrl: "https://player.vimeo.com/video/591688104"
              }
            }],
            visible: true
          }, {
            visible: true,
            dataQa: "2",
            layout: "list",
            panels: [{
              body: {
                dataQa: "2",
                content: "Every word your students hear, speak, and read is in their new language, beginning with the first lesson. Immersion is the natural way to learn a language, so when it's time to speak, students will be ready."
              },
              custom: {
                cta: {
                  destination: "https://www.rosettastone.co.uk/enterprise/resources/content/classroom-solutions-measurable-language-learning-success/",
                  new_window: false,
                  size: "regular",
                  text: "Watch Video",
                  theme: "blue_white"
                }
              },
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              title: {
                dataQa: "2",
                content: "Learn naturally.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            visible: true,
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                dataQa: "3",
                content: "Speaking a new language in the classroom isn’t easy at first. Mistakes can make students shy. Our TruAccent™ speech engine guides pronunciation until students feel confident speaking on their own."
              },
              custom: {
                quote: {
                  align: "left",
                  attribution: "Faculty Leader, Harrogate Grammar School",
                  dataQa: "2",
                  quote: "Rosetta Stone provides our students with the opportunity to study almost any language they want. That allows us to personalise language learning in a really powerful way.",
                  link: {
                    destination: "https://www.rosettastone.co.uk/enterprise/resources/content/harrogate-grammar-school",
                    theme: "black"
                  }
                }
              },
              data_qa: "3",
              direction: "image-right",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                dataQa: "3",
                content: "Speak confidently.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            visible: true,
            data_qa: "4",
            layout: "list",
            panels: [{
              body: {
                data_qa: "4",
                content: "Live Tutoring sessions allow students to practice conversation at their proficiency level, with native-speaking certified coaches. That makes tutoring in our safe space another smart way to learn."
              },
              custom: {
                quote: {
                  align: "left",
                  attribution: "Head Teacher, Norlington School for Boys",
                  dataQa: "2",
                  quote: "The solution is very simple in its use, but very powerful at the same time. Students can access it quickly and learn fast...",
                  link: {
                    destination: "https://www.rosettastone.co.uk/enterprise/resources/content/norlington-school-for-boys/",
                    theme: "black"
                  }
                }
              },
              direction: "image-left",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                data_qa: "4",
                content: "Make conversation.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }]
          }, {
            visible: true,
            data_qa: "5",
            layout: "list",
            panels: [{
              body: {
                data_qa: "5",
                content: "Our mobile app lets your students log in to their language learning program and activities whenever the time is right. That way, they have the freedom to turn any moment into a teachable one."
              },
              custom: {
                quote: {
                  align: "left",
                  attribution: "Assistant Headteacher, Belle Vue Girls",
                  dataQa: "2",
                  quote: "We use Rosetta Stone to support our teaching of ALL languages, because the students love the feeling of independence the programme offers.",
                  link: {
                    destination: "https://www.rosettastone.co.uk/enterprise/resources/content/belle-vue-girls-immersion/",
                    internal: true,
                    theme: "black"
                  }
                }
              },
              direction: "image-right",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                data_qa: "5",
                content: "Access anywhere.",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }]
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "solutions":
      return {
        page: page,
        helmet: {
          meta_title: "Online Language Learning Education Programs  | Rosetta Stone",
          meta_description: "Rosetta Stone online programs support language learners in schools, higher education, and teacher training. Learn how, and ask about education pricing.",
          canonical_url: "https://www.rosettastone.co.uk/schools/solutions/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1",
            panels: [{
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              body: {
                content: "Our self-paced approach to language learning helps all students to start speaking right away. So whether they are learning English or a world language, they’ll build their speaking confidence from the start."
              },
              direction: "image-right",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Inspire learners to speak a new language.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2",
            panels: [{
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/edtech-solutions-for-your-language-classroom/",
                  size: "regular",
                  theme: "blue_white",
                  text: "Watch Video"
                }
              },
              body: {
                content: "Students speaking little or no local language may hesitate at the classroom door. Rosetta Stone offers online and offline resources to help learners and teachers achieve their language and curriculum goals."
              },
              direction: "image-left",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Put students at ease.",
                heading: "h2",
                type: "page-title",
                theme: "black"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3",
            panels: [{
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/university-of-barcelona-critical-language-skills/",
                  size: "regular",
                  theme: "blue_white",
                  text: "Read Case Study"
                }
              },
              body: {
                content: "No matter how students become globally aware, an important next step is to learn a world language. Online learning accelerates students’ ability to develop new speaking skills and use them confidently."
              },
              direction: "image-right",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Serve higher education.",
                heading: "h2",
                type: "page-title",
                theme: "black"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 4",
            panels: [{
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/north-east-tsst-customer-spotlight/",
                  size: "regular",
                  theme: "blue_white",
                  text: "Learn More"
                }
              },
              body: {
                content: "Educators can access Rosetta Stone solutions whenever and wherever it suits their busy schedules. Our online program gives teachers added flexibility in their personal and professional development."
              },
              direction: "image-left",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Reach out to teachers.",
                heading: "h2",
                type: "page-title",
                theme: "black"
              }
            }],
            visible: true
          }],
          features: {
            img_bg_top: images.solSection_7StoneBlueSvg,
            img_bg_bottom: images.solSection_7StoneYellowSvg,
            data: {
              canonical_url: null,
              feature_1_img: "icon_dynamic",
              feature_1_subtitle: "Surrounding students with one language speeds up learning. ",
              feature_1_title: "Self-paced Immersion",
              feature_2_img: "icon_truaccent",
              feature_2_subtitle: "It’s the pronunciation helper any student can use.",
              feature_2_title: "TruAccent™ Speech Recognition",
              feature_3_img: "icon_tutoring",
              feature_3_subtitle: "Offered in a safe, online space at each student’s proficiency level.",
              feature_3_title: "Live Tutoring",
              feature_4_img: "icon_24",
              feature_4_subtitle: "English and world languages to match student goals.",
              feature_4_title: "24 Languages",
              feature_5_img: "icon_assessments",
              feature_5_subtitle: "Including staff language training meets a growing need.",
              feature_5_title: "Professional Development",
              feature_6_img: "icon_placement",
              feature_6_subtitle: "Offline resources to support teachers and students. ",
              feature_6_title: "Classroom Builders",
              feature_7_img: null,
              feature_7_subtitle: null,
              feature_7_title: null,
              feature_8_img: "icon_foundational",
              feature_8_subtitle: "Lessons keep up with students, not the other way around.",
              feature_8_title: "Engaging Content",
              feature_9_img: "icon_games",
              feature_9_subtitle: "Students have fun while reinforcing lessons they’ve learned.",
              feature_9_title: "Games and Activities",
              feature_10_img: null,
              feature_10_subtitle: null,
              feature_10_title: null,
              feature_11_img: "icon_mobile",
              feature_11_subtitle: "Puts learning access in each student’s hand.",
              feature_11_title: "Mobile App",
              feature_12_img: "icon_reporting",
              feature_12_subtitle: "Access up-to-date details on learner progress anytime.",
              feature_12_title: "Reporting",
              feature_13_img: "icon_transferable",
              feature_13_subtitle: "Education online customer community for sharing ideas and best practices.",
              feature_13_title: "The Bridge",
              feature_14_img: "icon_implementation",
              feature_14_subtitle: "Expert services make sure getting started is smooth sailing.",
              feature_14_title: "Implementation Support",
              feature_15_img: "icon_training",
              feature_15_subtitle: "Tailored to your school’s size and needs.",
              feature_15_title: "Training Services",
              feature_section_title: "Every resource you need is at your fingertips.",
              meta_description: "Rosetta Stone online programs support language learners in schools, higher education, and teacher training. Learn how, and ask about education pricing.",
              meta_title: "Online Language Learning Education Programs  | Rosetta Stone",
              pricing_subtitle: null,
              pricing_title: null,
              section_1_body: "Our self-paced approach to language learning helps all students to start speaking right away. So whether they are learning English or a world language, they’ll build their speaking confidence from the start.",
              section_1_cta_caption: null,
              section_1_link: null,
              section_1_logo: null,
              section_1_play_text: null,
              section_1_quote: null,
              section_1_secondary_cta: "Pricing Enquiry",
              section_1_title: "Inspire learners to speak a new language.",
              section_1_video_url: null,
              section_2_body: "Students speaking little or no local language may hesitate at the classroom door. Rosetta Stone offers online and offline resources to help learners and teachers achieve their language and curriculum goals. ",
              section_2_link: "https://www.rosettastone.co.uk/enterprise/resources/content/edtech-solutions-for-your-language-classroom",
              section_2_logo: null,
              section_2_quote: "Watch Video",
              section_2_title: "Put students at ease.",
              section_3_body: "No matter how students become globally aware, an important next step is to learn a world language. Online learning accelerates students’ ability to develop new speaking skills and use them confidently. ",
              section_3_link: "https://www.rosettastone.co.uk/enterprise/resources/content/university-of-barcelona-critical-language-skills",
              section_3_logo: null,
              section_3_play_text: null,
              section_3_quote: "Read Case Study",
              section_3_title: "Serve higher education.",
              section_3_video_url: null,
              section_4_body: "Educators can access Rosetta Stone solutions whenever and wherever it suits their busy schedules. Our online program gives teachers added flexibility in their personal and professional development.\n",
              section_4_link: "https://www.rosettastone.co.uk/enterprise/resources/content/north-east-tsst-customer-spotlight",
              section_4_logo: null,
              section_4_quote: "Learn More",
              section_4_title: "Reach out to teachers.",
              title: "uk-edu-solutions"
            }
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$4({
            strings: strings
          })
        }
      };

    case "pricing-request":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Book time with a Language Expert today"
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Please fill out the form below to schedule time to discuss how we can help."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Almost there!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "First Name",
                required: true,
                required_error: "Please enter your First Name."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Last Name",
                required: true,
                required_error: "Please enter your Last Name."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Email Address",
                required: true,
                required_error: "Please enter your Email Address.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Phone Number",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Company",
                required: true,
                required_error: "Please enter your Company Name."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Company Size",
                required: true,
                required_error: "Please enter your Company Size.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 or Less",
                  label: "100 or Less"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 or More",
                  label: "50,001 or More"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Title",
                required: true,
                required_error: "Please enter your Role."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Price Enquiry"
            },
            labels: {
              form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
              form_privacy2: "Privacy Policy",
              form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
              form_privacy4: ".",
              form_privacyUrl: "https://www.rosettastone.com/privacy",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
              form_updateagreement2: "here",
              form_updateagreement3: "for more information."
            },
            domain: ".co.uk",
            dataQaLocation: "page"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          })
        }
      };

    case "pricing-request-complete":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
          lang: "en"
        },
        content: {
          lead_generation_bar: {
            visible: false
          },
          title: {
            align: "center",
            content: "Thanks for your interest!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Check out some additional resources before your meeting!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/enterprise/resources/education",
            internal: false,
            new_window: false,
            size: "regular",
            text: "Resources",
            theme: "blue_white"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          })
        }
      };

    case "pricing-request-schedule":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/schools/pricing-request/",
          lang: "en"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$4({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.co.uk/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/schools/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: false,
          destination: "https://www.rosettastone.co.uk/higher-education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/enterprise/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.co.uk/about/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/magazine",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.co.uk/agreements"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/uk/pdfs/website-privacy-policy-uk.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStoneEU",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastoneUK",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: null,
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      options: [{
        link: "/industry/consulting/",
        label: strings.nav_secondary_enterprise_solutions_consulting_label,
        title: strings.nav_secondary_enterprise_solutions_consulting_label
      }, {
        link: "/industry/financial/",
        label: strings.nav_secondary_enterprise_solutions_financial_label,
        title: strings.nav_secondary_enterprise_solutions_financial_label
      }, {
        link: "/industry/logistics/",
        label: strings.nav_secondary_enterprise_solutions_logistics_label,
        title: strings.nav_secondary_enterprise_solutions_logistics_label
      }, {
        link: "/industry/manufacturing/",
        label: strings.nav_secondary_enterprise_solutions_manufacturing_label,
        title: strings.nav_secondary_enterprise_solutions_manufacturing_label
      }, {
        link: "/industry/pharmaceutical/",
        label: strings.nav_secondary_enterprise_solutions_pharmaceutical_label,
        title: strings.nav_secondary_enterprise_solutions_pharmaceutical_label
      }, {
        link: "/industry/retail/",
        label: strings.nav_secondary_enterprise_solutions_retail_label,
        title: strings.nav_secondary_enterprise_solutions_retail_label
      }]
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar$3 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/pricing-request/",
        new_window: false,
        size: "regular",
        text: "Price Enquiry",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Ready to begin your organisation’s complete language journey?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$3 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/schools"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config$1 = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Resources for Online Language Learning for Enterprise | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/resources/",
          lang: "en"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Enterprise Resources"
              },
              body: {
                content: "Let Employees Speak For Themselves"
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  theme: "yellow_black",
                  text: "REQUEST PRICING"
                }
              }
            }]
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "experience-audit-language-costs":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Audit Language Costs | Rosetta Stone Enterprise",
          meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/audit-language-costs/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 0 - Hero",
            layout: "list",
            panels: [{
              body: {
                content: "\n                                        A language cost audit can help keep learning and development (L&D) vendor costs down. Auditing your procurement process can be overwhelming, so we\u2019ve put together this handy three-step checklist to help you through the process.\n                                        "
              },
              custom: {
                cta: {
                  destination: "/experience/making-the-case/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Learn More"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Audit Your Language Training Costs in 3 Easy Steps!",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 1",
            layout: "list",
            panels: [{
              body: {
                content: "What’s your process for selecting language training solutions and other related L&D software products? Do you have a standardized way to identify language training programs? Have members of your regional procurement team purchased language services in the past? Be sure you fully grasp how your department purchases language training products."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "1. Start with your own procurement team and region.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2",
            layout: "list",
            panels: [{
              body: {
                content: "\n                            Language training can be billed in a variety of ways depending on who requested the vendor, and why they need the solution. Confirm L&D purchasing policies with each category manager in your region.\n                            "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "\n                            Look for patterns in language training spending over the past few years. Have language expenses increased from year-to-year? How are these costs billed? Are these language solutions sourced from multiple vendors or a single vendor? You\u2019ll also want to take a look at corporate credit card accounts, and employee benefit initiatives, like tuition reimbursement programs.   \n                            "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "2. Review departmental language training expenses.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 4",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "L&D expenses can vary from year to year, so you’ll need to look back a few years. Be sure to also look beyond L&D use cases. Some department heads will use language tools for specific use cases, often going unnoticed in a general cost audit. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 5",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "If purchasing is decentralized or broken out by region, you may need to do a little more legwork. A good place to start is by asking regional leaders to identify department heads responsible for tracking L&D, HR, software, and related spends. Then have those department heads identify which language costs are billed as direct or indirect expenses."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "3. Zero in on region-specific language training expenses.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 6",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "If you have a global language policy, start by asking regional leaders if they’re using that policy to purchase new language solutions. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 7",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "\n                            Rosetta Stone Enterprise helps some of the world\u2019s leading brands realize big cost savings by helping them streamline procurement by consolidating their language spend to a single, award-winning enterprise language training solution. \n                            "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "60%",
                width: "60%"
              },
              title: {
                align: "left",
                content: "So you’re overspending on language training... Now what?",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 8",
            layout: "list",
            panels: [{
              body: {
                content: ""
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Talk To A Language Expert"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Join thousands of leading organizations saving big on language training with Rosetta Stone Enterprise!",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }],
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "experience-making-the-case":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Making the Case | Rosetta Stone Enterprise",
          meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/making-the-case/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1",
            layout: "list",
            panels: [{
              body: {
                content: "\n                                        It\u2019s time to choose a language training programme. Do you go old school with face-to-face instruction or empower your employees to learn online? \n                                        <br/>\n                                        <br/>\n                                        Here\u2019s how to make a strong business case for online language training.\n                            ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Making the case for online language training.",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2",
            layout: "list",
            panels: [{
              body: {
                content: "Face-to-face training requires additional expenses beyond the cost of a learning module. But when your employees learn a language online, many of those costs vanish.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "60%",
                width: "60%"
              },
              sub_body: {
                content: "Converting your language spend from many local providers to one global platform is a clear cost-saver.",
                dangerous: true
              },
              sub_title: {
                align: "left",
                content: "Consolidate vendors.",
                theme: "black",
                type: "sub-title"
              },
              title: {
                align: "left",
                content: "Start with cost savings.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "One of the world’s largest consulting companies serves clients in over <strong>100</strong> countries and invests in language training on a global scale. After partnering with Rosetta Stone, the company reduced its vendor network and realised first-year cost savings of more than <strong>$500,00</strong>.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "75%",
                width: "75%"
              },
              title: null
            }, {
              body: {
                content: "A global manufacturing leader was able to increase its language offering from 2,000 employees to <strong>77,000</strong> while still saving over <strong>$3 million</strong> annually by simply switching from an international array of vendors to our single-source solution.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "75%",
                width: "75%"
              },
              title: null
            }],
            visible: true
          }, {
            data_qa: "Section 4",
            layout: "duo",
            panels: [{
              body: {
                align: "center",
                content: "Verifying new candidates’ language proficiency levels can be critical. Now your talent development team can conduct  language assessments available with your existing licences.",
                dangerous: true
              },
              data_qa: null,
              direction: "toggle-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "center",
                content: "Spend less on talent testing.",
                heading: "h2",
                theme: "black",
                type: "card-title"
              },
              toggle: {
                body: {
                  align: "left",
                  content: "A global professional services firm has tested more than 10,000 candidates through online assessments. An alternative was to use an outside language service at a cost of  $40 per person. Instead, the company chose the online CEFR-based Rosetta Stone assessment in the programme, at no additional cost.",
                  dangerous: true
                },
                title: null
              }
            }, {
              body: {
                align: "center",
                content: "Moving away from a dedicated training space achieves another level of cost savings."
              },
              data_qa: null,
              direction: "toggle-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "250px",
                width: "250px"
              },
              title: {
                align: "center",
                content: "Act sustainably.",
                heading: "h3",
                theme: "black",
                type: "card-title"
              },
              toggle: {
                body: {
                  align: "left",
                  content: "\n                                <ul>\n                                    <li>Eliminating employee and instructor travel</li>\n                                    <li>Cutting classroom space and maintenance</li>\n                                    <li>Replacing printed materials with online lessons</li>\n                                    <li>Allowing learners to use their personal devices</li>\n                                </ul>\n                            ",
                  dangerous: true
                },
                title: {
                  align: "left",
                  content: "Achieve more savings by:",
                  heading: "h3",
                  theme: "black",
                  type: "sub-title"
                }
              }
            }],
            visible: true
          }, {
            data_qa: "Section 5 - Know your learners.",
            layout: "carousel",
            panels: [{
              body: {
                content: "Just as today’s learners curate their own content experiences in their personal lives on social media, they expect the same experience at work."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Curators of their own experience.",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "They want to give and receive feedback on the learning process—how to improve as a learner, and how the organisation can help them succeed in their own online learning experiences."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Employer empowerment helps them thrive.",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Modern employees are also more likely to invest in their careers at organisations invested in their skill development—lowering your own retention spend in the process."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Loyal to organisations that invest in skill development.",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "Know your learners.",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 6",
            layout: "carousel",
            panels: [{
              body: {
                content: "Seamless, immersive learning experiences guide learners from assessment to proficiency employing a proven, unified method on any device."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Flexible. Mobile. Easy to use.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Learn from native speakers 24/7. Employees access tutoring sessions from virtually anywhere in the world to fit their own schedules."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Online Tutoring from native speakers.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Access an integrated reporting dashboard where you can track and monitor each employee’s learning progress."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Smart dashboards.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Choose from 24 languages.<br/>\n                               Switch at any time.<br/> \n                               The only limit? Hours in the day.\n                              ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Access all our languages.",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "Choose our award-winning enterprise solution.",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 7",
            layout: "list",
            panels: [{
              body: {
                content: "Rosetta Stone is dedicated to using the power of language and literacy education to change people's lives. Millions of inspired learners have used our online and mobile solutions at home, in the workplace, and in schools around the world."
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Talk To A Language Expert"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Join thousands of fellow industry leaders",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 8",
            layout: "list",
            panels: [{
              data_qa: null,
              banner: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null
              }
            }],
            visible: true
          }],
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "experience-nine-warning-signs":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Nine Warning Signs | Rosetta Stone Enterprise",
          meta_description: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/nine-warning-signs/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1 - Header",
            layout: "list",
            panels: [{
              body: {
                content: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organisation may suffer a business loss:"
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "9 warning signs your employees need language training.",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              },
              custom: {
                body: {
                  content: "\n                                            When you add a language barrier to the equation, things get even more complicated. What if you\u2019re communicating to a coworker, boss, or customers in a language you don\u2019t speak very well?\n                                            <br />\n                                            <br />\n                                            If you\u2019re worried your organisation might have a language problem, it\u2019s time to do an honest assessment. \n                                        ",
                  dangerous: true
                },
                list: ["A loss of revenue.", "A loss of productivity.", "A loss of a customer.", "A loss of an employee.", "A loss of credibility."],
                title: {
                  align: "left",
                  content: "These are losses no organisation can afford.",
                  theme: "black",
                  type: "sub-title"
                }
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2 - 9 Bullets",
            layout: "list",
            title: {
              align: "center",
              content: "9 signs you may have a language problem.",
              heading: "h2",
              theme: "blue",
              type: "page-title"
            },
            panels: [{
              body: {
                content: "\n                                A diverse, multilingual workforce is definitely worth celebrating. Keeping everyone informed about their roles, basic responsibilities, policies, and safety protocols is both a liability and a major challenge for productivity across the organisation. \n                                <br/>\n                                <br/>\n                                Solving this challenge involves a focused effort across your entire business to shift employees\u2019 perception of language training.\n                                ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "1. You have a diverse workforce",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Do multilingual employees fully understand safety policies and protocols? How does that impact their daily tasks and your ability to retain them?  \n                                            <br/>\n                                            <br/>\n                                            Safety compliance in a multilingual workplace is a critical and expensive problem to solve. Depending on the severity of the incident, miscommunicating a seemingly simple safety protocol can cost hundreds of thousands in compliance penalties.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "2. On-the-job safety incidents have increased",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Are you fully aware of the languages your customers speak? Have you ever lost a customer due to a language barrier that provided a bad experience? Do you understand the role of communication in each of your customers\u2019 local cultures?\n                                            <br/>\n                                            <br/>\n                                            Your answers to these questions may reveal a clear need for language training that truly immerses your employees in daily speaking practice with native speakers to truly understand the preferences of your customers.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "3. Customer service is compromised",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                Research shows that 60% of employees will stick with an employer if they provide language training as part of their professional development programmes. Meanwhile, only 30% of companies actively make that investment.\n                                <br/>\n                                <br/>\n                                A holistic retention strategy includes language training as an additional element of professional development across your business.\n                            ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "4. Employee turnover is on the rise",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Language barriers are presented in many forms on-the-job. One common result of miscommunication comes in the form of misunderstood job expectations.\n                                            <br/>\n                                            <br/>\n                                            This often means lowered productivity, more mistakes on the job, and general frustration from your broader teams. Operationally, you may default to lowering expectations for Limited English Proficiency (LEP) employees, which can damage morale and result in higher turnover.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "5. Lowered job expectations",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Since you\u2019re already investing time and resources into training LEP employees, it makes perfect sense to retain those employees. Adding language training to your employee development plan can go a long way to show every employee you are invested in their future with your company.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "6. Employee onboarding takes longer",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "When language barriers are a hurdle for career advancement, your employees will be less engaged in their work and are less likely to pursue advancement within your organisation. Create a win-win situation for your employees. Use language training to help them take the next best step for their career.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "7. Multilingual team members' careers have stalled",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Do you have a collaboration and productivity problem across your global teams? Language barriers could be at play, while your employees look to you for an effective training solution.   \n                                            <br/>\n                                            <br/>\n                                            A recent survey of Rosetta Stone Enterprise users showed two of the most desired outcomes include teamwide collaboration (66% of respondents) and improved verbal communication (68% of respondents) with teammates.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "8. Collaboration is an ongoing challenge",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Is your hiring strategy impacted by language challenges across your business? As you look to fill future roles and grow your business abroad, it\u2019s critical to take stock of how language barriers will impact employee performance, compliance, retention and growth.\n                                        "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "9. Future employees face similar obstacles",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3 - Brand Images",
            layout: "list",
            panels: [{
              destination: "",
              image: {
                alt: "Sony Pictures",
                asset_static: logos.logoSonyPicturesPng,
                height: "100px",
                width: "100px"
              },
              name: "Sony Pictures"
            }, {
              destination: "",
              image: {
                alt: "Twitter",
                asset_static: logos.logoTwitterPng,
                height: "100px",
                width: "100px"
              },
              name: "Twitter"
            }, {
              destination: "",
              image: {
                alt: "Vodafone",
                asset_static: logos.logoVodafonePng,
                width: "150px"
              },
              name: "Vodafone"
            }, {
              destination: "",
              image: {
                alt: "EON",
                asset_static: logos.logoEonPng,
                width: "100px"
              },
              name: "EON"
            }],
            title: {
              align: "center",
              content: "Leading brands use language solutions from Rosetta Stone Enterprise",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 4 - Enterprise Solutions",
            layout: "carousel",
            panels: [{
              body: null,
              custom: {
                body: {
                  content: "Regardless of industry, language barriers present a complex problem to solve for any organisation. The good news is that flexible, immersive language tools help set your team up for success by maximising collaboration and employee engagement in a way that aligns with your larger business strategy."
                },
                cta: {
                  destination: "/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Learn More"
                },
                list: ["Drive down language training costs across your organisation", "Attract and retain top-tier talent", "Improve communication and collaboration", "Foster a customer-obsessed work culture"]
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Curators of their own experience.",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "With enterprise language solutions from Rosetta Stone you can:",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }],
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone for Enterprise | Rosetta Stone",
          meta_description: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/",
          lang: "en"
        },
        content: {
          sections: [{
            lead_generation_button: {
              schedule_appointment: false,
              completion_redirect: null,
              button: {
                destination: "/pricing-request/",
                internal: true,
                new_window: false,
                size: "regular",
                text: "Price Enquiry",
                theme: "yellow_black"
              }
            },
            demo_button: {
              destination: "https://www.rosettastone.com/lp/ee_demo/",
              internal: false,
              new_window: false,
              size: "regular",
              text: "Try The Demo",
              theme: "yellow_black"
            },
            data_qa: "Header",
            sub_title: {
              align: "center",
              content: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
              theme: "white",
              type: "page-sub-title"
            },
            title: {
              align: "center",
              content: "Language training for enterprise teams.",
              heading: "h1",
              theme: "white",
              type: "page-title"
            },
            visible: true
          }, {
            title: {
              align: "center",
              content: "A proven enterprise language solution.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 2 - Cards",
            layout: "carousel",
            panels: [{
              body: {
                align: "center",
                content: "Invest in employee success. Help them learn a new language on any device—online or offline.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseTopTalentMp4,
                type: "video/mp4"
              },
              title: {
                align: "center",
                content: "Retain Top Talent",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Save big when you switch from face-to-face instructors to online language tutors.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseCutCostsMp4,
                type: "video/mp4"
              },
              title: {
                content: "Cut Costs",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Help your employees speak and work confidently across language barriers.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseWorkBetterMp4,
                type: "video/mp4"
              },
              title: {
                content: "Work Better Together",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Track, measure, and optimize your language training programs for learner success with detailed learner dashboards. ",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseLearnerSuccessMp4,
                type: "video/mp4"
              },
              title: {
                content: "Enable Learner Success",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }]
          }, {
            data_qa: "Section 3 - Animation Text",
            layout: "list",
            panels: [{
              animation: {
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              body: {
                content: "Going from many language providers to a single, proven online platform is a clear cost-saver. Give your employees flexible language learning tools that help immerse them in everyday speaking at the pace and place of their choosing."
              },
              custom: {
                cta_1: {
                  destination: "https://www.rosettastone.co.uk/enterprise/experience/making-the-case/?eeid=oo-e1-co&campaignid=7010W0000027w78&utm_campaign=US-CORP-content-traffic&utm_source=content&utm_content=",
                  internal: false,
                  new_window: false,
                  size: "regular",
                  text: "Show me the guide",
                  theme: "yellow_black"
                }
              },
              data_qa: null,
              direction: "image-right"
            }],
            title: {
              align: "center",
              content: "Making the case for online training.",
              heading: "h2",
              justifyContent: "flex-start",
              theme: "blue",
              type: "page-title"
            },
            visible: true
          }, {
            custom: {
              cta_1: {
                destination: "/resources/content/a-decade-of-language-training-success/",
                internal: true,
                new_window: false,
                size: "regular",
                theme: "yellow_black",
                text: "Read the latest customer story"
              }
            },
            data_qa: "Section 4 - Brand Images",
            layout: "list",
            panels: awards$1({
              strings: strings
            }).panels,
            title: {
              align: "center",
              content: "Join 12,000+ leading organizations.",
              heading: "h2",
              theme: "blue",
              type: "page-title"
            },
            visible: true
          }],
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-consulting":
      return {
        page: page,
        eloquaPage: "consulting",
        helmet: {
          meta_title: "Language Training for Consulting | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/consulting/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              body: {
                content: "There are plenty of barriers that limit consulting firms from expanding into new markets—chief among them is the language barrier. By providing your entire organization with language training you greatly improve the prospects of profitable expansion into new regions."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/consulting/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Speak every new client’s language.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              video: {
                controls: true,
                currentVideoUrl: "https://player.vimeo.com/video/591202724"
              }
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [],
            title: {
              align: "center",
              content: "Proven language solutions for leading hospitality organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Your organization may have some of the industry’s brightest consultants, but a lack of language skills may be causing significant work inefficiencies. Improve productivity with a broader multilingual talent pool."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Collaborate globally.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "The best and brightest are hard to retain because top talent in the professional consulting industry is on every firm’s radar. Adding language training to your professional development mix can help you differentiate from your competitors and alleviate the strain of turnover costs."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Drive down turnover.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Corporations lose millions each year from employee turnover, making it a top organisational challenge. Investing in language training for employees can enhance your retention initiatives by enabling your staff to grow in their careers."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Attract and retain top talent.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: "Keep Exploring",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-financial":
      return {
        page: page,
        eloquaPage: "financial",
        helmet: {
          meta_title: "Language Training for Financial Services | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/financial",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "Money matters don’t stop at a border. And not all business is conducted in the same language. Learning your customer’s language helps to establish the personal trust that leads to profitable relationships."
              },
              custom: {
                cta_1: {
                  destination: "/resources/content/language-skills-critical-to-business-goals/",
                  internal: true,
                  new_window: false,
                  size: "regular",
                  text: "Read the Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/financial/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Invest in your client’s language.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }, {
              dataQa: "2",
              body: {
                content: "Finances are personal. Customers want to be sure you understand their needs. If there is a language gap, employees have to navigate the conversation. Including language training in your professional development program can close that gap and increase employee loyalty toward your business."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Attract business, retain employees.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "3",
              body: {
                content: "Working well together is one place employee productivity starts. When language barriers get in the way, collaboration suffers and good ideas remain unspoken. Online language training gives your employees a proven path to better communication."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Collaboration connects colleagues.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2"
          }, {
            dataQa: "3"
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-logistics":
      return {
        page: page,
        eloquaPage: "logistics",
        helmet: {
          meta_title: "Transport and Logistics | Rosetta Stone",
          meta_description: "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/logistics",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down."
              },
              custom: {
                cta_1: {
                  destination: "/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                  internal: true,
                  new_window: true,
                  size: "regular",
                  text: "Read Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/logistics/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Keep lines of communication open.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }, {
              dataQa: "2",
              body: {
                content: "Every employees’ job comes with some degree of safety risk. For transport and logistics companies, those risks ramp up considerably given the sheer volume of shipments and deliveries. Improving employees’ language skills helps them avoid miscommunications that contribute to costly safety incidents."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Reduce risk.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "3",
              body: {
                content: "Successful logistics depend on Point A having confidence that shipments will reach Point B as expected. When language barriers get in the way, it’s easy for collaboration to break down. Language training equips employees to better navigate today’s multinational transactions."
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Collaborate worldwide.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "4",
              body: {
                content: "Speaking with co-workers is essential, whether working side-by-side or on a global team. With Catalyst training, language obstacles come down, clarity replaces confusion, and work quality goes up."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Build a stronger team.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2"
          }, {
            dataQa: "3"
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-manufacturing":
      return {
        page: page,
        eloquaPage: "manufacturing",
        helmet: {
          meta_title: "Speak the global language of manufacturing.",
          meta_description: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organisation with language training goes a long way toward a profitable expansion into new regions.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/manufacturing",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organization with language training goes a long way toward a profitable expansion into new regions."
              },
              custom: {
                cta_1: {
                  destination: "/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                  internal: true,
                  new_window: false,
                  size: "regular",
                  text: "Read Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/manufacturing/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Speak the global language of manufacturing.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }, {
              dataQa: "2",
              body: {
                content: "Safety is on the mind of every manufacturing firm’s HR leader. While not all safety-related incidents are fatal, they are all expensive. One small misinterpretation of a safety protocol can lead to significant losses in just a single incident. Ensure you’re doing all you can to keep each employee safe. Equip them with flexible language training."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Make safety a priority.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "3",
              body: {
                content: "Language barriers across the modern warehouse can lead to loss of productivity and drops in quality when a multi-lingual workforce cannot communicate clearly. See the best work from everyone on the production line with language training."
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Reduce productivity barriers.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "4",
              body: {
                content: "Voluntary turnover costs the manufacturing industry millions of dollars each year. Add language training to your professional development programme to attract and retain the industry’s very best."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Drive down retention costs.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2"
          }, {
            dataQa: "3"
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-pharmaceutical":
      return {
        page: page,
        eloquaPage: "pharmaceutical",
        helmet: {
          meta_title: "Rosetta Stone | Pharmaceutical",
          meta_description: "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/pharmacuetical",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations."
              },
              custom: {
                cta_1: {
                  destination: "/resources/content/norgine-spotlight/",
                  internal: true,
                  new_window: true,
                  size: "regular",
                  text: "Read Case Study",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/pharmaceutical/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Add language to your formula for success.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }, {
              dataQa: "2",
              body: {
                content: "Global businesses are layered with communication challenges. Consider the range of languages your employees are likely to encounter, from internal teams to supply chain partners. Getting internal and external communications right supports your company’s complex and precise work."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Close communication gaps.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "3",
              body: {
                content: "Working smart also applies to language training. Having different training providers scattered around the globe is inefficient and costly. Offering your employees 24/7 global access to one language training platform ensures a consistent learning experience that’s shared with colleagues everywhere."
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Consolidate training.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "4",
              body: {
                content: "Language barriers highlight the need for better interpersonal communication. Your employees’ ability to speak and understand more than one language supports operational excellence. Pharmaceutical employers providing online language training enable their employees to learn anytime, anywhere."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Develop talent.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2"
          }, {
            dataQa: "3"
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "industry-retail":
      return {
        page: page,
        eloquaPage: "retail",
        helmet: {
          meta_title: "Language Training for Retail | Rosetta Stone",
          meta_description: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/retail",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences."
              },
              custom: {
                cta_1: {
                  destination: "/resources/content/customer-spotlight-stella-mccartney/",
                  internal: true,
                  new_window: true,
                  size: "regular",
                  text: "Read Case Study",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/retail/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Price Enquiry",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Speak the universal language of customer service.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }, {
              dataQa: "2",
              body: {
                content: "Retention is a top issue facing all retail establishments. Hourly Limited English Proficiency employees are among the most difficult and costly to attract and retain. Investing in language training for these employees can go a long way to bolster retention initiatives within your organization—setting you apart as an industry leader."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Attract and retain the best staff.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "3",
              body: {
                content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your physical locations. Close the communication gaps between your employees with language training solutions from Rosetta Stone."
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Bridge the communication gap.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              dataQa: "4",
              body: {
                content: "Whether your retail operations are regional, national, or global, customers like personal service. Language training helps employees make customers who are speakers of other languages feel comfortable in any of your retail settings."
              },
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Keep retail personal.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2"
          }, {
            dataQa: "3"
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$3({
            strings: strings
          })
        }
      };

    case "pricing-request":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Book time with a Language Expert today"
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Please fill out the form below to schedule time to discuss how we can help."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Almost there!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "First Name",
                required: true,
                required_error: "Please enter your First Name."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Last Name",
                required: true,
                required_error: "Please enter your Last Name."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Email Address",
                required: true,
                required_error: "Please enter your Email Address.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Phone Number",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Company",
                required: true,
                required_error: "Please enter your Company Name."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Company Size",
                required: true,
                required_error: "Please enter your Company Size.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 or Less",
                  label: "100 or Less"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 or More",
                  label: "50,001 or More"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Title",
                required: true,
                required_error: "Please enter your Role."
              },
              explicitOptIn: {
                field_name: "explicitOptIn",
                required: false
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Price Enquiry"
            },
            labels: {
              form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
              form_privacy2: "Privacy Policy",
              form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
              form_privacy4: ".",
              form_privacyUrl: "https://www.rosettastone.com/privacy",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
              form_updateagreement2: "here",
              form_updateagreement3: "for more information."
            },
            domain: ".co.uk",
            dataQaLocation: "page"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          })
        }
      };

    case "pricing-request-complete":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/k12/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            align: "center",
            content: "Thanks for your interest!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Check out some additional resources before your meeting!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/resources/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Resources",
            theme: "blue_white"
          },
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          })
        }
      };

    case "pricing-request-schedule":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.co.uk/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          awards: awards$1({
            strings: strings
          }),
          branded_quotes: branded_quotes$1({
            strings: strings
          }),
          verticals: verticals$3({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.co.uk",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/schools/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: false,
          destination: "https://www.rosettastone.co.uk/higher-education/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_secondary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/enterprise/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.co.uk/about/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/magazine",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.co.uk/contact",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.co.uk/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/uk/pdfs/website-privacy-policy-uk.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "twitter",
          destination: "https://twitter.com/RosettaStoneUK",
          image: social.twitterDarkSvg
        }, {
          service: "linkedin",
          destination: "https://www.linkedin.com/company/rosettastone/",
          image: social.linkedinDarkPng
        }]
      }
    }
  };
});

var uk = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config$1({
        page: page,
        strings: strings
      });
      page_config = enterprise_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config$1({
        page: page,
        strings: strings
      });
      break;

    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config$1({
        page: page,
        strings: strings
      });
      page_config = education_primary_pages_config$1({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config$1({
        page: page,
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config$1({
    strings: strings,
    page: page
  });
  return {
    market: market,
    site: site,
    vertical: site,
    locale: locale,
    analytics: analytics$1,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var analytics = {
  gtm_id: "GTM-TLH67WS"
};

var nav_primary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://blog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_blog_label
    },
    contact: {
      visible: true,
      destination: "/contact/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_primary_contact_label
    },
    rs_logo: {
      visible: true,
      image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
      },
      link: {
        destination: "/",
        external: false,
        new_window: false
      }
    },
    phone: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      destination: "tel:18007673882",
      label: strings.nav_primary_phone_label,
      number: strings.nav_primary_phone_number
    },
    select_language: {
      visible: true,
      external: false,
      new_window: false,
      // Labels
      language_options_featured: [{
        url: "/buy-spanish/",
        title: strings.locale_es_la_label_primary,
        small: strings.locale_es_la_label_secondary
      }, {
        url: "/buy-french/",
        title: strings.locale_fr_fr_label_primary,
        small: strings.locale_fr_fr_label_secondary
      }, {
        url: "/buy-italian/",
        title: strings.locale_it_it_label_primary,
        small: strings.locale_it_it_label_secondary
      }, {
        url: "/buy-german/",
        title: strings.locale_de_de_label_primary,
        small: strings.locale_de_de_label_secondary
      }, {
        url: "/buy-english/",
        title: strings.locale_en_us_label_primary,
        small: strings.locale_en_us_label_secondary
      }],
      language_options_other: [{
        url: "/buy-arabic/",
        title: strings.locale_ar_ar_label_primary,
        small: strings.locale_ar_ar_label_secondary
      }, {
        url: "/buy-chinese/",
        title: strings.locale_zn_cn_label_primary,
        small: strings.locale_zn_cn_label_secondary
      }, {
        url: "/buy-dutch/",
        title: strings.locale_nl_nl_label_primary,
        small: strings.locale_nl_nl_label_secondary
      }, {
        url: "/buy-english-british/",
        title: strings.locale_en_gb_label_primary,
        small: strings.locale_en_gb_label_secondary
      }, {
        url: "/buy-tagalog/",
        title: strings.locale_tl_ph_label_primary,
        small: strings.locale_tl_ph_label_secondary
      }, {
        url: "/buy-greek/",
        title: strings.locale_el_gr_label_primary,
        small: strings.locale_el_gr_label_secondary
      }, {
        url: "/buy-hebrew/",
        title: strings.locale_he_il_label_primary,
        small: strings.locale_he_il_label_secondary
      }, {
        url: "/buy-hindi/",
        title: strings.locale_hi_in_label_primary,
        small: strings.locale_hi_in_label_secondary
      }, {
        url: "/buy-irish/",
        title: strings.locale_ga_ie_label_primary,
        small: strings.locale_ga_ie_label_secondary
      }, {
        url: "/buy-japanese/",
        title: strings.locale_ja_jp_label_primary,
        small: strings.locale_ja_jp_label_secondary
      }, {
        url: "/buy-korean/",
        title: strings.locale_ko_kr_label_primary,
        small: strings.locale_ko_kr_label_secondary
      }, {
        url: "/buy-farsi/",
        title: strings.locale_fa_ir_label_primary,
        small: strings.locale_fa_ir_label_secondary
      }, {
        url: "/buy-polish/",
        title: strings.locale_pl_pl_label_primary,
        small: strings.locale_pl_pl_label_secondary
      }, {
        url: "/buy-portuguese/",
        title: strings.locale_pt_br_label_primary,
        small: strings.locale_pt_br_label_secondary
      }, {
        url: "/buy-russian/",
        title: strings.locale_ru_ru_label_primary,
        small: strings.locale_ru_ru_label_secondary
      }, {
        url: "/buy-spanish-spain/",
        title: strings.locale_es_es_label_primary,
        small: strings.locale_es_es_label_secondary
      }, {
        url: "/buy-swedish/",
        title: strings.locale_sv_se_label_primary,
        small: strings.locale_sv_se_label_secondary
      }, {
        url: "/buy-turkish/",
        title: strings.locale_tr_tr_label_primary,
        small: strings.locale_tr_tr_label_secondary
      }, {
        url: "/buy-vietnamese/",
        title: strings.locale_vi_vn_label_primary,
        small: strings.locale_vi_vn_label_secondary
      }],
      select_language_label: strings.nav_primary_catalog_select_language_label,
      label: strings.nav_primary_catalog_label,
      product_title: strings.global_brand_name
    },
    sign_in: {
      visible: true,
      destination: "https://www.rosettastone.com/login",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_sign_in_label
    },
    switch_language: {
      visible: true,
      destination: "https://espanol.rosettastone.com/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_switch_language
    },
    support: {
      visible: true,
      destination: "https://support.rosettastone.com/en/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_support_label
    },
    vertical_consumer: {
      visible: false,
      destination: "/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
      visible: false,
      destination: "/homeschool/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
      visible: true,
      destination: "/k12/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
      visible: false,
      destination: "/highereducation/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
      visible: false,
      destination: "/students/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
      visible: true,
      destination: "/enterprise/",
      external: true,
      new_window: false,
      // Labels
      label: strings.nav_primary_vertical_enterprise_label
    }
  };
});

var awards = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.awards_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.awards_twitter,
        asset_static: logosTiles.logosTilesTwitterSvg
      }
    }, {
      image: {
        alt: strings.awards_bmw,
        asset_static: logosTiles.logosTilesBmwSvg
      }
    }, {
      image: {
        alt: strings.awards_uber,
        asset_static: logosTiles.logosTilesUberSvg
      }
    }, {
      image: {
        alt: strings.awards_williams_sonoma,
        asset_static: logosTiles.logosTilesWsSvg
      }
    }, {
      image: {
        alt: strings.awards_lego,
        asset_static: logosTiles.logosTilesLegoSvg
      }
    }]
  };
});

var branded_quotes = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.branded_quotes_header_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      name: strings.branded_quotes_macworld_name,
      type: strings.branded_quotes_macworld_type,
      quote: strings.branded_quotes_macworld_quote,
      logo: {
        asset_static: logos.logoMacworldSvg
      },
      backdrop: logos.logoMacworldBgSvg
    }, {
      name: strings.branded_quotes_techcrunch_name,
      type: strings.branded_quotes_techcrunch_type,
      quote: strings.branded_quotes_techcrunch_quote,
      logo: {
        asset_static: logos.logoTechcrunchSvg
      },
      backdrop: logos.logoTechcrunchBgSvg
    }, {
      name: strings.branded_quotes_cnn_name,
      type: strings.branded_quotes_cnn_type,
      quote: strings.branded_quotes_cnn_quote,
      logo: {
        asset_static: logos.logoCnnSvg
      },
      backdrop: logos.logoCnnBgSvg
    }]
  };
});

var email_collection_bar$4 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "US_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "Sign up",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Email Address",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Get Rosetta Stone news and offers.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Thanks for signing up.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "E-mail is invalid.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Sign up to stay in touch.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "By signing up, I agree to the",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: null,
      // "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "terms and conditions",
      theme: "white",
      underline: "on"
    },
    privacy_tooltip: {
      title: {
        type: "card-title",
        theme: "white",
        content: "Terms and Conditions",
        align: "center"
      },
      body: {
        align: "left",
        theme: "white",
        dangerous: false,
        content: /*#__PURE__*/React.createElement("div", null, "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\xA0", /*#__PURE__*/React.createElement("a", {
          href: "https://www.rosettastone.com/privacy",
          title: "Privacy Policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy"), ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \xA0", /*#__PURE__*/React.createElement("a", {
          href: "mailto: privacyofficer@rosettastone.com",
          title: "privacyofficer@rosettastone.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacyofficer@rosettastone.com"), ".")
      }
    }
  };
});

var consumer_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
          meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
          canonical_url: "https://www.rosettastone.com/",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    case "leadership":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® Leadership",
          meta_description: "Find out more about Rosetta Stone's Leadership.",
          canonical_url: "https://www.rosettastone.com/leadership/",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    case "mobile-apps":
      return {
        page: page,
        helmet: {
          meta_title: "Language Learning Mobile Apps &mdash; Rosetta Stone",
          meta_description: "Learn to speak a new language with the official Rosetta Stone: Learn Languages mobile app.",
          canonical_url: "https://www.rosettastone.com/mobile-apps/",
          lang: "en"
        },
        content: {
          topImageTextSections: {
            panels: [{
              dataQa: "1",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-right",
              maxWidth: 60,
              padding: "50px 0",
              body: {
                dangerously: true,
                content: strings.mobile_apps_top_section_one_body_content,
                align: "left"
              },
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_one_title_content,
                heading: "h1",
                type: "section-title",
                theme: "black"
              },
              image: {
                asset_static: images.mobileAppsImage_1Jpg
              },
              custom: {
                cta: {
                  destination: "https://www.rosettastone.com/freetrial/",
                  new_window: true,
                  size: "regular",
                  text: strings.mobile_apps_top_section_one_custom_cta_text,
                  theme: "blue_white"
                },
                awards: [{
                  asset_static: awards$9.awardPcMagPng,
                  destination: "https://www.pcmag.com/roundup/261786/the-best-language-learning-software",
                  new_window: true,
                  width: "250px",
                  align_items: "flex-start"
                }]
              }
            }, {
              dataQa: "2",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-left",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_two_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_two_body_content,
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_2Jpg
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_two_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_three
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_four,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_four
              }, {
                heading: strings.mobile_apps_top_section_two_feature_heading_content_five,
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_five
              }, {
                subHeading: strings.mobile_apps_top_section_two_feature_subheading_content_six
              }]
            }, {
              dataQa: "3",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-right",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_top_section_three_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_top_section_three_body_content,
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_3Png
              },
              sectionFeatureBullets: [{
                heading: strings.mobile_apps_top_section_three_feature_heading_content_one,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_one
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_two,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_two
              }, {
                heading: strings.mobile_apps_top_section_three_feature_heading_content_three,
                subHeading: strings.mobile_apps_top_section_three_feature_subheading_content_three
              }]
            }]
          },
          mobileOsLogos: {
            layout: "list",
            title: {
              align: "center",
              theme: "black",
              type: "section-title",
              content: strings.mobile_apps_os_logos_title_content,
              heading: "h2"
            },
            subtitle: {
              align: "center",
              theme: "black",
              type: "section-sub-title",
              content: strings.mobile_apps_os_logos_subtitle_content
            },
            padding: "25px 0",
            panels: [{
              image: {
                alt: "",
                asset_static: logos.logoIosSvg,
                destination: "https://rosettastone.onelink.me/zwaO/f670c3a0",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoAppleWatchSvg
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoAndroidSvg,
                destination: "https://play.google.com/store/apps/details?id=air.com.rosettastone.mobile.CoursePlayer&hl=en_US&gl=US",
                new_window: true
              }
            }, {
              image: {
                alt: "",
                asset_static: logos.logoSamsungSvg
              }
            }]
          },
          bottomImageTextSection: {
            panels: [{
              dataQa: "4",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-left",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: strings.mobile_apps_bottom_section_one_title_content,
                heading: "h2",
                type: "section-title",
                theme: "black"
              },
              body: {
                content: strings.mobile_apps_bottom_section_one_body_content,
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_4Jpg
              }
            }]
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    case "opdemo2":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® - Try Our Free Demo",
          meta_description: "Learn a new language with Rosetta Stone, the #1 language learning platform. Try a free online interactive demo today.",
          canonical_url: "https://www.rosettastone.com/demo/",
          lang: "en"
        },
        content: {
          hero: {
            heading: {
              type: "section-title",
              align: "center",
              heading: "h1",
              content: strings.opdemo2_hero_heading
            },
            subHeading: {
              type: "page-sub-title",
              align: "center",
              heading: "p",
              content: strings.opdemo2_hero_subheading
            },
            buttonHeading: {
              align: "center"
            },
            button: {
              custom: {
                cta: {
                  destination: "https://www.rosettastone.com/lp/tryitnow",
                  new_window: true,
                  size: "regular",
                  text: strings.opdemo2_button_custom_cta_text,
                  theme: "blue_white"
                }
              }
            }
          },
          topImageTextSections: {
            panels: [{
              dataQa: "1",
              layout: "list",
              direction: "image-right",
              title: {
                align: "left",
                content: strings.opdemo2_top_section_one_title_content,
                heading: "h3",
                type: "card-title",
                theme: "black"
              },
              body: {
                content: strings.opdemo2_top_section_one_body_content,
                align: "left",
                theme: "black"
              },
              image: {
                asset_static: images.opdemo2ProvenMethodPng
              }
            }, {
              dataQa: "2",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-left",
              title: {
                align: "left",
                content: strings.opdemo2_top_section_two_title_content,
                heading: "h3",
                type: "card-title",
                theme: "black"
              },
              body: {
                content: strings.opdemo2_top_section_one_body_content,
                align: "left",
                theme: "black"
              },
              image: {
                asset_static: images.opdemo2TruaccentPng
              }
            }, {
              dataQa: "3",
              layout: "list",
              justifyContent: "space-between",
              direction: "image-right",
              title: {
                align: "left",
                content: strings.opdemo2_top_section_three_title_content,
                heading: "h3",
                type: "card-title",
                theme: "black"
              },
              body: {
                content: strings.opdemo2_top_section_three_body_content,
                align: "left",
                theme: "black"
              },
              image: {
                asset_static: images.opdemo2TutorScreenPng
              }
            }, {
              dataQa: "4",
              layout: "list",
              direction: "image-left",
              title: {
                align: "left",
                content: strings.opdemo2_top_section_four_title_content,
                heading: "h3",
                type: "card-title",
                theme: "black"
              },
              body: {
                content: strings.opdemo2_top_section_four_body_content,
                align: "left",
                theme: "black"
              },
              image: {
                asset_static: images.opdemo2AudioCompanionPng
              }
            }, {
              dataQa: "5",
              layout: "list",
              direction: "image-right",
              title: {
                align: "left",
                content: strings.opdemo2_top_section_five_title_content,
                heading: "h3",
                type: "card-title",
                theme: "black"
              },
              body: {
                content: strings.opdemo2_top_section_five_body_content,
                align: "left",
                theme: "black"
              },
              image: {
                asset_static: images.opdemo2OnlineLockupPng
              }
            }]
          },
          bottomImageSection: {
            panels: [{
              dataQa: "6",
              layout: "list",
              direction: "image-left",
              titleHeading: strings.opdemo2_bottom_section_title_heading,
              image: {
                asset_static: images.opdemo2PhonePng
              },
              sectionFeatureBullets: [{
                heading: strings.opdemo2_bottom_section_feature_bullet_one_heading,
                subHeading: strings.opdemo2_bottom_section_feature_bullet_one_subheading
              }, {
                heading: strings.opdemo2_bottom_section_feature_bullet_two_heading,
                subHeading: strings.opdemo2_bottom_section_feature_bullet_two_subheading
              }, {
                heading: strings.opdemo2_bottom_section_feature_bullet_three_heading,
                subHeading: strings.opdemo2_bottom_section_feature_bullet_three_subheading
              }, {
                subHeading: strings.opdemo2_bottom_section_feature_bullet_four_subheading
              }, {
                subHeading: strings.opdemo2_bottom_section_feature_bullet_five_subheading
              }, {
                subHeading: strings.opdemo2_bottom_section_feature_bullet_six_subheading
              }]
            }]
          },
          productUnitCards: {
            panels: [{
              label: strings.opdemo2_unit_card_one_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_one_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_one_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_1ApplePng
              },
              color: "#FBC000"
            }, {
              label: strings.opdemo2_unit_card_two_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_two_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_two_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_2TeaPng
              },
              color: "#A9CB1F"
            }, {
              label: strings.opdemo2_unit_card_three_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_three_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_three_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_3PencilPng
              },
              color: "#ED360B"
            }, {
              label: strings.opdemo2_unit_card_four_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_four_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_four_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_4WalletPng
              },
              color: "#84CCDD"
            }, {
              label: strings.opdemo2_unit_card_five_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_five_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_five_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_5PassportPng
              },
              color: "#FBC000"
            }, {
              label: strings.opdemo2_unit_card_six_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_six_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_six_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_6PastFuturePng
              },
              color: "#A9CB1F"
            }, {
              label: strings.opdemo2_unit_card_seven_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_seven_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_seven_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_7MobilePng
              },
              color: "#ED360B"
            }, {
              label: strings.opdemo2_unit_card_eight_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_eight_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_eight_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_8DiningPng
              },
              color: "#84CCDD"
            }, {
              label: strings.opdemo2_unit_card_nine_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_nine_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_nine_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_9HealthPng
              },
              color: "#FBC000"
            }, {
              label: strings.opdemo2_unit_card_ten_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_ten_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_ten_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_10LifePng
              },
              color: "#A9CB1F"
            }, {
              label: strings.opdemo2_unit_card_eleven_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_eleven_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_eleven_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_11EverydayThingsPng
              },
              color: "#ED360B"
            }, {
              label: strings.opdemo2_unit_card_twelve_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_twelve_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_twelve_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_12PlacesEventsPng
              },
              color: "#84CCDD"
            }, {
              label: strings.opdemo2_unit_card_thirteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_thirteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_thirteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_13TourismPng
              },
              color: "#FBC000"
            }, {
              label: strings.opdemo2_unit_card_fourteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_fourteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_fourteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_14ProfessionPng
              },
              color: "#A9CB1F"
            }, {
              label: strings.opdemo2_unit_card_fifteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_fifteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_fifteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_15AtHomePng
              },
              color: "#ED360B"
            }, {
              label: strings.opdemo2_unit_card_sixteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_sixteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_sixteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_16StylePng
              },
              color: "#84CCDD"
            }, {
              label: strings.opdemo2_unit_card_seventeen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_seventeen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_seventeen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_17BusinessPng
              },
              color: "#FBC000"
            }, {
              label: strings.opdemo2_unit_card_eighteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_eighteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_eighteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_18ArtPng
              },
              color: "#A9CB1F"
            }, {
              label: strings.opdemo2_unit_card_nineteen_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_nineteen_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_nineteen_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_19EmergencyPng
              },
              color: "#ED360B"
            }, {
              label: strings.opdemo2_unit_card_twenty_unit_content,
              unit: {
                content: strings.opdemo2_unit_card_twenty_unit_content,
                type: "unit-card-title"
              },
              description: {
                content: strings.opdemo2_unit_card_twenty_description_content,
                type: "unit-card-sub-title"
              },
              icon: {
                asset_static: productUnits.productUnit_20FamilyPng
              },
              color: "#84CCDD"
            }]
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    case "retail":
      return {
        page: page,
        helmet: {
          meta_title: "These Rosetta Stone Retailers Can Help You Speak For Yourself",
          meta_description: "Speak up before you head out with Rosetta Stone immersive language learning software and award-winning mobile app, available at these retail locations.",
          canonical_url: "https://www.rosettastone.com/retail/",
          lang: "en"
        },
        content: {
          sections: [{
            panels: [{
              title: {
                align: "left",
                content: "These Rosetta Stone Retailers Can Help You Speak For Yourself",
                type: "page-title",
                heading: "h1"
              },
              sub_title: {
                type: "page-sub-title",
                heading: "h2",
                align: "center",
                content: "Say it like a local with language learning that never leaves your side, available at these Rosetta Stone retail locations."
              },
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              padding: "50px 0",
              direction: "image-right",
              body: {
                dangerous: true,
                align: "left",
                content: "Come to any of our retail locations and discover why Rosetta Stone has over 25 years of experience helping millions of language learners worldwide to speak for themselves. With 24 languages to choose from, our dynamic, immersive lessons and award-winning <a href='https://www.rosettastone.com/lp/mobile-apps/' target='_blank'>mobile app</a> will help you thrive in real-world conversations."
              },
              dataQa: "QA"
            }]
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    case "reviews":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® Reviews",
          meta_description: "We teach language learners to speak for themselves, but don’t take our word for it. Read reviews of Rosetta Stone from the people who know us best–our customers.",
          canonical_url: "https://www.rosettastone.com/reviews",
          lang: "en"
        },
        content: {
          topImagePageSection: {
            panels: [{
              title: {
                align: "left",
                content: "Rosetta Stone reviews",
                type: "page-title",
                heading: "h1"
              },
              maxWidth: 60,
              padding: "50px 0",
              direction: "image-right",
              image: {
                asset_static: images.mobileAppsImage_1Jpg
              },
              body: {
                align: "left",
                content: "We love it when people speak up. Here, you can read reviews from people who have used Rosetta Stone firsthand."
              },
              custom: {
                appStoreRatings: {
                  app_store: {
                    destination: "",
                    label: "App Store",
                    url: "/"
                  },
                  labels: {
                    check_it_out: "Check it out in the",
                    out_of: "out of",
                    ratings: "ratings"
                  },
                  ratings: {
                    graphBars: [{
                      stars: 5,
                      percentage: 84
                    }, {
                      stars: 4,
                      percentage: 11
                    }, {
                      stars: 3,
                      percentage: 2
                    }, {
                      stars: 2,
                      percentage: 1
                    }, {
                      stars: 1,
                      percentage: 2
                    }],
                    customerRatings: "4.8",
                    totalRatings: "108.7K"
                  }
                }
              }
            }, {
              direction: "image-left",
              title: {
                content: "Read Rosetta Stone reviews from real customers.",
                type: "section-title",
                heading: "h2",
                align: "left"
              },
              body: {
                content: "One glance at reviews of Rosetta Stone, and you’ll see we pride ourselves on our ability to help language learners thrive in real-world conversations. With dynamic, immersive bite-sized lessons and an award-winning mobile app, you can learn anytime and anywhere with language that never leaves your side.\n" + "\n" + "However, rather than monopolizing the conversation with our accolades, we’ll do what Rosetta Stone does best—encourage our customers to speak for themselves.",
                align: "left"
              },
              image: {
                asset_static: images.mobileAppsImage_2Jpg
              },
              maxWidth: 60,
              padding: "50px 0",
              dataQa: "QA"
            }]
          },
          videoPlayerPageSection: {
            heading: "Looking for videos of real learners?",
            paragraph: "Watch Rosetta Stone empower life-changing decisions, compassionate service, purposeful exploration, and much more in the lives of real language learners.",
            videos: [{
              video_url: "https://www.youtube.com/embed/-zXupH0XmmY",
              asset_url: images.reviewsVideoAntoniaPng
            }, {
              video_url: "https://www.youtube.com/embed/ZOwb57bx4mA",
              asset_url: images.reviewsVideoChrisPng
            }, {
              video_url: "https://www.youtube.com/embed/g6WEYqaMFsk",
              asset_url: images.reviewsVideoGracePng
            }, {
              video_url: "https://www.youtube.com/embed/KwFphr58e94",
              asset_url: images.reviewsVideoDelainePng
            }, {
              video_url: "https://www.youtube.com/embed/kp8VyQmDGdE",
              asset_url: images.reviewsVideoMarkPng
            }, {
              video_url: "https://www.youtube.com/embed/X7zcMsQ9fSI",
              asset_url: images.reviewsVideoNunoPng
            }]
          },
          bottomImagePageSection: {
            panels: [{
              direction: "image-right",
              maxWidth: 60,
              padding: "50px 0",
              title: {
                align: "left",
                content: "Need another reason?",
                type: "section-title",
                heading: "h2"
              },
              body: {
                content: "There are countless reasons why people learn new languages. Have you thought of why you should learn another language? Or even wondered where to start when starting a new language? Or simply wonder just how long will it take to get conversational? All we can promise is that the longer you wait the longer it’ll take. So, consider setting a language-learning goal. <br /> <br />Whether you practice for a day, a month or years, having a language goal–and a weekly routine to hold yourself accountable– goes a long way when learning to speak a new language well. Whether your reason for speaking a new language is a simple as traveling somewhere new or deeper than wanting to feel how your heritage sounds coming off your own lips, Rosetta Stone is committed to helping you confidently speak another language for yourself.",
                align: "left",
                dangerous: true
              },
              image: {
                asset_static: images.mobileAppsImage_4Jpg
              },
              dataQa: "QA"
            }]
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$4({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "us",
      domain: ".com",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/idiomas/aprender-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_portugues_label
        }, {
          visible: true,
          destination: "/gift/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gifts_label
        }, {
          visible: true,
          destination: "/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/languages/learn-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_spanish_label
        }, {
          visible: true,
          destination: "/languages/learn-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/languages/learn-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/languages/learn-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }, {
          visible: true,
          destination: "/languages/learn-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/languages/learn-japanese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_japanese_label
        }, {
          visible: true,
          destination: "/languages/learn-chinese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_chinese_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_ingles_label
        }, {
          visible: true,
          destination: "/languages/learn-language/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_languages_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/tryitnow/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonials/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "/speech-recognition/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_speech_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }, {
          visible: true,
          destination: "/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/retail/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/student-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_student_discount_label
        }, {
          visible: true,
          destination: "/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_military_discount_label
        }, {
          visible: true,
          destination: "/frontline-discount/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_frontline_discount_label
        }, {
          visible: true,
          destination: "/teacher-discount/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_teacher_discount_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }, {
          visible: true,
          destination: "/coaches/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_coaches_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "/system-requirements/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "/lp/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar$3 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "US_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "Sign up",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Email Address",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Get Rosetta Stone news and offers.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Thanks for signing up.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "E-mail is invalid.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Sign up to stay in touch.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "By signing up, I agree to the",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: null,
      // "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "terms and conditions",
      theme: "white",
      underline: "on"
    },
    privacy_tooltip: {
      title: {
        type: "card-title",
        theme: "white",
        content: "Terms and Conditions",
        align: "center"
      },
      body: {
        align: "left",
        theme: "white",
        dangerous: false,
        content: /*#__PURE__*/React.createElement("div", null, "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\xA0", /*#__PURE__*/React.createElement("a", {
          href: "https://www.rosettastone.com/privacy",
          title: "Privacy Policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy"), ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \xA0", /*#__PURE__*/React.createElement("a", {
          href: "mailto: privacyofficer@rosettastone.com",
          title: "privacyofficer@rosettastone.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacyofficer@rosettastone.com"), ".")
      }
    }
  };
});

var consumer_seo_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          trustpilot: true,
          lang: "en"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://www.rosettastone.com/lp/tryitnow/?ocid=seo-sticky",
              text: "Start Free Trial"
            }
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          email_collection_bar: email_collection_bar$3({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_seo_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "us",
      domain: ".com",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/idiomas/aprender-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_portugues_label
        }, {
          visible: true,
          destination: "/gift/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gifts_label
        }, {
          visible: true,
          destination: "/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/languages/learn-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_spanish_label
        }, {
          visible: true,
          destination: "/languages/learn-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/languages/learn-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/languages/learn-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }, {
          visible: true,
          destination: "/languages/learn-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/languages/learn-japanese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_japanese_label
        }, {
          visible: true,
          destination: "/languages/learn-chinese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_chinese_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_ingles_label
        }, {
          visible: true,
          destination: "/languages/learn-language/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_languages_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/tryitnow/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonials/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "/speech-recognition/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_speech_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }, {
          visible: true,
          destination: "/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/retail/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/student-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_student_discount_label
        }, {
          visible: true,
          destination: "/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_military_discount_label
        }, {
          visible: true,
          destination: "/frontline-discount/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_frontline_discount_label
        }, {
          visible: true,
          destination: "/teacher-discount/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_teacher_discount_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }, {
          visible: true,
          destination: "/coaches/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_coaches_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "/system-requirements/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "/lp/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar$2 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "US_WEBSITE",
    demo_type: "offer_signup",
    newsletter_type: "footer_signup",
    language: "ENG",
    button: {
      text: "Sign up",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Email Address",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "Get Rosetta Stone news and offers.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Thanks for signing up.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "E-mail is invalid.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Sign up to stay in touch.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "By signing up, I agree to the",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: null,
      // "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "terms and conditions",
      theme: "white",
      underline: "on"
    },
    privacy_tooltip: {
      title: {
        type: "card-title",
        theme: "white",
        content: "Terms and Conditions",
        align: "center"
      },
      body: {
        align: "left",
        theme: "white",
        dangerous: false,
        content: /*#__PURE__*/React.createElement("div", null, "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\xA0", /*#__PURE__*/React.createElement("a", {
          href: "https://www.rosettastone.com/privacy",
          title: "Privacy Policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy"), ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \xA0", /*#__PURE__*/React.createElement("a", {
          href: "mailto: privacyofficer@rosettastone.com",
          title: "privacyofficer@rosettastone.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacyofficer@rosettastone.com"), ".")
      }
    }
  };
});

var consumer_lausd_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Official Rosetta Stone® - Language Learning - Learn a Language",
          meta_description: "Rosetta Stone is the best way to learn a foreign language. The award-winning language solution combines proven learning methods with the world's best speech recognition technology.",
          canonical_url: "https://www.rosettastone.com/lausd/",
          lang: "en"
        },
        content: {
          heading: {
            layout: "list",
            wrapper: {
              backgroundColor: null,
              backgroundImage: null,
              gutter: "double"
            },
            panels: [{
              body: {
                content: ""
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fluid: null,
                height: null,
                width: null
              },
              justifyContent: "center",
              title: {
                align: "center",
                content: "Welcome to the LAUSD Rosetta Stone Hub",
                heading: "h1",
                theme: "white",
                type: "page-title"
              }
            }]
          },
          contacts: {
            layout: "list",
            wrapper: {
              backgroundColor: null,
              backgroundImage: null,
              gutter: true
            },
            custom: {
              title: {
                content: "Your dedicated Rosetta Stone team is here to help!",
                type: "section-sub-title"
              },
              contact_1_label: {
                content: "For sign-in support:"
              },
              contact_1_link: {
                theme: "blue",
                label: "supportLAUSD@rosettastone.com",
                destination: "mailto:supportLAUSD@rosettastone.com"
              },
              contact_2_label: {
                content: "For implementation and product support:"
              },
              contact_2_link: {
                theme: "blue",
                label: "LAUSD@rosettastone.com",
                destination: "mailto:LAUSD@rosettastone.com"
              }
            }
          },
          getting_started: {
            layout: "list",
            wrapper: {
              backgroundColor: "#EFFAFC",
              gutter: "double"
            },
            panels: [{
              body: null,
              custom: {
                list_button_1: {
                  theme: "white_blue",
                  text: "Install Rosetta Stone with Schoology",
                  destination: "https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-schoology-integration-guide-rs.pdf",
                  list_item_number: 1
                },
                list_button_2: {
                  theme: "white_blue",
                  text: "Sign in to Rosetta Stone through Schoology",
                  list_item_number: 2,
                  destination: "https://lausdschoology.azurewebsites.net/?&domain=lms.lausd.net&timestamp=1626272930",
                  new_window: true
                }
              },
              data_qa: null,
              direction: "image-right",
              video: {
                currentVideoUrl: "https://player.vimeo.com/video/579936506",
                playing: false,
                controls: true
              },
              justifyContent: "space-between",
              title: {
                align: "left",
                content: "Getting Started",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }]
          },
          helpful_resources: {
            layout: "list",
            wrapper: {
              backgroundColor: null,
              gutter: "double"
            },
            panels: [{
              body: null,
              custom: {
                li_1: 'Experience the student side of <a target="_blank" rel="noopener noreferrer" href="https://faculty-lausd.rosettastoneclassroom.com/en-US/">Rosetta Stone and model how to use the program</a> for your students.',
                li_2: 'Need more help? Check out these <a target="_blank" rel="noopener noreferrer" href="https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-rst-faq-troubleshooting.pdf">FAQs</a>.'
              },
              data_qa: null,
              direction: "image-right",
              justifyContent: "split",
              video: {
                playing: false,
                currentVideoUrl: "https://player.vimeo.com/video/579936632",
                controls: true
              },
              title: {
                align: "left",
                content: "Helpful Resources",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }]
          },
          teacher_resources: {
            layout: "list",
            wrapper: {
              backgroundColor: "#EFFAFC",
              gutter: "double",
              title: {
                align: "left",
                content: "Teacher Resources for English Language Learners",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            },
            panels: [{
              body: null,
              custom: {
                li_1: "<span>Use Rosetta Stone\u2019s <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://resources.rosettastone.com/support/SF/Resources/ScopeAndSequence.pdf\">Scope and Sequence</a> to see what students are learning in each unit.</span>",
                li_2: "<span>Explore a variety of <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.rosettastone.com/s/article/Supplemental-Resources-English-Learners?language=en_US\">printable resources</a> for teaching English Language Learners.</span>",
                li_3: "<span>Need help placing learners with previous language experience? Check out these <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.rosettastone.com/s/article/Getting-Started-in-Foundations-with-Previous-Experience?language=en_US\">helpful tips</a>.</span>"
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fluid: null,
                alt: "Teacher Resources for English Language Learners"
              },
              justifyContent: "split"
            }]
          },
          parent_resources: {
            layout: "list",
            wrapper: {
              backgroundColor: null,
              gutter: "double"
            },
            panels: [{
              body: null,
              custom: {
                li_1: "Learn how students can access <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-accessing-rs-from-home.pdf\">Rosetta Stone at home</a>.",
                li_2: "Descubra c\xF3mo los estudiantes pueden acceder a <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://resources.rosettastone.com/CDN/us/pdfs/lausd/lausd-spanish-accessing-rs-from-home.pdf\">Rosetta Stone en casa</a>."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fluid: null,
                alt: "Parent Resources"
              },
              justifyContent: "split",
              title: {
                align: "left",
                content: "Parent Resources",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }]
          },
          professional_development: {
            layout: "list",
            wrapper: {
              backgroundColor: "#EFFAFC",
              gutter: "double"
            },
            panels: [{
              body: {
                content: "Get Professional Development at no added cost for your school or district!"
              },
              custom: {
                cta_1: {
                  destination: "https://docs.google.com/forms/d/e/1FAIpQLSdB-pFfk3zw_CjcNQ2MVnn0KDVDk2JTOrpf7YENr4QM4ZnC7g/viewform",
                  internal: false,
                  new_window: true,
                  size: "regular",
                  text: "Request PD",
                  theme: "yellow_black"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fluid: null,
                alt: "Professional Development"
              },
              justifyContent: "split",
              title: {
                align: "left",
                content: "Professional Development",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }]
          },
          email_collection_bar: email_collection_bar$2({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var consumer_lausd_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: false,
      email_capture: true,
      market: "us",
      domain: ".com",
      vertical: "consumer",
      page: "home",
      // Strings
      main_label: strings.footer_cta_email_main_label,
      sub_label: strings.footer_cta_email_sub_label,
      button_label: strings.footer_cta_email_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      email_placeholder: strings.footer_cta_email_button
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_buy_label,
        links: [{
          visible: true,
          destination: "/buy-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_spanish_label
        }, {
          visible: true,
          destination: "/buy-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_french_label
        }, {
          visible: true,
          destination: "/buy-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_italian_label
        }, {
          visible: true,
          destination: "/buy-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_german_label
        }, {
          visible: true,
          destination: "/buy-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_english_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/idiomas/aprender-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_ingles_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_espanol_label
        }, {
          visible: true,
          destination: "/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_homeschool_label
        }, {
          visible: true,
          destination: "https://pt.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_buy_portugues_label
        }, {
          visible: true,
          destination: "/gift/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_gifts_label
        }, {
          visible: true,
          destination: "/buynow/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_all_label
        }]
      }, {
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "/languages/learn-spanish/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_spanish_label
        }, {
          visible: true,
          destination: "/languages/learn-french/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_french_label
        }, {
          visible: true,
          destination: "/languages/learn-italian/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_italian_label
        }, {
          visible: true,
          destination: "/languages/learn-german/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_german_label
        }, {
          visible: true,
          destination: "/languages/learn-english/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_english_label
        }, {
          visible: true,
          destination: "/languages/learn-japanese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_japanese_label
        }, {
          visible: true,
          destination: "/languages/learn-chinese/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_chinese_label
        }, {
          visible: true,
          destination: "//espanol.rosettastone.com/comprar-ingles/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_ingles_label
        }, {
          visible: true,
          destination: "/languages/learn-language/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_learn_languages_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "/tryitnow/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_demo_label
        }, {
          visible: true,
          destination: "/product-activation/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_activation_label
        }, {
          visible: true,
          destination: "/mobile-apps/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_mobile_label
        }, {
          visible: true,
          destination: "/reviews/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_reviews_label
        }, {
          visible: true,
          destination: "/testimonials/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_testamonials_label
        }, {
          visible: true,
          destination: "/speech-recognition/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_speech_label
        }, {
          visible: true,
          destination: "/enterprise/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_enterprise_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_education_primary_label
        }, {
          visible: true,
          destination: "//blog.rosettastone.com",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_blog_label
        }, {
          visible: true,
          destination: "/translate/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "/about/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "/retail/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_retail_partners_label
        }, {
          visible: true,
          destination: "/k12/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_k12_reading_label
        }, {
          visible: true,
          destination: "/student-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_student_discount_label
        }, {
          visible: true,
          destination: "/military-discount/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_military_discount_label
        }, {
          visible: true,
          destination: "/careers/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "/endangered/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_endangered_languages_label
        }, {
          visible: true,
          destination: "/coaches/",
          external: false,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_coaches_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "//support.rosettastone.com/en/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "/faq/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "/contact/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "/system-requirements/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "/lp/accessibility/",
          external: false,
          new_window: false,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "https://www.rosettastone.com/anti-piracy/"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          label: "Facebook",
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          label: "Twitter",
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          label: "Instagram",
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          label: "^YouTube",
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_homeschool_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: false,
    blog: {
      visible: true,
      destination: "https://educationblog.rosettastone.com/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_homeschool_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_homeschool_home_label
    },
    resources: {
      visible: false,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_homeschool_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_homeschool_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_homeschool_label
    }
  };
});

var email_collection_bar$1 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "US_WEBSITE",
    formUrl: "HOMESCHOOL_HOMEPAGE_FOOTER",
    demo_type: "offer_signup",
    newsletter_type: "Top_Homeschool_Footer",
    language: "ENG",
    button: {
      text: "Sign up",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Email Address",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "and promotional emails to receive homeschooling tips.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Thanks for signing up.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "E-mail is invalid.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Sign up for our e‑Newsletter",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "By signing up, I agree to the",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "terms and conditions",
      theme: "white",
      underline: "on"
    },
    privacy_tooltip: {
      title: {
        type: "card-title",
        theme: "white",
        content: "Terms and Conditions",
        align: "center"
      },
      body: {
        align: "left",
        theme: "white",
        dangerous: false,
        content: /*#__PURE__*/React.createElement("div", null, "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\xA0", /*#__PURE__*/React.createElement("a", {
          href: "https://www.rosettastone.com/privacy",
          title: "Privacy Policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy"), ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \xA0", /*#__PURE__*/React.createElement("a", {
          href: "mailto: privacyofficer@rosettastone.com",
          title: "privacyofficer@rosettastone.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacyofficer@rosettastone.com"), ".")
      }
    }
  };
});

var education_homeschool_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
          meta_description: "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
          canonical_url: "https://www.rosettastone.com/homeschool/",
          lang: "en"
        },
        content: {
          hero: {
            title: {
              theme: "green",
              type: "page-title",
              align: "left",
              content: "Built for Homeschoolers"
            },
            subtitle: {
              theme: "black",
              type: "page-sub-title",
              align: "left",
              content: "Language learning that fits into your curriculum"
            },
            body: {
              content: "Designed with your child's success in mind, Rosetta Stone Homeschool is the effective way to bring a\n                    foreign language curriculum home, providing long-term retention and a critical lifelong skill in\n                    today's world."
            },
            cta_1: {
              destination: "https://www.rosettastone.com/tryitnow?homeschool",
              internal: false,
              theme: "yellow_black",
              text: "START A 3‑DAY FREE TRIAL"
            },
            cta_2: {
              destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
              internal: false,
              theme: "black_yellow",
              text: "Buy Now"
            }
          },
          features: {
            layout: "list",
            panels: [{
              body: {
                content: "Rosetta Stone Homeschool is designed with your child's success in mind. Trusted around the world, our technology promotes long-term retention and correct pronunciation—without memorization or drills."
              },
              custom: {
                list: [{
                  heading: "An immersion method that works.",
                  content: "Rosetta Stone teaches language the natural way—no translation required."
                }, {
                  heading: "The most advanced speech technology.",
                  content: "TruAccent® speech-recognition technology listens, analyzes, and corrects your child's speech throughout the learning process."
                }, {
                  heading: "Enhanced reporting and monitoring tools.",
                  content: "Keep your child on track with printable reports and lesson progress data."
                }, {
                  heading: "Access across devices and offline.",
                  content: "Your child can learn from a computer, tablet, or mobile phone. When an Internet connection isn't available, you can easily download lessons with the Audio Companion feature."
                }]
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Rosetta Stone Homeschool",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                content: "Rosetta Stone Homeschool",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }]
          },
          email_collection_bar: email_collection_bar$1({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_homeschool_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: true,
      email_capture: false,
      market: "us",
      domain: ".com",
      vertical: "k12",
      page: "home",
      // Strings
      main_label: "Get the language learning support you need. Connect with us today.",
      sub_label: "Please fill out the form below and we'll follow up with you right away.",
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_online_curriculum_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum-foreign-language/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_foreign_curriculum_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-program/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_homeschool_program_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/homeschool-travel/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_homeschool_travel_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/resellers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_start_homeschool_retailers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/translate/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/personal/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/lp/accessibility/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var email_collection_bar = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "email collection bar",
    website: "US_WEBSITE",
    formUrl: "HOMESCHOOL_HOMEPAGE_FOOTER",
    demo_type: "offer_signup",
    newsletter_type: "Top_Homeschool_Footer",
    language: "ENG",
    button: {
      text: "Sign up",
      theme: "yellow_black",
      size: "mini"
    },
    email_field: {
      placeholder: "Email Address",
      id: "email",
      name: "email"
    },
    subtitle: {
      content: "and promotional emails to receive homeschooling tips.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    success_message: {
      content: "Thanks for signing up.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    error_message: {
      content: "E-mail is invalid.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    title: {
      content: "Sign up for our e‑Newsletter",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    },
    legal: {
      content: "By signing up, I agree to the",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    legal_link: {
      destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf",
      label: "terms and conditions",
      theme: "white",
      underline: "on"
    },
    privacy_tooltip: {
      title: {
        type: "card-title",
        theme: "white",
        content: "Terms and Conditions",
        align: "center"
      },
      body: {
        align: "left",
        theme: "white",
        dangerous: false,
        content: /*#__PURE__*/React.createElement("div", null, "By signing up, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third-party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone\u2019s\xA0", /*#__PURE__*/React.createElement("a", {
          href: "https://www.rosettastone.com/privacy",
          title: "Privacy Policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Privacy Policy"), ". I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at \xA0", /*#__PURE__*/React.createElement("a", {
          href: "mailto: privacyofficer@rosettastone.com",
          title: "privacyofficer@rosettastone.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacyofficer@rosettastone.com"), ".")
      }
    }
  };
});

var verticals$2 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/enterprise/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/highereducation/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_publicsector,
        asset_static: verticals$q.publicsectorCirclePng
      },
      link: {
        destination: "/publicsector/"
      },
      name: strings.verticals_publicsector,
      title: {
        content: strings.verticals_publicsector,
        type: "card-title"
      }
    }]
  };
});

var education_homeschool_seo_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "seo-basic":
      return {
        page: page,
        helmet: {
          meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
          meta_description: "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
          canonical_url: "https://www.rosettastone.com/homeschool/",
          trustpilot: true,
          lang: "en"
        },
        content: {
          free_trial_banner: {
            visible: true,
            button: {
              theme: "blue_white",
              destination: "https://www.rosettastone.com/homeschool/free-trial/?ocid=seo-stickyhs",
              text: "Start Free Trial"
            }
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$2({
            strings: strings
          }),
          email_collection_bar: email_collection_bar({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_homeschool_seo_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    cta: {
      visible: false,
      contact_modal: true,
      email_capture: false,
      market: "us",
      domain: ".com",
      vertical: "k12",
      page: "home",
      // Strings
      main_label: "Get the language learning support you need. Connect with us today.",
      sub_label: "Please fill out the form below and we'll follow up with you right away.",
      button_label: strings.footer_cta_pricing_button,
      form_title: strings.footer_cta_pricing_title,
      form_subtitle: strings.footer_cta_pricing_subtitle,
      form_firstname: strings.footer_cta_form_firstname,
      form_lastname: strings.footer_cta_form_lastname,
      form_email: strings.footer_cta_form_email,
      form_phone: strings.footer_cta_form_phone,
      form_country: strings.footer_cta_form_country,
      form_organization: strings.footer_cta_form_organization,
      form_organizationsize_100: strings.footer_cta_form_organizationsize_100,
      form_organizationsize_500: strings.footer_cta_form_organizationsize_500,
      form_organizationsize_1000: strings.footer_cta_form_organizationsize_1000,
      form_organizationsize_5000: strings.footer_cta_form_organizationsize_5000,
      form_organizationsize_10000: strings.footer_cta_form_organizationsize_10000,
      form_organizationsize_25000: strings.footer_cta_form_organizationsize_25000,
      form_organizationsize_50000: strings.footer_cta_form_organizationsize_50000,
      form_organizationsize_more: strings.footer_cta_form_organizationsize_more,
      form_organizationsize: strings.footer_cta_form_organizationsize,
      form_role: strings.footer_cta_form_role,
      form_role_individualcontributor: strings.footer_cta_form_role_individualcontributor,
      form_role_manager: strings.footer_cta_form_role_manager,
      form_role_executive: strings.footer_cta_form_role_executive,
      form_role_vicepresident: strings.footer_cta_form_role_vicepresident,
      form_role_director: strings.footer_cta_form_role_director,
      form_role_teacher: strings.footer_cta_form_role_teacher,
      form_role_techcoordinator: strings.footer_cta_form_role_techcoordinator,
      form_role_curriculumdirector: strings.footer_cta_form_role_curriculumdirector,
      form_role_principal: strings.footer_cta_form_role_principal,
      form_role_boardmember: strings.footer_cta_form_role_boardmember,
      form_role_superintendent: strings.footer_cta_form_role_superintendent,
      form_comments: strings.footer_cta_form_comments,
      form_submit: strings.footer_cta_form_submit,
      form_pricing_thanks: strings.footer_cta_form_pricing_thanks
    },
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_learn_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_online_curriculum_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-curriculum-foreign-language/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_foreign_curriculum_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/online-homeschool-program/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_homeschool_program_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/homeschool-travel/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_homeschool_travel_label
        }]
      }, {
        label: strings.footer_menu_start_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/lp/sbsr/sitewide-hs/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_buy_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/languages/resellers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_start_homeschool_retailers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/translate/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_start_translate_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_contact_us_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/rosetta-stone-media-room/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/personal/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/lp/accessibility/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_accessibility_statement_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_primary_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://educationblog.rosettastone.com/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_solutions_label,
      options: [{
        link: "/solutions/k12-english-language/",
        label: strings.nav_secondary_education_primary_solutions_k12_english_language
      }, {
        link: "/solutions/world-languages/",
        label: strings.nav_secondary_education_primary_solutions_world_languages
      }]
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_primary_label
    }
  };
});

var lead_generation_bar$2 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/pricing-request/",
        new_window: false,
        size: "regular",
        text: "Request Pricing",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Get the language learning support you need. Connect with us today.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var quote_carousel = (function (_ref) {
  _ref.strings;
  return {
    data_qa: "Section 6 - Quotes",
    visible: true,
    layout: "carousel",
    title: {
      align: "center",
      content: "Trusted for 25+ years by schools nationwide",
      heading: "h2",
      theme: "black",
      type: "section-title"
    },
    panels: [{
      quote: "Rosetta Stone English meets my students’ needs by allowing them to practice and get immediate feedback in a safe setting. When students are struggling, the lessons are terrific.",
      attribution: "Mary Doerr, ESL Specialist at Lincoln Elementary, Wenatchee Public Schools, WA"
    }, {
      quote: "Students were surprised to see such a diversity of characters they could select. They can relate to the characters, yet it’s interesting to see they are choosing characters of different backgrounds—not just their own.",
      attribution: "Caitlin McHugh, Director of English as a Second Language, Boston Collegiate Charter School, MA"
    }, {
      quote: "I would definitely recommend Rosetta Stone English to other educators! We’ve been searching for ways to provide more engaging, targeted lessons to our English learners, and I believe Rosetta Stone English achieves that.",
      attribution: "Courtney Bradley, Culture and Data Coordinator, Soleil Academy, CA"
    }]
  };
});

var education_primary_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: ""
              },
              body: {
                content: ""
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  theme: "yellow_black",
                  internal: true,
                  text: "REQUEST PRICING"
                }
              }
            }]
          },
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "K-12 Online Language Learning | Rosetta Stone",
          meta_description: "Rosetta Stone online language learning for education complements classroom instruction in both English and world languages. Learn about customer successes.",
          canonical_url: "https://www.rosettastone.com/k12/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1",
            panels: [{
              body: {
                content: "Language connects us all, laying the groundwork for learning and growth. For an increasingly diverse student population, language can also be the key to achievement, in school and beyond. "
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Where will language take your students?",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              video: {
                controls: true,
                currentVideoUrl: "https://player.vimeo.com/video/591207204"
              }
            }],
            visible: true
          }, {
            visible: true,
            data_qa: "Section 2 - Image Text",
            layout: "list",
            panels: [{
              body: {
                content: "As communities diversify and global connections increase, the need for K–12 students to develop language skills grows. Compared to children who speak only one language, bilingual students benefit from better working memories, greater mental flexibility, and the ability to more easily grasp abstract concepts."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Promoting the power of bilingualism",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                content: "Promoting the power of bilingualism",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }, {
              body: {
                content: "Every student is different. That’s why our programs personalize language learning through the Adaptive Blended Learning Model, while incorporating scaffolded instruction and Speech Recognition Engine technology. Individualized learning paths empower students to take ownership of their own language development."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                alt: "Addressing individual needs for language learning",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Addressing individual needs for language learning",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Speaking with purposeful repetition and listening practice is a key attribute of our solutions, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Advancing proficiency with immediate feedback",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Advancing proficiency with immediate feedback",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "We support, engage, and encourage students throughout their learning journeys by using pedagogies that respect a diversity of cultures and languages. Our programs and lessons are designed to celebrate student achievement every step of the way."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                alt: "Culturally respectful for more inclusive classrooms",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Culturally respectful for more inclusive classrooms",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "We empower educators to enhance academic outcomes with programs aligned with multiple language proficiency standards. And we combine language learning with subject knowledge to support career readiness, while helping administrators meet district and state goals."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Improving student outcomes for greater academic achievement",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Improving student outcomes for greater academic achievement",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Students can learn anywhere. Our language learning solutions enable both students and educators to access language lessons and activities virtually. That way, any moment can become a teachable one."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                alt: "Opportunities for learning anywhere, anytime",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Opportunities for learning anywhere, anytime",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }]
          }, {
            visible: true,
            data_qa: "Section 3 - Contact",
            layout: "list",
            panels: [{
              data_qa: null,
              sub_title: {
                align: "center",
                content: "Please fill out the form below and we'll follow up with you right away.",
                theme: "white",
                type: "sub-title"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              title: {
                align: "center",
                content: "Get the language learning support you need. Connect with us today.",
                heading: "h2",
                theme: "white",
                type: "section-title"
              }
            }]
          }],
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "pricing-request":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Book time with a Language Expert today"
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Please fill out the form below to schedule time to discuss how we can help."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Almost there!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "First Name",
                required: true,
                required_error: "Please enter your First Name."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Last Name",
                required: true,
                required_error: "Please enter your Last Name."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Email Address",
                required: true,
                required_error: "Please enter your Email Address.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Phone Number",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Company",
                required: true,
                required_error: "Please enter your Company Name."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Company Size",
                required: true,
                required_error: "Please enter your Company Size.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 or Less",
                  label: "100 or Less"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 or More",
                  label: "50,001 or More"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Title",
                required: true,
                required_error: "Please enter your Role."
              }
            },
            static_fields: {},
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Request Pricing"
            },
            labels: {
              form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
              form_privacy2: "Privacy Policy",
              form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
              form_privacy4: ".",
              form_privacyUrl: "https://www.rosettastone.com/privacy",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
              form_updateagreement2: "here",
              form_updateagreement3: "for more information."
            },
            domain: ".com",
            dataQaLocation: "page"
          },
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-complete":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/k12/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            align: "center",
            content: "Thanks for your interest!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Check out some additional resources before your meeting!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/resources/",
            new_window: false,
            internal: true,
            size: "regular",
            text: "Resources",
            theme: "blue_white"
          },
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-schedule":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "solutions-K12-english-language":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Language Training Solutions | Rosetta Stone",
          meta_description: "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
          canonical_url: "https://www.rosettastone.com/k12/solutions/K12-english-language/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              body: {
                content: "Rosetta Stone Foundations is a scalable e-learning solution designed for beginner to intermediate students to build fundamental English language skills. Students develop their skills through learning activities, stories, and live online conversations."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    new_window: false,
                    internal: true,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              title: {
                align: "left",
                content: "Lay the groundwork for success with Rosetta Stone® Foundations",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              video: {
                currentVideoUrl: "https://player.vimeo.com/video/591207236",
                playing: false,
                controls: true
              }
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              body: {
                content: "For your emergent bilingual students, or English language learners, in grades 7–12, producing spoken language is key. You need an immersive solution that allows students to build their language skills naturally, accelerating speaking confidence."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Building skills for conversational proficiency",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Building skills for conversational proficiency",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                alt: "Speech Recognition Engine with immediate feedback",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Speech Recognition Engine with immediate feedback",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "With live tutoring, students can talk with native speakers in a safe, controlled online environment. Meanwhile, teachers receive support materials, including workbooks, guides, and quizzes, as well as reports that can assist in class planning and one-on-one instruction."
              },
              custom: {},
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Support for students and educators every step of the way",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Support for students and educators every step of the way",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "See the greater gains in year-over-year AZELLA scores for English language learners."
              },
              custom: {
                cta: {
                  theme: "blue_white",
                  size: "regular",
                  text: "Download White Paper",
                  destination: "https://resources.rosettastone.com/CDN/us/pdfs/EL-Controlled-Study-White-Paper.pdf",
                  internal: false,
                  new_window: true
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                alt: "Rosetta Stone Foundations gets results",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Rosetta Stone Foundations gets results",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Access these additional resources to learn more about Rosetta Stone Foundations."
              },
              custom: {
                li_1: {
                  destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/little-rock-school-district-case-study.pdf",
                  label: "Rosetta Stone Foundations Case Study"
                },
                li_2: {
                  destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/technology-to-promote-ell-student-family-success.pdf",
                  label: "Promoting EL Student Success with Technology"
                },
                li_3: {
                  destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/six-steps-toward-ell-success.pdf",
                  label: "Six Steps Toward ELL Success"
                }
              },
              data_qa: null,
              direction: "image-left",
              image: {
                alt: "Build a strong foundation",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Build a strong foundation",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "5",
            layout: "list",
            panels: [{
              data_qa: null,
              sub_title: {
                align: "center",
                content: "Please fill out the form below and we'll follow up with you right away.",
                theme: "white",
                type: "sub-title"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              title: {
                align: "center",
                content: "Get the language learning support you need. Connect with us today.",
                heading: "h2",
                theme: "white",
                type: "section-title"
              }
            }],
            visible: true
          }],
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    case "solutions-world-languages":
      return {
        page: page,
        helmet: {
          meta_title: "Language Training Solutions | Rosetta Stone",
          meta_description: "Rosetta Stone English for grades K–6 is an adaptive blended learning program that supports students’ English language development through academic conversations. The program integrates speaking, listening, and grammar in the subjects of math, science, social studies, general knowledge, and biographies.",
          canonical_url: "https://www.rosettastone.com/k12/solutions/elementary-english-language/",
          lang: "en"
        },
        content: {
          hero: {
            dataQa: "1",
            layout: "list",
            panels: [{
              body: {
                content: "The Rosetta Stone Foundations for World Languages K–12 solution provides a range of language instruction, incorporating speaking, listening, grammar, and writing lessons. The program allows for flexibility and personalized study, enabling students to learn at their own pace."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              dataQa: "1",
              direction: "image-right",
              image: {
                alt: "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                asset_fixed: null,
                asset_fluid: null,
                height: "100%",
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Make a world of difference with Rosetta Stone® Foundations for World Languages",
                heading: "h1",
                theme: "black",
                type: "page-title"
              },
              hasCtaRedirect: true
            }],
            visible: true
          },
          image_text_list: {
            dataQa: "2",
            layout: "list",
            panels: [{
              body: {
                content: "Today, more of the world’s population is bilingual than monolingual, and the demand for bilingual workers is rising. Your students need a learning solution that can help them develop speaking and listening skills in a wide range of languages, for greater success in school and beyond."
              },
              dataQa: "2",
              direction: "image-left",
              image: {
                alt: "Meeting a range of diverse language learning needs",
                asset_fixed: null,
                asset_fluid: null,
                height: "80%",
                asset_static: null,
                width: "80%"
              },
              title: {
                align: "left",
                content: "Meeting a range of diverse language learning needs",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Speaking with purposeful repetition and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation without judging, while educators can monitor student progress."
              },
              dataQa: "3",
              direction: "image-right",
              image: {
                alt: "Immersing students in language so they’re prepared to speak",
                asset_fixed: null,
                asset_fluid: null,
                height: "80%",
                asset_static: null,
                width: "80%"
              },
              title: {
                align: "left",
                content: "Immersing students in language so they’re prepared to speak",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Students build confidence by practicing their conversational skills under the direction of one of our experienced live tutors, a native speaker of the language being studied. Each session takes place in a real-time group setting with other students for even more opportunities to converse. Students also have access to children’s stories, history, and cultural resources."
              },
              dataQa: "4",
              direction: "image-left",
              image: {
                alt: "Creating opportunities for more speaking and listening practice",
                asset_fixed: null,
                asset_fluid: null,
                height: "80%",
                asset_static: null,
                width: "80%"
              },
              title: {
                align: "left",
                content: "Creating opportunities for more speaking and listening practice",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Extensive, repetitive speaking and listening practice is a key attribute of the software, and the embedded Speech Recognition Engine provides immediate feedback. Our TruAccent™ speech recognition helps guide pronunciation, without judging, while educators can monitor student progress."
              },
              dataQa: "5",
              direction: "image-right",
              image: {
                alt: "Speech Recognition Engine with immediate feedback",
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Speech Recognition Engine with immediate feedback",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Access these additional resources to learn more about Rosetta Stone World Languages."
              },
              custom: {
                li_1: {
                  destination: "https://resources.rosettastone.com/CDN/us/pdfs/education-primary/new-foundations-product-factsheet.pdf",
                  label: "Rosetta Stone Foundations Grades K–12 World Languages Flyer"
                },
                li_2: {
                  destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/lifelong-learning.pdf",
                  label: "Language is a Lifelong Skill eBook"
                },
                li_3: {
                  destination: "https://resources.rosettastone.com/CDN/us/pdfs/education-primary/world-language-case-study-2020.pdf",
                  label: "World Language Case Study"
                },
                li_4: {
                  destination: "https://resources.rosettastone.com/assets/lp/9999999998/resources/closing-the-world-language-education-gap-2016.pdf",
                  label: "Closing the World Language Gap eBook"
                }
              },
              image: {
                alt: "Provide a world of opportunities",
                asset_fixed: null,
                asset_fluid: null,
                height: "80%",
                asset_static: null,
                width: "80%"
              },
              dataQa: "6",
              direction: "image-left",
              title: {
                content: "Provide a world of opportunities",
                type: "section-title",
                heading: "h2",
                theme: "black",
                align: "left"
              }
            }],
            visible: true
          },
          quote_carousel: quote_carousel({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$2({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_primary_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_homeschool_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/k12/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/enterprise/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://educationblog.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var education_secondary_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: false,
      destination: null,
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_resources_label
    },
    solutions: {
      visible: false,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_solutions_label
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_education_secondary_label
    }
  };
});

var lead_generation_bar$1 = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/pricing-request/",
        new_window: false,
        size: "regular",
        text: "Request Pricing",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Get the language learning support you need. Connect with us today.",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals$1 = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_enterprise,
        asset_static: verticals$q.enterpriseCirclePng
      },
      link: {
        destination: "/enterprise/"
      },
      name: strings.verticals_enterprise,
      title: {
        content: strings.verticals_enterprise,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/k12/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_publicsector,
        asset_static: verticals$q.publicsectorCirclePng
      },
      link: {
        destination: "/publicsector/"
      },
      name: strings.verticals_publicsector,
      title: {
        content: strings.verticals_publicsector,
        type: "card-title"
      }
    }]
  };
});

var education_secondary_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: ""
              },
              body: {
                content: ""
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  theme: "yellow_black",
                  internal: true,
                  text: "REQUEST PRICING"
                }
              }
            }]
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Online Language Learning for Higher Ed | Rosetta Stone",
          meta_description: "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
          canonical_url: "https://www.rosettastone.com/highereducation/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "section1_hero",
            layout: "list",
            panels: [{
              body: {
                content: "Students create global connections with a swipe on their smartphone. Yet, schools face world language budget constraints. This limits students’ potential academic and career choices, and their worldview. In a global economy, world language skills are a 21st century job requirement."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: null,
                  button: {
                    destination: "/pricing-request/",
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                width: "50vw"
              },
              title: {
                align: "left",
                content: "Put language learning within every student’s reach",
                theme: "black",
                type: "page-title",
                heading: "h1"
              }
            }],
            visible: true
          }, {
            data_qa: "section2_productSample",
            panels: [{
              title: {
                align: "left",
                content: "Accelerate English language learning.",
                type: "section-title",
                heading: "h2"
              },
              body: {
                content: "Many higher education students can pass a standardized English-language proficiency test; however, the language skills required to be successful in academia are often much different. Rosetta Stone language learning solutions help build international students' English confidence and prepare them for success."
              },
              panels: [{
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.azulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.verdePng
                  }
                },
                challenge_text: "Azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.bicicletaAzulPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.bicicletaAmarillaPng
                  }
                },
                challenge_text: "Una bicicleta azul"
              }, {
                left_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.dosBicicletasAzulesPng
                  }
                },
                right_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.dosBicicletasDiferentesPng
                  }
                },
                challenge_text: "Dos bicicletas azules"
              }, {
                left_option: {
                  is_correct: false,
                  image: {
                    asset_static: productSample.verdesPorUnDiaPng
                  }
                },
                right_option: {
                  is_correct: true,
                  image: {
                    asset_static: productSample.azulesPorUnDiaPng
                  }
                },
                challenge_text: "Dos bicicletas azules por un día por favor"
              }],
              custom: {
                quote_attribution_1: {
                  quote: "In this Internet era, English being the global language, students need to master this language to be confident and to stay competitive in their studies now and later in their profession.",
                  attribution: "Dean, Deanship of Preparatory Year & Supportive Studies, Northern Border University",
                  size: "small",
                  align: "left",
                  link: {
                    align: "left",
                    theme: "black",
                    destination: "https://www.rosettastone.com/k12/resources/content/case-study-northern-border-university/"
                  }
                }
              }
            }],
            visible: true
          }, {
            data_qa: "section3_image",
            layout: "list",
            panels: [{
              body: {
                content: "That’s no surprise. Culture, entertainment, sports, and literature are only a click away. Blending award-winning e-learning into your language curriculum gives students online access to unlimited pronunciation guidance and speaking practice that’s not possible during classroom hours."
              },
              custom: {
                quote_attribution_1: {
                  quote: "After we piloted our conversational language courses, our students took the American Council on the Teaching of Foreign Languages’ (ACTFL) Oral Proficiency Interview (OPIc). After just one semester of study, students in the 101 courses scored at the Novice-Mid level or higher on the OPIc.",
                  attribution: "Department Chair, College of General Studies, Liberty University",
                  align: "left",
                  size: "small",
                  link: {
                    align: "left",
                    theme: "black",
                    destination: "https://www.rosettastone.com/k12/resources/content/case-study-liberty-university/"
                  }
                }
              },
              direction: "image-right",
              image: {},
              title: {
                align: "left",
                content: "Online is students’ home away from home",
                theme: "black",
                type: "section-title",
                heading: "h2"
              }
            }],
            visible: true
          }, {
            data_qa: "section4_image",
            layout: "list",
            panels: [{
              body: {
                content: "Students, instructors, and staff all want to feel at ease speaking a new language. Moving from language learning to the real world takes practice. With our 1:1 and small group tutoring sessions, learners converse with native speakers. That makes tutoring in our friendly online space a smart way to learn."
              },
              custom: {
                quote_attribution_1: {
                  quote: "Rosetta Stone solutions have been a great tool to help the participants assess their levels and access a range of interactive and diversified learning experiences which promotes independent progress.",
                  attribution: "Course Coordinator, Canterbury Christ Church University",
                  link: {
                    align: "left",
                    theme: "black",
                    destination: "https://www.rosettastone.com/k12/resources/content/case-study-canterbury-christ-church-university/"
                  },
                  align: "left",
                  size: "small"
                }
              },
              direction: "image-left",
              image: {},
              title: {
                align: "left",
                content: "Unlimited Live Tutoring gets learners talking",
                theme: "black",
                type: "section-title",
                heading: "h2"
              }
            }],
            visible: true
          }, {
            data_qa: "section5_image",
            layout: "list",
            panels: [{
              body: {
                content: "Class schedules are still the norm for students. But schools are also making it easier to learn away from the classroom. Our mobile app lets your students access lessons and activities whenever the time is right. Giving them the freedom to turn any moment into a teachable one."
              },
              custom: {
                quote_attribution_1: {
                  quote: "We see those students who follow the Rosetta Stone® program become motivated and confident, more willing to participate in classroom activities, and acquire vocabulary at a much faster rate.",
                  attribution: "ELL Teacher, Phoenix Union High School District",
                  align: "left",
                  size: "small",
                  link: {
                    align: "left",
                    theme: "black",
                    destination: "https://www.rosettastone.com/k12/resources/content/customer-spotlight-phoenix-union-high-school-district/"
                  }
                }
              },
              direction: "image-right",
              image: {},
              title: {
                align: "left",
                content: "Mobile learning, online or off",
                theme: "black",
                type: "section-title",
                heading: "h2"
              }
            }],
            visible: true
          }, {
            data_qa: "section6_contact",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "section7_features",
            layout: "list",
            panels: [{
              features: [{
                feature: {
                  label: "24 Languages",
                  description: "English and World Languages to match student goals.",
                  icon: {
                    asset_static: icons.icon_24Svg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneLanguagesPng
                }
              }, {
                feature: {
                  label: "Self-paced Immersion",
                  description: "Surrounding students with one language speeds up learning.",
                  icon: {
                    asset_static: icons.iconProficiencySvg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneImmersionPng
                }
              }, {
                feature: {
                  label: "Games and Activities",
                  description: "Students have fun while reinforcing lessons they’ve learned.",
                  icon: {
                    asset_static: icons.iconGamesSvg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneActivitiesPng
                }
              }, {
                feature: {
                  label: "TruAccent™ Speech Recognition",
                  description: "It’s the pronunciation helper any student can use.",
                  icon: {
                    asset_static: icons.iconTruaccentSvg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneTruaccentPng
                }
              }, {
                feature: {
                  label: "Live Tutoring",
                  description: "Offered in a safe, online space at each student’s level.",
                  icon: {
                    asset_static: icons.iconTutoringSvg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneTutoringPng
                }
              }, {
                feature: {
                  label: "Mobile App",
                  description: "Puts learning access in each student’s hand.",
                  icon: {
                    asset_static: icons.iconMobileSvg
                  }
                },
                media: {
                  asset_static: features.featuresPhoneMobilePng
                }
              }]
            }],
            visible: true
          }, {
            data_qa: "section8_relatedResources",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["recqx7Gp85JxbWVUk", "recmZCtDOwebYHRXw", "reclyhXd1Wt8SDAkv", "recBdyJF9DHfMJX4Y"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              theme: "black",
              type: "section-title"
            },
            visible: true
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    case "pricing-request":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Book time with a Language Expert today"
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Please fill out the form below to schedule time to discuss how we can help."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Almost there!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "First Name",
                required: true,
                required_error: "Please enter your First Name."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Last Name",
                required: true,
                required_error: "Please enter your Last Name."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Email Address",
                required: true,
                required_error: "Please enter your Email Address.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Phone Number",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Company",
                required: true,
                required_error: "Please enter your Company Name."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Company Size",
                required: true,
                required_error: "Please enter your Company Size.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 or Less",
                  label: "100 or Less"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 or More",
                  label: "50,001 or More"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Title",
                required: true,
                required_error: "Please enter your Role."
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Request Pricing"
            },
            labels: {
              form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
              form_privacy2: "Privacy Policy",
              form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
              form_privacy4: ".",
              form_privacyUrl: "https://www.rosettastone.com/privacy",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
              form_updateagreement2: "here",
              form_updateagreement3: "for more information."
            },
            domain: ".com",
            dataQaLocation: "page"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-complete":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/highereducation/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            align: "center",
            content: "Thanks for your interest!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Check out some additional resources before your meeting!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/resources/",
            new_window: false,
            internal: true,
            size: "regular",
            text: "Resources",
            theme: "blue_white"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-schedule":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals$1({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar$1({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var education_secondary_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_homeschool_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/k12/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/enterprise/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://educationblog.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var enterprise_nav_secondary_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    blog: {
      visible: true,
      destination: "https://enterpriseblog.rosettastone.com/",
      external: true,
      new_window: true,
      // Labels
      label: strings.nav_secondary_enterprise_blog_label,
      title: strings.nav_secondary_enterprise_blog_label
    },
    home: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_home_label,
      title: strings.nav_secondary_enterprise_home_label
    },
    resources: {
      visible: true,
      destination: "/resources/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_resources_label,
      title: strings.nav_secondary_enterprise_resources_label
    },
    solutions: {
      visible: true,
      destination: "/solutions/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_solutions_label,
      options: [{
        link: "/industry/construction/",
        label: strings.nav_secondary_enterprise_solutions_construction_label,
        title: strings.nav_secondary_enterprise_solutions_construction_label
      }, {
        link: "/industry/consulting/",
        label: strings.nav_secondary_enterprise_solutions_consulting_label,
        title: strings.nav_secondary_enterprise_solutions_consulting_label
      }, {
        link: "/industry/foodservice/",
        label: strings.nav_secondary_enterprise_solutions_foodservice_label,
        title: strings.nav_secondary_enterprise_solutions_foodservice_label
      }, {
        link: "/industry/government/",
        label: strings.nav_secondary_enterprise_solutions_government_label,
        title: strings.nav_secondary_enterprise_solutions_government_label
      }, {
        link: "/industry/healthcare/",
        label: strings.nav_secondary_enterprise_solutions_healthcare_label,
        title: strings.nav_secondary_enterprise_solutions_healthcare_label
      }, {
        link: "/industry/hospitality/",
        label: strings.nav_secondary_enterprise_solutions_hospitality_label,
        title: strings.nav_secondary_enterprise_solutions_hospitality_label
      }, {
        link: "/industry/manufacturing/",
        label: strings.nav_secondary_enterprise_solutions_manufacturing_label,
        title: strings.nav_secondary_enterprise_solutions_manufacturing_label
      }, {
        link: "/industry/retail/",
        label: strings.nav_secondary_enterprise_solutions_retail_label,
        title: strings.nav_secondary_enterprise_solutions_retail_label
      }]
    },
    vertical_header: {
      visible: true,
      destination: "/",
      external: false,
      new_window: false,
      // Labels
      label: strings.nav_secondary_enterprise_label
    }
  };
});

var lead_generation_bar = (function (_ref) {
  _ref.strings;
  return {
    visible: true,
    dataQa: "lead generation bar",
    lead_generation_button: {
      schedule_appointment: false,
      button: {
        destination: "/pricing-request/",
        new_window: false,
        size: "regular",
        text: "Request Pricing",
        theme: "yellow_black"
      }
    },
    subtitle: {
      content: "",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-sub-title"
    },
    title: {
      content: "Ready to begin your organization’s complete language journey?",
      align: "left",
      theme: "white",
      heading: "div",
      type: "banner-title"
    }
  };
});

var verticals = (function (_ref) {
  var strings = _ref.strings;
  return {
    visible: true,
    title: {
      content: strings.verticals_label,
      align: "center",
      type: "section-title"
    },
    panels: [{
      image: {
        alt: strings.verticals_publicsector,
        asset_static: verticals$q.publicsectorCirclePng
      },
      link: {
        destination: "/publicsector/"
      },
      name: strings.verticals_publicsector,
      title: {
        content: strings.verticals_publicsector,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_primary,
        asset_static: verticals$q.educationPrimaryCirclePng
      },
      link: {
        destination: "/k12/"
      },
      name: strings.verticals_education_primary,
      title: {
        content: strings.verticals_education_primary,
        type: "card-title"
      }
    }, {
      image: {
        alt: strings.verticals_education_secondary,
        asset_static: verticals$q.educationSecondaryCirclePng
      },
      link: {
        destination: "/highereducation/"
      },
      name: strings.verticals_education_secondary,
      title: {
        content: strings.verticals_education_secondary,
        type: "card-title"
      }
    }]
  };
});

var enterprise_pages_config = (function (_ref) {
  var page = _ref.page,
      strings = _ref.strings;

  switch (page) {
    case "dynamic-content":
      return {
        page: page,
        helmet: {
          meta_title: "",
          meta_description: "",
          canonical_url: "",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "dynamic-resources":
      return {
        page: page,
        helmet: {
          meta_title: "Resources for Online Language Learning for Enterprise | Rosetta Stone",
          meta_description: "",
          canonical_url: "https://www.rosettastone.com/enterprise/resources/",
          lang: "en"
        },
        content: {
          hero: {
            layout: "list",
            panels: [{
              layout: "image-right",
              alignItems: "center",
              image: {
                asset_static: null
              },
              title: {
                content: "Enterprise Resources"
              },
              body: {
                content: "Let Employees Speak For Themselves"
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  theme: "yellow_black",
                  text: "REQUEST PRICING"
                }
              }
            }]
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "experience-audit-language-costs":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Audit Language Costs | Rosetta Stone Enterprise",
          meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
          canonical_url: "https://www.rosettastone.com/enterprise/experience/audit-language-costs/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 0 - Hero",
            layout: "list",
            panels: [{
              body: {
                content: "\n                            A language cost audit can help keep learning and development (L&D) vendor costs down. Auditing your procurement process can be overwhelming, so we\u2019ve put together this handy three-step checklist to help you through the process.\n                            "
              },
              custom: {
                cta: {
                  destination: "/enterprise/experience/making-the-case/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Learn More"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Audit Your Language Training Costs in 3 Easy Steps!",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 1",
            layout: "list",
            panels: [{
              body: {
                content: "What’s your process for selecting language training solutions and other related L&D software products? Do you have a standardized way to identify language training programs? Have members of your regional procurement team purchased language services in the past? Be sure you fully grasp how your department purchases language training products."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "1. Start with your own procurement team and region.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2",
            layout: "list",
            panels: [{
              body: {
                content: "Language training can be billed in a variety of ways depending on who requested the vendor, and why they need the solution. Confirm L&D purchasing policies with each category manager in your region. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "Look for patterns in language training spending over the past few years. Have language expenses increased from year-to-year? How are these costs billed? Are these language solutions sourced from multiple vendors or a single vendor? You’ll also want to take a look at corporate credit card accounts, and employee benefit initiatives, like tuition reimbursement programs. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "2. Review departmental language training expenses.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 4",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "L&D expenses can vary from year to year, so you’ll need to look back a few years. Be sure to also look beyond L&D use cases. Some department heads will use language tools for specific use cases, often going unnoticed in a general cost audit. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 5",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "If purchasing is decentralized or broken out by region, you may need to do a little more legwork. A good place to start is by asking regional leaders to identify department heads responsible for tracking L&D, HR, software, and related spends. Then have those department heads identify which language costs are billed as direct or indirect expenses."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "3. Zero in on region-specific language training expenses.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 6",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "If you have a global language policy, start by asking regional leaders if they’re using that policy to purchase new language solutions. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "115px",
                width: "115px"
              },
              title: {
                align: "left",
                content: "Pro tip:",
                theme: "blue",
                type: "sub-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 7",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "Rosetta Stone Enterprise helps some of the world’s leading brands realize big cost savings by helping them streamline procurement by consolidating their language spend to a single, award-winning enterprise language training solution. "
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "60%",
                width: "60%"
              },
              title: {
                align: "left",
                content: "So you’re overspending on language training... Now what?",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 8",
            layout: "list",
            panels: [{
              body: {
                content: ""
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Talk To A Language Expert"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Join thousands of leading organizations saving big on language training with Rosetta Stone Enterprise!",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }],
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "experience-making-the-case":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Making the Case | Rosetta Stone Enterprise",
          meta_description: "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
          canonical_url: "https://www.rosettastone.com/enterprise/experience/making-the-case/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1",
            layout: "list",
            panels: [{
              body: {
                content: "\n                                        It\u2019s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? \n                                        <br/>\n                                        <br/>\n                                        Here\u2019s how to make a strong business case for online language training.\n                            ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                width: "100%"
              },
              title: {
                align: "left",
                content: "Making the case for online language training.",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2",
            layout: "list",
            panels: [{
              body: {
                content: "Face-to-face training requires additional expenses beyond the cost of a learning module. But when your employees learn a language online, many of those costs vanish.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "60%",
                width: "60%"
              },
              sub_body: {
                content: "Converting your language spend from many local providers to one global platform is a clear cost-saver.",
                dangerous: true
              },
              sub_title: {
                align: "left",
                content: "Consolidate vendors.",
                theme: "black",
                type: "sub-title"
              },
              title: {
                align: "left",
                content: "Start with cost savings.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3",
            layout: "list",
            panels: [{
              body: {
                align: "left",
                content: "One of the world’s largest consulting companies serves clients in over <strong>100</strong> countries and invests in language training on a global scale. After partnering with Rosetta Stone, the company reduced its vendor network and realized first-year cost savings of more than <strong>$500,00</strong>.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "75%",
                width: "75%"
              },
              title: null
            }, {
              body: {
                content: "A global manufacturing leader was able to increase its language offering from 2,000 employees to <strong>77,000</strong> while still saving over <strong>$3 million</strong> annually by simply switching from an international array of vendors to our single-source solution.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "75%",
                width: "75%"
              },
              title: null
            }],
            visible: true
          }, {
            data_qa: "Section 4",
            layout: "duo",
            panels: [{
              body: {
                align: "center",
                content: "Verifying new candidates’ language proficiency levels can be critical. Now your talent development team can rely on language assessments available with your existing licenses.",
                dangerous: true
              },
              data_qa: null,
              direction: "toggle-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "center",
                content: "Start with cost savings.",
                heading: "h2",
                theme: "black",
                type: "card-title"
              },
              toggle: {
                body: {
                  align: "left",
                  content: "A global professional services firm has tested more than 10,000 candidates through online assessments. An alternative was to use an outside language service at a cost of  $40 per person. Instead, the company chose the online CEFR-based Rosetta Stone assessment in the program, at no additional cost.",
                  dangerous: true
                },
                title: null
              }
            }, {
              body: {
                align: "center",
                content: "Moving away from a dedicated training space achieves another level of cost savings."
              },
              data_qa: null,
              direction: "toggle-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "250px",
                width: "250px"
              },
              title: {
                align: "center",
                content: "Act sustainably.",
                heading: "h3",
                theme: "black",
                type: "card-title"
              },
              toggle: {
                body: {
                  align: "left",
                  content: "\n                                <ul>\n                                    <li>Eliminating employee and instructor travel</li>\n                                    <li>Cutting classroom space and maintenance</li>\n                                    <li>Replacing printed materials with online lessons</li>\n                                    <li>Allowing learners to use their personal devices</li>\n                                </ul>\n                            ",
                  dangerous: true
                },
                title: {
                  align: "left",
                  content: "Achieve more savings by:",
                  heading: "h3",
                  theme: "black",
                  type: "sub-title"
                }
              }
            }],
            visible: true
          }, {
            data_qa: "Section 5 - Know your learners.",
            layout: "carousel",
            panels: [{
              body: {
                content: "Just as today’s learners curate their own content experiences in their personal lives on social media, they expect the same experience at work."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Curators of their own experience.",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "They want to give and receive feedback on the learning process—how to improve as a learner, and how the organization can help them succeed in their own online learning experiences."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Employer empowerment helps them thrive.",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Modern employees are also more likely to invest in their careers at organizations invested in their skill development—lowering your own retention spend in the process."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Loyal to organizations that invest in skill development. ",
                heading: "h3",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "Know your learners.",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 6",
            layout: "carousel",
            panels: [{
              body: {
                content: "Seamless, immersive learning experiences guide learners from assessment to proficiency employing a proven, unified method on any device."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Flexible. Mobile. Easy to use.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Learn from native speakers 24/7. Employees access tutoring sessions from virtually anywhere in the world to fit their own schedules."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Online Tutoring from native speakers.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Access an integrated reporting dashboard where you can track and monitor each employee’s learning progress."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Smart dashboards.",
                theme: "black",
                type: "sub-title"
              }
            }, {
              body: {
                content: "Choose from 24 languages.<br/>\n                               Switch at any time.<br/> \n                               The only limit? Hours in the day.\n                              ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Access all our languages.",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "Choose our award-winning enterprise solution.",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 7",
            layout: "list",
            panels: [{
              body: {
                content: "Rosetta Stone is dedicated to using the power of language and literacy education to change people's lives. Millions of inspired learners have used our online and mobile solutions at home, in the workplace, and in schools around the world."
              },
              custom: {
                cta: {
                  destination: "/pricing-request/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Talk To A Language Expert"
                }
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Join thousands of fellow industry leaders",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 8",
            layout: "list",
            panels: [{
              data_qa: null,
              banner: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null
              }
            }],
            visible: true
          }],
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "experience-nine-warning-signs":
      return {
        page: page,
        eloquaPage: "webpage",
        helmet: {
          meta_title: "Nine Warning Signs | Rosetta Stone Enterprise",
          meta_description: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss.",
          canonical_url: "https://www.rosettastone.com/enterprise/experience/nine-warning-signs/",
          lang: "en"
        },
        content: {
          sections: [{
            data_qa: "Section 1 - Header",
            layout: "list",
            panels: [{
              body: {
                content: "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss:"
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "9 warning signs your employees need language training.",
                heading: "h1",
                theme: "blue",
                type: "page-title"
              },
              custom: {
                body: {
                  content: "\n                                            When you add a language barrier to the equation, things get even more complicated. What if you\u2019re communicating to a coworker, boss, or customers in a language you don\u2019t speak very well?\n                                            <br />\n                                            <br />\n                                            If you\u2019re worried your organization might have a language problem, it\u2019s time to do an honest assessment.\n                                        ",
                  dangerous: true
                },
                list: ["A loss of revenue.", "A loss of productivity.", "A loss of a customer.", "A loss of an employee.", "A loss of credibility."],
                title: {
                  align: "left",
                  content: "These are losses no organization can afford. ",
                  theme: "black",
                  type: "sub-title"
                }
              }
            }],
            visible: true
          }, {
            data_qa: "Section 2 - 9 Bullets",
            layout: "list",
            title: {
              align: "center",
              content: "9 signs you may have a language problem.",
              heading: "h2",
              theme: "blue",
              type: "page-title"
            },
            panels: [{
              body: {
                content: "\n                                A diverse, multilingual workforce is definitely worth celebrating. Keeping everyone informed about their roles, basic responsibilities, policies, and safety protocols is both a liability and a major challenge for productivity across the organization.\n                                <br/>\n                                <br/>\n                                Solving this challenge involves a focused effort across your entire business to shift employees\u2019 perception of language training.\n                                ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "1. You have a diverse workforce",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Do multilingual employees fully understand safety policies and protocols? How does that impact their daily tasks and your ability to retain them?  \n                                            <br/>\n                                            <br/>\n                                            Safety compliance in a multilingual workplace is a critical and expensive problem to solve. Depending on the severity of the incident, miscommunicating a seemingly simple safety protocol can cost hundreds of thousands in compliance penalties.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "2. On-the-job safety incidents have increased",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Are you fully aware of the languages your customers speak? Have you ever lost a customer due to a language barrier that provided a bad experience? Do you understand the role of communication in each of your customers\u2019 local cultures?\n                                            <br/>\n                                            <br/>\n                                            Your answers to these questions may reveal a clear need for language training that truly immerses your employees in daily speaking practice with native speakers to truly understand the preferences of your customers.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "3. Customer service is compromised",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                Research shows that 60% of employees will stick with an employer if they provide language training as part of their professional development programs. Meanwhile, only 30% of companies actively make that investment.\n                                <br/>\n                                <br/>\n                                A holistic retention strategy includes language training as an additional element of professional development across your business.\n                            ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "4. Employee turnover is on the rise",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Language barriers are presented in many forms on-the-job. One common result of miscommunication comes in the form of misunderstood job expectations.\n                                            <br/>\n                                            <br/>\n                                            This often means lowered productivity, more mistakes on the job, and general frustration from your broader teams. Operationally, you may default to lowering expectations for Limited English Proficiency (LEP) employees, which can damage morale and result in higher turnover.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "5. Lowered job expectations",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Since you\u2019re already investing time and resources into training LEP employees, it makes perfect sense to retain those employees. Adding language training to your employee development plan can go a long way to show every employee you are invested in their future with your company.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "6. Employee onboarding takes longer",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "When language barriers are a hurdle for career advancement, your employees will be less engaged in their work and are less likely to pursue advancement within your organization. Create a win-win situation for your employees. Use language training to help them take the next best step for their career.",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "7. LEP team members' careers have stalled",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "\n                                            Do you have a collaboration and productivity problem across your global teams? Language barriers could be at play, while your employees look to you for an effective training solution.   \n                                            <br/>\n                                            <br/>\n                                            A recent survey of Rosetta Stone Enterprise users showed two of the most desired outcomes include teamwide collaboration (66% of respondents) and improved verbal communication (68% of respondents) with teammates.\n                                        ",
                dangerous: true
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "8. Collaboration is an ongoing challenge",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }, {
              body: {
                content: "Is your hiring strategy impacted by language challenges across your business? As you look to fill future roles and grow your business abroad, it’s critical to take stock of how language barriers will impact employee performance, compliance, retention and growth."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100px",
                width: "100px"
              },
              title: {
                align: "left",
                content: "9. Future employees face similar obstacles",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            data_qa: "Section 3 - Brand Images",
            layout: "list",
            panels: [{
              destination: "",
              image: {
                alt: "Sony Pictures",
                asset_static: logos.logoSonyPicturesPng,
                height: "100px",
                width: "100px"
              },
              name: "Sony Pictures"
            }, {
              destination: "",
              image: {
                alt: "Twitter",
                asset_static: logos.logoTwitterPng,
                height: "100px",
                width: "100px"
              },
              name: "Twitter"
            }, {
              destination: "",
              image: {
                alt: "Amgen",
                asset_static: logos.logoAmgenPng,
                width: "150px"
              },
              name: "Amgen"
            }, {
              destination: "",
              image: {
                alt: "FICO",
                asset_static: logos.logoFicoPng,
                width: "150px"
              },
              name: "FICO"
            }],
            title: {
              align: "center",
              content: "Leading brands use language solutions from Rosetta Stone Enterprise",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 4 - Enterprise Solutions",
            layout: "carousel",
            panels: [{
              body: null,
              custom: {
                body: {
                  content: "Regardless of industry, language barriers present a complex problem to solve for any organization. The good news is that flexible, immersive language tools help set your team up for success by maximizing collaboration and employee engagement in a way that aligns with your larger business strategy."
                },
                cta: {
                  destination: "/",
                  internal: true,
                  size: "regular",
                  theme: "yellow_black",
                  text: "Learn More"
                },
                list: ["Drive down language training costs across your organization", "Attract and retain top-tier talent", "Improve communication and collaboration", "Foster a customer-obsessed work culture"]
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Curators of their own experience.",
                theme: "black",
                type: "sub-title"
              }
            }],
            title: {
              align: "center",
              content: "With enterprise language solutions from Rosetta Stone you can:",
              heading: "h2",
              theme: "blue",
              type: "section-title"
            },
            visible: true
          }],
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "home":
      return {
        page: page,
        helmet: {
          meta_title: "Rosetta Stone for Enterprise | Rosetta Stone",
          meta_description: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
          canonical_url: "https://www.rosettastone.com/enterprise/",
          lang: "en"
        },
        content: {
          sections: [{
            lead_generation_button: {
              schedule_appointment: false,
              completion_redirect: null,
              button: {
                destination: "/pricing-request/",
                internal: true,
                new_window: false,
                size: "regular",
                text: "Request Pricing",
                theme: "yellow_black"
              }
            },
            demo_button: {
              destination: "https://www.rosettastone.com/lp/ee_demo/",
              internal: false,
              new_window: false,
              size: "regular",
              text: "Try The Demo",
              theme: "yellow_black"
            },
            data_qa: "Header",
            sub_title: {
              align: "center",
              content: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
              theme: "white",
              type: "page-sub-title"
            },
            title: {
              align: "center",
              content: "Language training for enterprise teams.",
              heading: "h1",
              theme: "white",
              type: "page-title"
            },
            visible: true
          }, {
            title: {
              align: "center",
              content: "A proven enterprise language solution.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            data_qa: "Section 2 - Cards",
            layout: "carousel",
            panels: [{
              body: {
                align: "center",
                content: "Invest in employee success. Help them learn a new language on any device—online or offline.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseTopTalentMp4,
                type: "video/mp4"
              },
              title: {
                align: "center",
                content: "Retain Top Talent",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Save big when you switch from face-to-face instructors to online language tutors.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseCutCostsMp4,
                type: "video/mp4"
              },
              title: {
                content: "Cut Costs",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Help your employees speak and work confidently across language barriers.",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseWorkBetterMp4,
                type: "video/mp4"
              },
              title: {
                content: "Work Better Together",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }, {
              body: {
                align: "center",
                content: "Track, measure, and optimize your language training programs for learner success with detailed learner dashboards. ",
                type: "card"
              },
              video: {
                src: animations.usEnterpriseLearnerSuccessMp4,
                type: "video/mp4"
              },
              title: {
                content: "Enable Learner Success",
                heading: "h3",
                type: "card-title",
                theme: "blue"
              }
            }]
          }, {
            data_qa: "Section 3 - Animation Text",
            layout: "list",
            panels: [{
              body: {
                content: "Going from many language providers to a single, proven online platform is a clear cost-saver. Give your employees flexible language learning tools that help immerse them in everyday speaking at the pace and place of their choosing."
              },
              custom: {
                cta_1: {
                  destination: "https://www.rosettastone.com/enterprise/experience/making-the-case/?eeid=oo-e1-co&campaignid=7010W0000027w78&utm_campaign=US-CORP-content-traffic&utm_source=content&utm_content=",
                  internal: false,
                  new_window: false,
                  size: "regular",
                  text: "Show me the guide",
                  theme: "yellow_black"
                }
              },
              data_qa: null,
              direction: "image-right",
              animation: {
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Making the case for online training.",
                heading: "h2",
                theme: "blue",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            custom: {
              cta_1: {
                destination: "/resources/content/a-decade-of-language-training-success/",
                internal: true,
                new_window: false,
                size: "regular",
                theme: "yellow_black",
                text: "Read the latest customer story"
              }
            },
            data_qa: "Section 4 - Brand Images",
            layout: "list",
            panels: awards({
              strings: strings
            }).panels,
            title: {
              align: "center",
              content: "Join 12,000+ leading organizations.",
              heading: "h2",
              theme: "blue",
              type: "page-title"
            },
            visible: true
          }],
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-construction":
      return {
        page: page,
        eloquaPage: "construction",
        helmet: {
          meta_title: "Language Training for Construction | Rosetta Stone",
          meta_description: "Delivering language training solutions across your construction organization helps alleviate costs due to employee productivity, safety compliance, and overall employee retention.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/construction/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              dataQa: "1",
              body: {
                content: "Investing in language training can have a huge impact on your construction organization—from reduced safety incidents to lower turnover costs. When your employees understand each other regardless of their native language, your job sites will become safer, more productive, and ultimately more profitable."
              },
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                  new_window: false,
                  size: "regular",
                  text: "Read Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/construction/",
                  button: {
                    destination: "/pricing-request/",
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Improve job site operations.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              hasCtaRedirect: true
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "Caterpillar",
                asset_static: logosTiles.logosTilesCaterpillarSvg
              }
            }, {
              image: {
                alt: "DPR Construction",
                asset_static: logosTiles.logosTilesDprSvg
              }
            }, {
              image: {
                alt: "Tishman Speyer",
                asset_static: logosTiles.logosTilesTishSvg
              }
            }, {
              image: {
                alt: "Crowder",
                asset_static: logosTiles.logosTilesCrowderSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading construction organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Every job site safety incident is expensive, costing some construction organizations hundreds of thousands of dollars in compliance penalties a year. By equipping your non-English speaking employees with language training, you can reduce safety incidents caused by language barriers."
              },
              direction: "image-left",
              image: {},
              title: {
                align: "left",
                content: "Reduce risk.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Language differences across the modern job site can lead to loss of productivity and detrimental drops in quality—often fueled by poor communication across multiple languages. An investment in language training streamlines communication in a way that engages your employees to do their best work."
              },
              direction: "image-right",
              image: {},
              title: {
                align: "left",
                content: "See your crews’ best work.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Investing in employee language training can go a long way to bolster retention initiatives within your organization—reducing turnover costs while making you an industry leader."
              },
              direction: "image-left",
              image: {},
              title: {
                align: "left",
                content: "Drive down turnover costs.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: false
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-consulting":
      return {
        page: page,
        eloquaPage: "consulting",
        helmet: {
          meta_title: "Language Training for Consulting | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/consulting/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              body: {
                content: "There are plenty of barriers that limit consulting firms from expanding into new markets—chief among them is the language barrier. By providing your entire organization with language training you greatly improve the prospects of profitable expansion into new regions."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/consulting/",
                  button: {
                    destination: "/pricing-request/",
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              video: {
                currentVideoUrl: "https://player.vimeo.com/video/591202724",
                playing: false,
                controls: true
              },
              direction: "content-right",
              title: {
                align: "left",
                content: "Speak every new client’s language.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              hasCtaRedirect: false,
              thanks: "Thanks for your interest! Someone will follow up with you shortly."
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [],
            title: {
              align: "center",
              content: "Proven language solutions for leading hospitality organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Your organization may have some of the industry’s brightest consultants, but a lack of language skills may be causing significant work inefficiencies. Improve productivity with a broader multilingual talent pool."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Collaborate globally.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "The best and brightest are hard to retain because top talent in the professional consulting industry is on every firm’s radar. Adding language training to your professional development mix can help you differentiate from your competitors and alleviate the strain of turnover costs."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Drive down turnover.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Corporations lose millions each year from employee turnover, making it a top organisational challenge. Investing in language training for employees can enhance your retention initiatives by enabling your staff to grow in their careers."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "80%",
                width: "80%"
              },
              title: {
                align: "left",
                content: "Attract and retain top talent.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: "Keep Exploring",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-foodservice":
      return {
        page: page,
        eloquaPage: "foodservice",
        helmet: {
          meta_title: "Language Training for Food Service | Rosetta Stone",
          meta_description: "Flexible language training solutions help large food service organizations reduce communication barriers that get in the way of serving each customer effectively. Everyone from the front-of-house to back-of-house is better equipped to deliver amazing experiences regardless of language barriers.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/foodservice/",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "Language training helps you reduce language barriers that get in the way of great customer experiences. Equip everyone from the front-of-house to back-of-house to deliver amazing customer service."
              },
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/foodservice-operator-language-training/",
                  new_window: false,
                  size: "regular",
                  text: "View Infographic",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/foodservice/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Serve up the right language every time.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              hasCtaRedirect: true
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "Bar S Foods",
                asset_static: logosTiles.logosTilesBarSSvg
              }
            }, {
              image: {
                alt: "Georges",
                asset_static: logosTiles.logosTilesGeorgesSvg
              }
            }, {
              image: {
                alt: "Leclerc",
                asset_static: logosTiles.logosTilesLeclercSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading food service organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Investing in language training for your Limited English Proficiency (LEP) employees can go a long way toward driving down turnover costs in your organization."
              },
              direction: "image-left",
              image: {},
              title: {
                align: "left",
                content: "Retain the best in the food service industry.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "By simply equipping these hourly LEP employees with language training you reduce compliance risk by ensuring that all safety protocols are communicated among all kitchen staff."
              },
              direction: "image-right",
              image: {},
              title: {
                align: "left",
                content: "Safer kitchen operations start with better communication.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your locations. Bridge the communication gap between your kitchen staff with language training solutions from Rosetta Stone."
              },
              direction: "image-left",
              image: {},
              title: {
                align: "left",
                content: "Language barriers: a recipe for disaster.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-government":
      return {
        page: page,
        eloquaPage: "government",
        helmet: {
          meta_title: "Language Training for Government | Rosetta Stone",
          meta_description: "Government employees on the federal, state, or local level require an in-depth understanding of the communities they serve—their needs, concerns, cultures, and yes, the languages they speak. Equipping your government employees with effective, online language training can help ensure they are thoughtfully and effectively meeting the needs of the multilingual communities they serve.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/government/",
          lang: "en"
        },
        content: {
          sections: [{
            // Should include the Video Section once updated
            panels: [{
              dataQa: "1",
              body: {
                content: "Government employees on the federal, state, or local level require an in-depth understanding of the communities they serve—their needs, concerns, cultures, and yes, the languages they speak. Equipping your government employees with effective, online language training can help ensure they are thoughtfully and effectively meeting the needs of the multilingual communities they serve."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/foodservice/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              title: {
                align: "left",
                content: "Effective language solutions for government employees.",
                heading: "h1",
                theme: "black",
                type: "page-title"
              }
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [],
            title: {
              align: "center",
              content: "Proven language solutions for leading hospitality organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Take full advantage of our globally-recognized assessment standards (CEFR, CLP, and ILR) to identify your team’s diverse language training needs."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Industry-leading assessments.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Rosetta Stone is a GSA-approved vendor serving more than 9,000 public sector organizations across the United States."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "GSA approved.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Use smart, integrated dashboards to monitor each employee’s progress. Then reinforce every team member’s speaking, listening, writing, and everyday conversation skills with daily lessons from certified language experts."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Empower speaking success.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-healthcare":
      return {
        page: page,
        eloquaPage: "healthcare",
        helmet: {
          meta_title: "Language Training for Healthcare | Rosetta Stone",
          meta_description: "Build trust and loyalty while improving patient satisfaction by speaking your patients' native language. By eliminating language barriers throughout your organization, you can serve more patients in new locations, while reducing costs associated with compliance risk by delivering critical medical information to each patient clearly and effectively.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/healthcare/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            // Should include the Video Section once updated
            panels: [{
              video: {
                currentVideoUrl: "https://player.vimeo.com/video/591204981",
                playing: false,
                controls: true
              },
              body: {
                content: "When both caregivers and patients truly understand each other—regardless of their native language—patient satisfaction goes up while medical errors and other costly risks go down. Flexible language training helps providers speak, write, listen, and ultimately care for each patient with clarity and purpose.  See language training for healthcare in action."
              },
              custom: {
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/healthcare/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              title: {
                align: "left",
                content: "Great care starts with a conversation.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              }
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "Amgen",
                asset_static: logosTiles.logosTilesAmgenSvg
              }
            }, {
              image: {
                alt: "CVS Health",
                asset_static: logosTiles.logosTilesCvsSvg
              }
            }, {
              image: {
                alt: "NYC Health",
                asset_static: logosTiles.logosTilesNycHealthSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading hospitality organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "In the hospitality business, excellent customer care requires delivering the best possible service to each patron, regardless of their native language. Language training can help you launch a business culture of customer obsession as you serve every customer in their own language."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "How do you say ‘enjoy your stay?’",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "While there are plenty of barriers to high-value market growth, chief among them is a language barrier. By providing your entire organization with language training you prepare staff for profitable expansion into a new region without limits."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Don’t let language hinder global expansion.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Investing in language training for your employees can go a long way to bolster retention initiatives within your organization—reducing turnover costs while raising you up as an industry leader."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Retain the best people.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-hospitality":
      return {
        page: page,
        eloquaPage: "hospitality",
        helmet: {
          meta_title: "Language Training for Hospitality | Rosetta Stone",
          meta_description: "Hospitality organizations use the power of language training to fuel a customer-obsessed business culture. Since hospitality is a global enterprise, this means speaking the language of every customer. Language training helps your organization deliver these experiences.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/hospitality/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              image: {
                asset_fluid: null,
                height: "100%",
                width: "100%"
              },
              dataQa: "1",
              body: {
                content: "Friendly, helpful conversations live right at the heart of the hospitality industry— where every customer interaction begins with a simple “hello” and often ends with a “thank you.” Speak the global language of customer obsession."
              },
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                  new_window: false,
                  size: "regular",
                  text: "Read Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/hospitality/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "White glove service in any language.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              hasCtaRedirect: true
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "Marriott International",
                asset_static: logosTiles.logosTilesMarriottSvg
              }
            }, {
              image: {
                alt: "PPHE Hotel Group",
                asset_static: logosTiles.logosTilesPpheSvg
              }
            }, {
              image: {
                alt: "Vi",
                asset_static: logosTiles.logosTilesViSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading hospitality organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "In the hospitality business, excellent customer care requires delivering the best possible service to each patron, regardless of their native language. Language training can help you launch a business culture of customer obsession as you serve every customer in their own language."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "How do you say ‘enjoy your stay?’",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "While there are plenty of barriers to high-value market growth, chief among them is a language barrier. By providing your entire organization with language training you prepare staff for profitable expansion into a new region without limits."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fluid: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Don’t let language hinder global expansion.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Investing in language training for your employees can go a long way to bolster retention initiatives within your organization—reducing turnover costs while raising you up as an industry leader."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Retain the best people.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-manufacturing":
      return {
        page: page,
        eloquaPage: "manufacturing",
        helmet: {
          meta_title: "Language Training for Manufacturing | Rosetta Stone",
          meta_description: "There are plenty of barriers that limit manufacturing firms from improving safety, retaining quality talent, and expanding into new, global markets—chief among them is the language barrier. By providing your entire organization with language training you are able to better control out of control operations costs associated with compliance, productivity, and global expansion.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/manufacturing/",
          lang: "en"
        },
        content: {
          sections: [{
            panels: [{
              dataQa: "1",
              body: {
                content: "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organization with language training goes a long way toward a profitable expansion into new regions."
              },
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/forbes-insights-reducing-the-impact-of-language-barriers/",
                  new_window: false,
                  size: "regular",
                  text: "Read Report",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/manufacturing/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Speak the global language of manufacturing.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              hasCtaRedirect: true
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "BMW",
                asset_static: logosTiles.logosTilesBmwSvg
              }
            }, {
              image: {
                alt: "GM",
                asset_static: logosTiles.logosTilesGmSvg
              }
            }, {
              image: {
                alt: "Lam Research",
                asset_static: logosTiles.logosTilesLamSvg
              }
            }, {
              image: {
                alt: "Phillip Morris International",
                asset_static: logosTiles.logosTilesPmiSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading manufacturing organizations.",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Safety is on the mind of every manufacturing firm’s HR leader. While not all safety-related incidents are fatal, they are all expensive. One small misinterpretation of a safety protocol can lead to significant losses in just a single incident. Ensure you’re doing all you can to keep each employee safe. Equip them with flexible language training."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Make safety a priority.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Language barriers across the modern warehouse can lead to loss of productivity and drops in quality when a multilingual workforce cannot communicate clearly. See the best work from everyone on the production line with language training."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Reduce productivity barriers.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Voluntary turnover costs the manufacturing industry millions of dollars each year. Add language training to your professional development program to attract and retain the industry’s very best."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Drive down retention costs",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "industry-retail":
      return {
        page: page,
        eloquaPage: "retail",
        helmet: {
          meta_title: "Language Training for Retail | Rosetta Stone",
          meta_description: "There are plenty of barriers that limit manufacturing firms from improving safety, retaining quality talent, and expanding into new, global markets—chief among them is the language barrier. By providing your entire organization with language training you are able to better control out of control operations costs associated with compliance, productivity, and global expansion.",
          canonical_url: "https://www.rosettastone.com/enterprise/industry/retail/",
          lang: "en"
        },
        content: {
          sections: [{
            dataQa: "1",
            panels: [{
              body: {
                content: "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences."
              },
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              custom: {
                cta: {
                  destination: "/enterprise/resources/content/customer-spotlight-stella-mccartney/",
                  new_window: false,
                  size: "regular",
                  text: "Read Case Study",
                  theme: "blue_white"
                },
                lead_generation_button: {
                  schedule_appointment: false,
                  completion_redirect: "/industry/retail/",
                  button: {
                    destination: "/pricing-request/",
                    internal: true,
                    new_window: false,
                    size: "regular",
                    text: "Request Pricing",
                    theme: "yellow_black"
                  }
                }
              },
              direction: "image-right",
              title: {
                align: "left",
                content: "Speak the universal language of customer service.",
                heading: "h1",
                type: "page-title",
                theme: "black"
              },
              thanks: "Thanks for your interest! Someone will follow up with you shortly.",
              hasCtaRedirect: true
            }],
            visible: true
          }, {
            dataQa: "2",
            layout: "list",
            panels: [{
              image: {
                alt: "O'Reilly Auto Parts",
                asset_static: logosTiles.logosTilesOreillySvg
              }
            }, {
              image: {
                alt: "Williams Sonoma",
                asset_static: logosTiles.logosTilesWsSvg
              }
            }],
            title: {
              align: "center",
              content: "Proven language solutions for leading retail organizations.",
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "3",
            layout: "list",
            panels: [{
              body: {
                content: "Retention is a top issue facing all retail establishments. Hourly Limited English Proficiency employees are among the most difficult and costly to attract and retain. Investing in language training for these employees can go a long way to bolster retention initiatives within your organization—setting you apart as an industry leader."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Attract and retain the best staff.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Safety compliance is a top concern for the retail industry, costing it billions of dollars in compliance penalties each year. By equipping your Limited English Proficiency (LEP) employees with language skills you reduce compliance risk, ensuring that all safety protocols are communicated effectively across your team."
              },
              data_qa: null,
              direction: "image-right",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Make retail ops safer.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }, {
              body: {
                content: "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your physical locations. Bridge the communication gap between your employees with language training solutions from Rosetta Stone."
              },
              data_qa: null,
              direction: "image-left",
              image: {
                asset_fixed: null,
                asset_fluid: null,
                asset_static: null,
                height: "100%",
                width: "100%"
              },
              title: {
                align: "left",
                content: "Bridge the communication gap.",
                heading: "h2",
                theme: "black",
                type: "section-title"
              }
            }],
            visible: true
          }, {
            dataQa: "4",
            sub_title: {
              align: "center",
              content: "Please fill out the form below and we'll follow up with you right away.",
              theme: "white",
              type: "sub-title"
            },
            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
            title: {
              align: "center",
              content: "Get the pricing answers you need.",
              heading: "h2",
              theme: "white",
              type: "section-title"
            },
            visible: true
          }, {
            dataQa: "5",
            default_button_label: strings.related_resources_button_label,
            panels: [],
            resource_ids: ["reciMH1K4BjgQ84fN", "recmSa35M1J9knw1q", "reclFOyT4ITytBqqV", "recQzXnf8QZQc3E8c"],
            resources_url: "/resources/",
            title: {
              align: "center",
              content: strings.related_resources_label,
              heading: "h2",
              theme: "black",
              type: "section-title"
            },
            visible: false
          }],
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: lead_generation_bar({
            strings: strings
          })
        }
      };

    case "pricing-request":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            type: "section-title",
            theme: "yellow",
            content: "Book time with a Language Expert today"
          },
          sub_title: {
            type: "section-sub-title",
            theme: "white",
            content: "Please fill out the form below to schedule time to discuss how we can help."
          },
          lead_generation_form: {
            title: {
              theme: "blue",
              type: "section-title",
              content: "Almost there!"
            },
            fields: {
              first_name: {
                field_name: "first_name",
                field_type: "text",
                label: "First Name",
                required: true,
                required_error: "Please enter your First Name."
              },
              last_name: {
                field_name: "last_name",
                type: "text",
                label: "Last Name",
                required: true,
                required_error: "Please enter your Last Name."
              },
              email: {
                field_name: "email",
                field_type: "email",
                label: "Email Address",
                required: true,
                required_error: "Please enter your Email Address.",
                validation_error: "Please enter a valid Email Address."
              },
              phone: {
                field_name: "phone",
                field_type: "tel",
                label: "Phone Number",
                required: true,
                required_error: null
              },
              organization_name: {
                field_name: "organization_name",
                field_type: "text",
                label: "Company",
                required: true,
                required_error: "Please enter your Company Name."
              },
              organization_size: {
                field_name: "organization_size",
                field_type: "text",
                label: "Company Size",
                required: true,
                required_error: "Please enter your Company Size.",
                options: [{
                  value: "",
                  label: ""
                }, {
                  value: "100 or Less",
                  label: "100 or Less"
                }, {
                  value: "101 - 500",
                  label: "101 - 500"
                }, {
                  value: "501 - 1,000",
                  label: "501 - 1,000"
                }, {
                  value: "1,001 - 5,000",
                  label: "1,001 - 5,000"
                }, {
                  value: "5,001 - 10,000",
                  label: "5,001 - 10,000"
                }, {
                  value: "10,001 - 25,000",
                  label: "10,001 - 25,000"
                }, {
                  value: "25,001 - 50,000",
                  label: "25,001 - 50,000"
                }, {
                  value: "50,001 or More",
                  label: "50,001 or More"
                }]
              },
              role: {
                field_name: "title",
                field_type: "select",
                label: "Title",
                required: true,
                required_error: "Please enter your Role."
              }
            },
            button: {
              as: "button",
              type: "submit",
              size: "regular",
              text: "Request Pricing"
            },
            labels: {
              form_privacy1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's",
              form_privacy2: "Privacy Policy",
              form_privacy3: "I understand that I may opt-out of such communications at any time by clicking the link provided in the communication or by contacting Rosetta Stone at",
              form_privacy4: ".",
              form_privacyUrl: "https://www.rosettastone.com/privacy",
              form_privacyemail: "privacyofficer@rosettastone.com",
              form_updateagreement1: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
              form_updateagreement2: "here",
              form_updateagreement3: "for more information."
            },
            domain: ".com",
            dataQaLocation: "page"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-complete":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          title: {
            align: "center",
            content: "Thanks for your interest!",
            heading: "h1",
            theme: "blue",
            type: "page-title"
          },
          sub_title: {
            align: "center",
            heading: "h2",
            content: "Check out some additional resources before your meeting!",
            type: "page-sub-title"
          },
          resources_link: {
            destination: "/resources/",
            internal: true,
            new_window: false,
            size: "regular",
            text: "Resources",
            theme: "blue_white"
          },
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          }),
          lead_generation_bar: {
            visible: false
          }
        }
      };

    case "pricing-request-schedule":
      return {
        page: page,
        helmet: {
          meta_title: "Pricing Request | Rosetta Stone",
          meta_description: "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
          canonical_url: "https://www.rosettastone.com/enterprise/pricing-request/",
          lang: "en"
        },
        content: {
          awards: awards({
            strings: strings
          }),
          branded_quotes: branded_quotes({
            strings: strings
          }),
          verticals: verticals({
            strings: strings
          })
        }
      };

    default:
      return null;
  }
});

var enterprise_footer_config = (function (_ref) {
  var strings = _ref.strings;
  return {
    menu: {
      visible: true,
      sections: [{
        label: strings.footer_menu_products_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_consumer_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/homeschool/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_homeschool_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/k12/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_education_primary_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/enterprise/",
          external: true,
          new_window: false,
          // Labels
          label: strings.footer_menu_products_enterprise_label
        }]
      }, {
        label: strings.footer_menu_about_label,
        links: [{
          visible: true,
          destination: "https://www.rosettastone.com/about/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_about_us_label
        }, {
          visible: true,
          destination: "https://enterpriseblog.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_blog_label
        }, {
          visible: true,
          destination: "https://pr.rosettastone.com/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_press_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/careers/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_careers_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/contact/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_about_contact_label
        }]
      }, {
        label: strings.footer_menu_support_label,
        links: [{
          visible: true,
          destination: "https://support.rosettastone.com/en/work/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_support_site_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/faq/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_faqs_label
        }, {
          visible: true,
          destination: "https://www.rosettastone.com/system-requirements/",
          external: true,
          new_window: true,
          // Labels
          label: strings.footer_menu_support_system_requirements_label
        }]
      }]
    },
    meta: {
      visible: true,
      copyright: {
        visible: true,
        label: strings.footer_meta_copyright_label,
        IXLLabel: strings.footer_meta_copyright_IXL,
        destination: "/"
      },
      ixl_logo: footerIxlLogo({
        strings: strings
      }),
      rs_logo: footerRsLogo({
        strings: strings
      }),
      ccpa: {
        visible: true,
        label: strings.footer_meta_ccpa_label,
        destination: "https://www.rosettastone.com/lp/ccpa/"
      },
      cookieSettings: {
        visible: true,
        label: strings.footer_meta_cookie_settings_label,
        destination: "#"
      },
      agreements: {
        visible: true,
        label: strings.footer_meta_agreements_label,
        destination: "https://www.rosettastone.com/agreements/"
      },
      termsConditions: {
        visible: true,
        label: strings.footer_meta_terms_conditions_label,
        destination: "https://resources.rosettastone.com/CDN/us/pdfs/eulas/US_terms_and_conditions.pdf"
      },
      privacyPolicy: {
        visible: true,
        label: strings.footer_meta_privacy_policy_label,
        destination: "https://resources.rosettastone.com/CDN/us/agreements/US_Privacy_Policy-102513.pdf"
      }
    },
    region_social: {
      visible: true,
      region: {
        visible: true,
        label: strings.footer_region_label,
        options: [{
          destination: "https://www.rosettastone.com/",
          label: strings.footer_region_options_us_label
        }, {
          destination: "https://espanol.rosettastone.com/",
          label: strings.footer_region_options_la_label
        }, {
          destination: "https://www.therosettastone.com.au/",
          label: strings.footer_region_options_au_label
        }, {
          destination: "https://pt.rosettastone.com/",
          label: strings.footer_region_options_br_label
        }, {
          destination: "https://www.rosettastone.cn/",
          label: strings.footer_region_options_cn_label
        }, {
          destination: "https://www.rosettastone.de/",
          label: strings.footer_region_options_de_label
        }, {
          destination: "https://www.rosettastone.eu/",
          label: strings.footer_region_options_eu_label
        }, {
          destination: "https://www.rosettastone.es/",
          label: strings.footer_region_options_es_label
        }, {
          destination: "https://www.rosettastone.fr/",
          label: strings.footer_region_options_fr_label
        }, {
          destination: "https://www.rosettastone.it/",
          label: strings.footer_region_options_it_label
        }, {
          destination: "https://www.rosettastone.co.uk/",
          label: strings.footer_region_options_uk_label
        }, {
          destination: "https://www.rosettastone.co.jp/",
          label: strings.footer_region_options_jp_label
        }, {
          destination: "https://www.rosettastone.co.kr/",
          label: strings.footer_region_options_kr_label
        }]
      },
      social: {
        visible: true,
        label: strings.footer_social_label,
        options: [{
          service: "facebook",
          destination: "https://www.facebook.com/RosettaStone",
          image: social.facebookDarkSvg
        }, {
          service: "twitter",
          destination: "https://twitter.com/rosettastone",
          image: social.twitterDarkSvg
        }, {
          service: "instagram",
          destination: "https://www.instagram.com/rosettastone",
          image: social.instagramDarkSvg
        }, {
          service: "youtube",
          destination: "https://www.youtube.com/user/rosettastone",
          image: social.youtubeDarkSvg
        }]
      }
    }
  };
});

var us = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale,
      strings = _ref.strings;
  var nav_secondary = null;
  var page_config = null;
  var footer_config = null;

  switch (site) {
    case "consumer":
      page_config = consumer_pages_config({
        page: page,
        strings: strings
      });
      footer_config = consumer_footer_config({
        strings: strings
      });
      break;

    case "consumer-seo":
      page_config = consumer_seo_pages_config({
        page: page,
        strings: strings
      });
      footer_config = consumer_seo_footer_config({
        strings: strings
      });
      break;

    case "consumer-lausd":
      page_config = consumer_lausd_pages_config({
        page: page,
        strings: strings
      });
      footer_config = consumer_lausd_footer_config({
        strings: strings
      });
      break;

    case "business":
    case "enterprise":
      nav_secondary = enterprise_nav_secondary_config({
        strings: strings
      });
      page_config = enterprise_pages_config({
        page: page,
        strings: strings
      });
      footer_config = enterprise_footer_config({
        strings: strings
      });
      break;

    case "homeschool":
    case "education-homeschool":
      nav_secondary = education_homeschool_nav_secondary_config({
        strings: strings
      });
      page_config = education_homeschool_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_homeschool_footer_config({
        strings: strings
      });
      break;

    case "education-homeschool-seo":
      page_config = education_homeschool_seo_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_homeschool_seo_footer_config({
        strings: strings
      });
      break;

    case "k12":
    case "education-primary":
      nav_secondary = education_primary_nav_secondary_config({
        strings: strings
      });
      page_config = education_primary_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_primary_footer_config({
        strings: strings
      });
      break;

    case "hed":
    case "education-secondary":
      nav_secondary = education_secondary_nav_secondary_config({
        strings: strings
      });
      page_config = education_secondary_pages_config({
        page: page,
        strings: strings
      });
      footer_config = education_secondary_footer_config({
        strings: strings
      });
      break;
  }

  var nav_primary = nav_primary_config({
    strings: strings
  });
  return {
    market: market,
    site: site,
    vertical: site,
    // leaving this for legacy configuration
    locale: locale,
    analytics: analytics,
    nav: {
      visible: true,
      primary: nav_primary || null,
      secondary: nav_secondary || null
    },
    footer: _objectSpread2({
      visible: true
    }, footer_config),
    page: page_config
  };
});

var strings_de_DE = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabisch",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Deutsch",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Griechisch",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Englisch",
  locale_en_gb_label_secondary: "Britisch",
  locale_en_us_label_primary: "Englisch",
  locale_en_us_label_secondary: "Amerikanisch",
  locale_es_es_label_primary: "Spanisch",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Spanisch",
  locale_es_la_label_secondary: "Lateinamerika",
  locale_fa_ir_label_primary: "Persisch",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "Französisch",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irisch",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebräisch",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italienisch",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanisch",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Koreanisch",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Niederländisch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polnisch",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portugiesisch",
  locale_pt_br_label_secondary: "Brazil",
  locale_ru_ru_label_primary: "Russisch",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Schwedisch",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Philippinisch",
  locale_tl_ph_label_secondary: "Tagalog",
  locale_tr_tr_label_primary: "Türkisch",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamesisch",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinesisch",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Magazine",
  nav_primary_catalog_label: "Sprachen Und Preise",
  nav_primary_catalog_select_language_label: "Wähle eine Sprache",
  nav_primary_contact_label: "Kontakt",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Fragen? Ruf Sie uns an:",
  nav_primary_phone_number: "0800 724 0778",
  nav_primary_sign_in_label: "Login",
  nav_primary_support_label: "Support",
  nav_primary_switch_language: "",
  nav_primary_vertical_consumer_label: "",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Bildungseinrichtungen",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Unternehmen",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Home",
  nav_secondary_enterprise_label: "Unternehmen",
  nav_secondary_enterprise_resources_label: "Ressourcen",
  nav_secondary_enterprise_solutions_label: "Lösungen",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Home",
  nav_secondary_education_primary_label: "Schulen",
  nav_secondary_education_primary_resources_label: "Ressourcen",
  nav_secondary_education_primary_solutions_label: "Lösungen",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "",
  nav_secondary_education_secondary_label: "",
  nav_secondary_education_secondary_resources_label: "",
  nav_secondary_education_secondary_solutions_label: "",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Seit 25+ Jahren von Top-Organisationen genutzt",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Was die Leute über uns sagen",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;Der <em>Gold-Status</em> an computerbasiertem Sprachenlernen.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Ich bin von der Rosetta Stone Sprachlernlösung begeistert und fest davon überzeugt, <em>dass der Lernansatz funktioniert.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Mit den benutzerfreundlichen Interfaces, klaren Anweisungen sowie der großen Auswahl an Spielen und sonstigen Lern-Tools hat es <em>Rosetta Stone einfach drauf.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Welche Art von Lerner bist du?",
  verticals_education_primary: "Schulen",
  verticals_education_secondary: "Hochschulen",
  verticals_enterprise: "Unternehmen",
  verticals_publicsector: "Öffentlicher Sektor",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_form_comments: "Wie können wir Ihnen weiter helfen?",
  footer_cta_form_country: "Country",
  footer_cta_form_email: "E-Mail",
  footer_cta_form_firstname: "Vorname",
  footer_cta_form_lastname: "Nachname",
  footer_cta_form_organization: "Unternehmen",
  footer_cta_form_organizationsize: "form_organizationsize",
  footer_cta_form_organizationsize_100: "form_100",
  footer_cta_form_organizationsize_500: "form_500",
  footer_cta_form_organizationsize_1000: "form_1000",
  footer_cta_form_organizationsize_5000: "form_5000",
  footer_cta_form_organizationsize_10000: "form_10000",
  footer_cta_form_organizationsize_25000: "form_25000",
  footer_cta_form_organizationsize_50000: "form_50000",
  footer_cta_form_organizationsize_more: "form_more",
  footer_cta_form_phone: "Telefonnummer (optional)",
  footer_cta_form_pricing_thanks: "Danke für Ihr Interesse! In Kürze wird sich jemand mit Ihnen in Verbindung setzen.",
  footer_cta_form_role: "Rolle (oder Titel)",
  footer_cta_form_role_boardmember: "Vorstandsmitglied",
  footer_cta_form_role_curriculumdirector: "Lehrplanleiter / Instruktionskoordinator",
  footer_cta_form_role_director: "Direktor",
  footer_cta_form_role_executive: "Geschäftsführung / Executive",
  footer_cta_form_role_individualcontributor: "Einzelner Mitwirkender",
  footer_cta_form_role_manager: "Manager",
  footer_cta_form_role_principal: "Auftraggeber / Vizepräsident",
  footer_cta_form_role_superintendent: "Superintendent/District Administrator",
  footer_cta_form_role_teacher: "Lehrer",
  footer_cta_form_role_techcoordinator: "Technologiekoordinator",
  footer_cta_form_role_vicepresident: "Vizepräsident",
  footer_cta_form_submit: "JETZT ANGEBOT ANFORDERN",
  footer_cta_opt_in_learn_more_button_text: "Mehr erfahren",
  footer_cta_opt_in_learn_more_link_text_1: "Datenschutzrichtlinie von Rosetta Stone ",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
  footer_cta_opt_in_learn_more_text_1: "Ich stimme dem Erhalt von Info- und Marketingmaterial über Produktneuigkeiten, Angebote oder Einladungen zu Veranstaltungen von Rosetta Stone zu. Es ist mir bewusst, dass meine Daten mit internationalen Partnern, die Dienstleistungen für Rosetta Stone anbieten im Rahmen der",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: " kontaktiere.",
  footer_cta_opt_in_text_after_button: "",
  footer_cta_opt_in_text_before_button: "Ja, ich möchte Produktneuigkeiten und Angebote von Rosetta Stone erhalten. ",
  footer_cta_pricing_button: "ANGEBOT ANFORDERN",
  footer_cta_pricing_label: "Bereit für den nächsten Schritt?",
  footer_cta_pricing_subtitle: "Haben wir Ihr Interesse geweckt? Fordern Sie Ihr individuelles Angebot an.",
  footer_cta_pricing_title: "Bitte ausfüllen und wir melden uns umgehend bei Ihnen.",
  // Menu
  footer_menu_about_about_us_label: "Über Uns",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Karriere",
  footer_menu_about_contact_label: "Kontakt",
  footer_menu_about_label: "Unternehmen",
  footer_menu_about_press_label: "Presse",
  footer_menu_products_consumer_label: "Für Einzelpersonen",
  footer_menu_products_education_primary_label: "Bildungseinrichtungen",
  footer_menu_products_education_secondary_label: "Für Hochschullehrer",
  footer_menu_products_enterprise_label: "Unternehmen",
  footer_menu_products_label: "Überblick",
  footer_menu_products_publicsector_label: "Öffentlicher Sektor",
  footer_menu_support_faqs_label: "FAQs",
  footer_menu_support_label: "Support",
  footer_menu_support_support_site_label: "Support Site",
  footer_menu_support_system_requirements_label: "Systemanforderungen",
  footer_meta_agreements_label: "Vereinbarungen",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Cookie-Einstellungen",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: " Rosetta Stone GmbH. Alle Rechte vorbehalten.",
  footer_meta_privacy_policy_label: "Datenschutzrichtlinie",
  footer_meta_terms_conditions_label: "Nutzungsbedingungen",
  // Region
  footer_region_label: "Region ändern",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Kontaktieren Sie uns",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_en_GB = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabic",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "German",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greek",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "English",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "English",
  locale_en_us_label_secondary: "American",
  locale_es_es_label_primary: "Spanish",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Spanish",
  locale_es_la_label_secondary: "Latin America",
  locale_fa_ir_label_primary: "Persian",
  locale_fa_ir_label_secondary: "",
  locale_fr_fr_label_primary: "French",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irish",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebrew",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italian",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Korean",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Dutch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polish",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portuguese",
  locale_pt_br_label_secondary: "",
  locale_ru_ru_label_primary: "Russian",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Swedish",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "",
  locale_tr_tr_label_primary: "Turkish",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamese",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinese",
  locale_zn_cn_label_secondary: "",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Magazine",
  nav_primary_catalog_label: "Languages & Pricing",
  nav_primary_catalog_select_language_label: "Select a language",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Questions?",
  nav_primary_phone_number: "1 (800) 306-3467",
  nav_primary_sign_in_label: "Sign In",
  nav_primary_support_label: "Support",
  nav_primary_switch_language: "",
  nav_primary_vertical_consumer_label: "",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "For Educators",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "For Enterprise",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Home",
  nav_secondary_enterprise_label: "Enterprise",
  nav_secondary_enterprise_resources_label: "Resources",
  nav_secondary_enterprise_solutions_label: "Solutions",
  // Solutions
  nav_secondary_enterprise_solutions_consulting_label: "Consulting",
  nav_secondary_enterprise_solutions_financial_label: "Financial",
  nav_secondary_enterprise_solutions_logistics_label: "Logistics",
  nav_secondary_enterprise_solutions_manufacturing_label: "Manufacturing",
  nav_secondary_enterprise_solutions_pharmaceutical_label: "Pharmaceutical",
  nav_secondary_enterprise_solutions_retail_label: "Retail",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Home",
  nav_secondary_education_primary_label: "Schools",
  nav_secondary_education_primary_resources_label: "Resources",
  nav_secondary_education_primary_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "",
  nav_secondary_education_secondary_label: "",
  nav_secondary_education_secondary_resources_label: "",
  nav_secondary_education_secondary_solutions_label: "",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // Shared - Awards
  // ******************************************
  awards_header_label: "Trusted for 25+ years by top organizations.",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "What people say about us.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;The <em>gold standard</em> of computer-based language learning.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;I love Rosetta Stone's software, and I think <em>the approach to learning languages works.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;With its excellent user interface, clear instructions, wide variety of games and challenges...  <em>Rosetta Stone has got it going on.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "Keep Exploring",
  related_resources_button_label: "Read more",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "What type of learner are you?",
  verticals_education_primary: "Schools",
  verticals_enterprise: "Enterprise",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "Sign Up",
  footer_cta_email_main_label: "Sign up to stay in touch.",
  footer_cta_email_placeholder: "Sign Up",
  footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
  footer_cta_form_comments: "How Can We Help?",
  footer_cta_form_country: "Country",
  footer_cta_form_email: "Email Address",
  footer_cta_form_firstname: "First Name",
  footer_cta_form_lastname: "Surname",
  footer_cta_form_organization: "Institution",
  footer_cta_form_organizationsize: "form_organizationsize",
  footer_cta_form_organizationsize_100: "form_100",
  footer_cta_form_organizationsize_500: "form_500",
  footer_cta_form_organizationsize_1000: "form_1000",
  footer_cta_form_organizationsize_5000: "form_5000",
  footer_cta_form_organizationsize_10000: "form_10000",
  footer_cta_form_organizationsize_25000: "form_25000",
  footer_cta_form_organizationsize_50000: "form_50000",
  footer_cta_form_organizationsize_more: "form_more",
  footer_cta_form_phone: "Phone Number (Optional)",
  footer_cta_form_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
  footer_cta_form_role: "Role (or title)",
  footer_cta_form_role_boardmember: "Board Member",
  footer_cta_form_role_curriculumdirector: "Curriculum Director/Instruction Coordinator",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "General Management/Executive",
  footer_cta_form_role_individualcontributor: "Individual Contributor",
  footer_cta_form_role_manager: "Manager",
  footer_cta_form_role_principal: "Principal/Vice Principal",
  footer_cta_form_role_superintendent: "Superintendent/District Administrator",
  footer_cta_form_role_teacher: "Teacher",
  footer_cta_form_role_techcoordinator: "Technology Coordinator",
  footer_cta_form_role_vicepresident: "Vice President",
  footer_cta_form_submit: "Submit",
  footer_cta_opt_in_learn_more_button_text: "here",
  footer_cta_opt_in_learn_more_link_text_1: "Privacy Policy",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://www.rosettastone.co.uk/docs/terms/RS-UK_Website%20Privacy%20Policy_05252018.pdf",
  footer_cta_opt_in_learn_more_text_1: "By confirming, I agree to receive information and marketing relating to news, updates on Rosetta Stone products and services, offers, and invitations to events from Rosetta Stone, and I understand and agree that Rosetta Stone may process and transfer my information to its affiliates globally and to third party entities that provide services to Rosetta Stone for such purposes, in accordance with Rosetta Stone's ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "for more information.",
  footer_cta_opt_in_text_before_button: "Yes! I would like to receive product updates and marketing from Rosetta Stone. Click ",
  footer_cta_pricing_button: "Request Pricing",
  footer_cta_pricing_label: "Ready to begin your organisation’s complete language journey?",
  footer_cta_pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
  footer_cta_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
  footer_cta_pricing_title: "Get the pricing answers you need.",
  // Menu
  footer_menu_about_about_us_label: "About Us",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Careers",
  footer_menu_about_contact_label: "Contact",
  footer_menu_about_label: "About",
  footer_menu_about_press_label: "Press",
  footer_menu_products_consumer_label: "For Individuals",
  footer_menu_products_education_primary_label: "For Schools",
  footer_menu_products_education_secondary_label: "For Higher Education",
  footer_menu_products_enterprise_label: "For Enterprise",
  footer_menu_products_label: "Products",
  footer_menu_support_faqs_label: "FAQs",
  footer_menu_support_label: "Support",
  footer_menu_support_support_site_label: "Support Site",
  footer_menu_support_system_requirements_label: "System Requirements",
  // Meta
  footer_meta_agreements_label: "Agreements",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Cookie Settings",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone Ltd. All Rights Reserved.",
  footer_meta_privacy_policy_label: "Privacy Policy",
  footer_meta_terms_conditions_label: "Terms & Conditions",
  // Region
  footer_region_label: "Change Region",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Connect with us",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_en_US = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabic",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "German",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greek",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "English",
  locale_en_gb_label_secondary: "British",
  locale_en_us_label_primary: "English",
  locale_en_us_label_secondary: "American",
  locale_es_es_label_primary: "Spanish",
  locale_es_es_label_secondary: "Spain",
  locale_es_la_label_primary: "Spanish",
  locale_es_la_label_secondary: "Latin America",
  locale_fa_ir_label_primary: "Persian",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "French",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irish",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebrew",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italian",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Korean",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Dutch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polish",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portuguese",
  locale_pt_br_label_secondary: "Brazil",
  locale_ru_ru_label_primary: "Russian",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Swedish",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "Tagalog",
  locale_tr_tr_label_primary: "Turkish",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamese",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinese",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Languages & Pricing",
  nav_primary_catalog_select_language_label: "Select a language",
  nav_primary_contact_label: "Contact",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Questions?",
  nav_primary_phone_number: "1-800-767-3882",
  nav_primary_sign_in_label: "Sign In",
  nav_primary_support_label: "Support",
  nav_primary_switch_language: "Español",
  nav_primary_vertical_consumer_label: "For You",
  nav_primary_vertical_education_for_homeschool_label: "For Homeschool",
  nav_primary_vertical_education_for_students_label: "For Students",
  nav_primary_vertical_education_homeschool_label: "Homeschool",
  nav_primary_vertical_education_primary_label: "For Schools",
  nav_primary_vertical_education_secondary_label: "For Higher Education",
  nav_primary_vertical_education_students_label: "Students",
  nav_primary_vertical_enterprise_label: "For Enterprise",
  nav_primary_vertical_for_young_learners_label: "For Young Learners",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Home",
  nav_secondary_enterprise_label: "Enterprise",
  nav_secondary_enterprise_resources_label: "Resources",
  nav_secondary_enterprise_solutions_label: "Solutions",
  // Solutions
  nav_secondary_enterprise_solutions_construction_label: "Construction",
  nav_secondary_enterprise_solutions_consulting_label: "Consulting",
  nav_secondary_enterprise_solutions_foodservice_label: "Food Service",
  nav_secondary_enterprise_solutions_government_label: "Government",
  nav_secondary_enterprise_solutions_healthcare_label: "Healthcare",
  nav_secondary_enterprise_solutions_hospitality_label: "Hospitality",
  nav_secondary_enterprise_solutions_manufacturing_label: "Manufacturing",
  nav_secondary_enterprise_solutions_retail_label: "Retail",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "Blog",
  nav_secondary_education_primary_home_label: "Home",
  nav_secondary_education_primary_label: "Schools",
  nav_secondary_education_primary_resources_label: "Resources",
  nav_secondary_education_primary_solutions_label: "Solutions",
  // Solutions
  nav_secondary_education_primary_solutions_k12_english_language: "K12 English Language",
  nav_secondary_education_primary_solutions_world_languages: "World Languages",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "Blog",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Home",
  nav_secondary_education_secondary_label: "Higher Education",
  nav_secondary_education_secondary_resources_label: "Resources",
  nav_secondary_education_secondary_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "Blog",
  nav_secondary_education_homeschool_home_label: "Home",
  nav_secondary_education_homeschool_label: "Homeschool",
  nav_secondary_education_homeschool_resources_label: "Resources",
  nav_secondary_education_homeschool_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Trusted for 25+ years by top organizations.",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "What people say about us.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;The <em>gold standard</em> of computer-based language learning.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;I love Rosetta Stone's software, and I think <em>the approach to learning languages works.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;With its excellent user interface, clear instructions, wide variety of games and challenges...  <em>Rosetta Stone has got it going on.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "Keep Exploring",
  related_resources_button_label: "Read more",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "What type of learner are you?",
  verticals_education_primary: "Schools",
  verticals_education_secondary: "Higher Education",
  verticals_enterprise: "Enterprise",
  verticals_publicsector: "Public Sector",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "Sign Up",
  footer_cta_email_main_label: "Sign up to stay in touch.",
  footer_cta_email_placeholder: "Sign Up",
  footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
  footer_cta_form_comments: "",
  footer_cta_form_country: "Country",
  footer_cta_form_email: "Email Address",
  footer_cta_form_firstname: "First Name",
  footer_cta_form_lastname: "Last Name",
  footer_cta_form_organization: "Organization Name",
  footer_cta_form_organizationsize: "form_organizationsize",
  footer_cta_form_organizationsize_100: "form_100",
  footer_cta_form_organizationsize_500: "form_500",
  footer_cta_form_organizationsize_1000: "form_1000",
  footer_cta_form_organizationsize_5000: "form_5000",
  footer_cta_form_organizationsize_10000: "form_10000",
  footer_cta_form_organizationsize_25000: "form_25000",
  footer_cta_form_organizationsize_50000: "form_50000",
  footer_cta_form_organizationsize_more: "form_more",
  footer_cta_form_phone: "Phone Number (Optional)",
  footer_cta_form_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
  footer_cta_form_role: "Role (or title)",
  footer_cta_form_role_boardmember: "Board Member",
  footer_cta_form_role_curriculumdirector: "Curriculum Director/Instruction Coordinator",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "General Management/Executive",
  footer_cta_form_role_individualcontributor: "Individual Contributor",
  footer_cta_form_role_manager: "Manager",
  footer_cta_form_role_principal: "Principal/Vice Principal",
  footer_cta_form_role_superintendent: "Superintendent/District Administrator",
  footer_cta_form_role_teacher: "Teacher",
  footer_cta_form_role_techcoordinator: "Technology Coordinator",
  footer_cta_form_role_vicepresident: "Vice President",
  footer_cta_form_submit: "Submit",
  footer_cta_pricing_button: "Request Pricing",
  footer_cta_pricing_label: "Ready to begin your organization’s complete language journey?",
  footer_cta_pricing_subtitle: "Please fill out the form below and we'll follow up with you right away.",
  footer_cta_pricing_thanks: "Thanks for your interest! Someone will follow up with you shortly.",
  footer_cta_pricing_title: "Get the pricing answers you need.",
  // Menu
  footer_menu_about_about_us_label: "About Us",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Careers",
  footer_menu_about_coaches_label: "Meet Our Coaches",
  footer_menu_about_contact_label: "Contact",
  footer_menu_about_endangered_languages_label: "Endangered Languages",
  footer_menu_about_investor_relationss_label: "Investor Relations",
  footer_menu_about_investors_label: "Investors",
  footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
  footer_menu_about_label: "About",
  footer_menu_about_military_discount_label: "Military Discount",
  footer_menu_about_teacher_discount_label: "Teacher Discount",
  footer_menu_about_frontline_discount_label: "Frontline Heros Discount",
  footer_menu_about_press_label: "Press",
  footer_menu_about_retail_partners_label: "Retail Partners",
  footer_menu_about_student_discount_label: "Student Discount",
  footer_menu_buy_all_label: "See All Languages",
  footer_menu_buy_english_label: "English",
  footer_menu_buy_espanol_label: "Rosetta Stone Español",
  footer_menu_buy_french_label: "French",
  footer_menu_buy_german_label: "German",
  footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
  footer_menu_buy_ingles_label: "Inglés",
  footer_menu_buy_italian_label: "Italian",
  footer_menu_buy_label: "Buy Now",
  footer_menu_buy_portugues_label: "Rosetta Stone Português",
  footer_menu_buy_spanish_label: "Spanish",
  footer_menu_foreign_curriculum_label: "Homeschool Foreign Language Curriculum",
  footer_menu_gifts_label: "Gifts",
  footer_menu_homeschool_program_label: "Homeschool Program",
  footer_menu_homeschool_travel_label: "Homeschool Travel",
  footer_menu_learn_chinese_label: "Learn Chinese",
  footer_menu_learn_english_label: "Learn English",
  footer_menu_learn_french_label: "Learn French",
  footer_menu_learn_german_label: "Learn German",
  footer_menu_learn_ingles_label: "Aprende Inglés",
  footer_menu_learn_italian_label: "Learn Italian",
  footer_menu_learn_japanese_label: "Learn Japanese",
  footer_menu_learn_label: "Learn More",
  footer_menu_learn_languages_label: "Learn a Language",
  footer_menu_learn_spanish_label: "Learn Spanish",
  footer_menu_online_curriculum_label: "Online Homeschool Curriculum",
  footer_menu_products_consumer_label: "For Individuals",
  footer_menu_products_education_homeschool_label: "For Homeschool",
  footer_menu_products_education_primary_label: "For Schools",
  footer_menu_products_enterprise_label: "For Enterprise",
  footer_menu_products_label: "Products",
  footer_menu_start_activation_label: "Product Activation",
  footer_menu_start_blog_label: "Blog",
  footer_menu_start_demo_label: "Try it Free",
  footer_menu_start_education_primary_label: "For Schools",
  footer_menu_start_enterprise_label: "For Enterprise",
  footer_menu_start_homeschool_retailers_label: "Authorized Retailers",
  footer_menu_start_homeschool_reviews_label: "Homeschool Reviews",
  footer_menu_start_label: "Where to Start",
  footer_menu_start_mobile_label: "Mobile Apps",
  footer_menu_start_reviews_label: "Reviews",
  footer_menu_start_speech_label: "Speech Recognition",
  footer_menu_start_testamonials_label: "Testimonials",
  footer_menu_start_translate_label: "Translate",
  footer_menu_support_accessibility_statement_label: "Accessibility Statement",
  footer_menu_support_contact_us_label: "Contact Us",
  footer_menu_support_faqs_label: "FAQs",
  footer_menu_support_label: "Support",
  footer_menu_support_support_site_label: "Support Site",
  footer_menu_support_system_requirements_label: "System Requirements",
  // Meta
  footer_meta_agreements_label: "Agreements",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Cookie Settings",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone Ltd. All Rights Reserved.",
  footer_meta_privacy_policy_label: "Privacy Policy",
  footer_meta_terms_conditions_label: "Terms & Conditions",
  // Region
  footer_region_label: "Change Region",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Connect with us",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube",
  // Opdemo2 Hero
  opdemo2_hero_heading: "TRY ROSETTA STONE FOR FREE",
  opdemo2_hero_subheading: "Take our language learning demo. Discover the power of Rosetta Stone.",
  opdemo2_button_heading: "Ready for a free demo?",
  opdemo2_button_custom_cta_text: "START FREE TRIAL",
  // Opdemo2 Top Sections
  opdemo2_top_section_one_title_content: "The best way to learn a language is to surround yourself with it, so our Dynamic Immersion® method does just that.",
  opdemo2_top_section_one_body_content: "Our language learning program is the result of 20+ years of extensive research. Meticulously crafted by our expert linguists, each of our courses presents information for optimal impact and performance, leading to quick results.",
  opdemo2_top_section_two_title_content: "TruAccent® speech recognition technology",
  opdemo2_top_section_two_body_content: "Your accent matters. Our patented speech engine instantly compares your voice to thousands of native and non-native speakers, so you get real-time feedback for the most accurate pronunciation. It’s also adjustable, which allows you to fine-tune your accent.",
  opdemo2_top_section_three_title_content: "Speak up before you head out",
  opdemo2_top_section_three_body_content: "It can feel daunting to speak up in public, but confidence comes from practice. That’s why Rosetta Stone has Live Tutoring sessions with native-speaking tutors to help along the way. Available for in-product purchase.",
  opdemo2_top_section_four_title_content: "Audio Companion® lessons",
  opdemo2_top_section_four_body_content: "Conveniently listen and learn offline with downloadable Audio Companion® lessons.",
  opdemo2_top_section_five_title_content: "Anywhere, anytime lessons.",
  opdemo2_top_section_five_body_content: "Pick up where you left off with lessons that never leave your side—from your desktop, tablet, or smartphone. Perfect for learning at your own pace.",
  // Opdemo2 Bottom Sections
  opdemo2_bottom_section_title_heading: "We're always improving our mobile learning tools.",
  opdemo2_bottom_section_feature_bullet_one_heading: "Don't get lost in translation*.",
  opdemo2_bottom_section_feature_bullet_one_subheading: "If you’re stuck on a word, you can now instantly translate it––so you can get back to learning, fast.",
  opdemo2_bottom_section_feature_bullet_two_heading: "Learn using your surroundings.",
  opdemo2_bottom_section_feature_bullet_two_subheading: "Seek & Speak† turns everyday objects into conversation practice with scavenger-hunt style challenges.",
  opdemo2_bottom_section_feature_bullet_three_heading: "Set your lessons to your lifestyle.**",
  opdemo2_bottom_section_feature_bullet_three_subheading: "Language confidence comes with practice, so Your Plan is designed with you in mind. Focus your lessons on relevant material, get motivational reminders, and keep up the good work.",
  opdemo2_bottom_section_feature_bullet_four_subheading: "* Available for Unit 1 of English, French German, Italian, and Spanish (Latin America)",
  opdemo2_bottom_section_feature_bullet_five_subheading: "** Available on Android devices.",
  opdemo2_bottom_section_feature_bullet_six_subheading: "†Available in select languages on iOS. Android coming soon.",
  // Opdemo2 Product Unit Cards
  opdemo2_unit_card_one_unit_content: "Unit 1",
  opdemo2_unit_card_one_description_content: "Language Basics",
  opdemo2_unit_card_two_unit_content: "Unit 2",
  opdemo2_unit_card_two_description_content: "Greetings and Introductions",
  opdemo2_unit_card_three_unit_content: "Unit 3",
  opdemo2_unit_card_three_description_content: "Work and School",
  opdemo2_unit_card_four_unit_content: "Unit 4",
  opdemo2_unit_card_four_description_content: "Shopping",
  opdemo2_unit_card_five_unit_content: "Unit 5",
  opdemo2_unit_card_five_description_content: "Travel",
  opdemo2_unit_card_six_unit_content: "Unit 6",
  opdemo2_unit_card_six_description_content: "Past & Future",
  opdemo2_unit_card_seven_unit_content: "Unit 7",
  opdemo2_unit_card_seven_description_content: "Friends & Social Life",
  opdemo2_unit_card_eight_unit_content: "Unit 8",
  opdemo2_unit_card_eight_description_content: "Dining & Vacation",
  opdemo2_unit_card_nine_unit_content: "Unit 9",
  opdemo2_unit_card_nine_description_content: "Home & Health",
  opdemo2_unit_card_ten_unit_content: "Unit 10",
  opdemo2_unit_card_ten_description_content: "Life & World",
  opdemo2_unit_card_eleven_unit_content: "Unit 11",
  opdemo2_unit_card_eleven_description_content: "Everyday Things",
  opdemo2_unit_card_twelve_unit_content: "Unit 12",
  opdemo2_unit_card_twelve_description_content: "Places & Events",
  opdemo2_unit_card_thirteen_unit_content: "Unit 13",
  opdemo2_unit_card_thirteen_description_content: "Tourism & Recreation",
  opdemo2_unit_card_fourteen_unit_content: "Unit 14",
  opdemo2_unit_card_fourteen_description_content: "Professions & Hobbies",
  opdemo2_unit_card_fifteen_unit_content: "Unit 15",
  opdemo2_unit_card_fifteen_description_content: "Greetings and Introductions",
  opdemo2_unit_card_sixteen_unit_content: "Unit 16",
  opdemo2_unit_card_sixteen_description_content: "Style & Personal Wellness",
  opdemo2_unit_card_seventeen_unit_content: "Unit 17",
  opdemo2_unit_card_seventeen_description_content: "Business & Industry",
  opdemo2_unit_card_eighteen_unit_content: "Unit 18",
  opdemo2_unit_card_eighteen_description_content: "Arts & Academics",
  opdemo2_unit_card_nineteen_unit_content: "Unit 19",
  opdemo2_unit_card_nineteen_description_content: "Emergency Situations",
  opdemo2_unit_card_twenty_unit_content: "Unit 20",
  opdemo2_unit_card_twenty_description_content: "Family & Community",
  // Mobile Apps Page Section Panels
  mobile_apps_top_section_one_title_content: "Rosetta Stone app.",
  mobile_apps_top_section_one_body_content: "With a variety of speaking-focused lessons and features, instantaneous pronunciation feedback with TruAccent, a track record of getting people speaking confidently and a near-five star rating in the app store, the award-winning Rosetta Stone mobile app is the best way to learn new languages.",
  mobile_apps_top_section_one_custom_cta_text: "START FREE TRIAL",
  mobile_apps_top_section_two_title_content: "Rosetta Stone helps you speak confidently.",
  mobile_apps_top_section_two_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
  mobile_apps_top_section_two_feature_heading_content_one: "Speak confidently.",
  mobile_apps_top_section_two_feature_subheading_content_one: "TruAccent® technology provides real-time pronunciation feedback.",
  mobile_apps_top_section_two_feature_heading_content_two: "Go beyond memorization.",
  mobile_apps_top_section_two_feature_subheading_content_two: "Learn in context using our Dynamic Immersion® method.",
  mobile_apps_top_section_two_feature_heading_content_three: "Fits any schedule.",
  mobile_apps_top_section_two_feature_subheading_content_three: "Take a 10-minute lesson anywhere-online or off.",
  mobile_apps_top_section_two_feature_heading_content_four: "Never leaves your side.",
  mobile_apps_top_section_two_feature_subheading_content_four: "Practice here, there, and everywhere.",
  mobile_apps_top_section_two_feature_heading_content_five: "Don't get lost in translation.",
  mobile_apps_top_section_two_feature_subheading_content_five: "Touch and hold anything from your Core Lessons to reveal its translation*.",
  mobile_apps_top_section_two_feature_subheading_content_six: "*Available with select languages on the Rosetta Stone: Learn Languages app.",
  mobile_apps_top_section_three_title_content: "Extended Learning Features.",
  mobile_apps_top_section_three_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
  mobile_apps_top_section_three_feature_heading_content_one: "Say it like a local.",
  mobile_apps_top_section_three_feature_subheading_content_one: "Practice speaking by reading aloud while listening to native speakers with Stories.",
  mobile_apps_top_section_three_feature_heading_content_two: "Always know what to say.",
  mobile_apps_top_section_three_feature_subheading_content_two: "Get easy-to-understand greetings, phrases, expressions, and more with Phrasebook*. *Available on in select languages on the Rosetta Stone: Learn Languages app.",
  mobile_apps_top_section_three_feature_heading_content_three: "Train your ear.",
  mobile_apps_top_section_three_feature_subheading_content_three: "Take a break from the screen by listening to Audio Companion® lessons.",
  mobile_apps_bottom_section_one_title_content: "Need another reason?",
  mobile_apps_bottom_section_one_body_content: "Why the Rosetta Stone app? Because the best way to learn a new language is to surround yourself with it, and Rosetta Stone’s Dynamic Immersion® method does just that. Interactive and contextual lessons blend with Extended Learning features that are literally at your fingertips–any time, anywhere, any device; online or off.",
  // Mobile Apps Page Os Logos
  mobile_apps_os_logos_title_content: "Get Rosetta Stone on all your devices.",
  mobile_apps_os_logos_subtitle_content: "Web or app, anytime, anywhere, online or off, your lessons are ready."
};

var strings_es_419 = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Árabe",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Alemán",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Griego",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglés",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "Inglés",
  locale_en_us_label_secondary: "Americano",
  locale_es_es_label_primary: "Español",
  locale_es_es_label_secondary: "España",
  locale_es_la_label_primary: "Español",
  locale_es_la_label_secondary: "Latinoamérica",
  locale_fa_ir_label_primary: "Persa",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "Francés",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandés",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebreo",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japonés",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Holandés",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polaco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portugués",
  locale_pt_br_label_secondary: "",
  locale_ru_ru_label_primary: "Ruso",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Sueco",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chino",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Idiomas Y Precios",
  nav_primary_catalog_select_language_label: "Selecciona un idioma:",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "¿Preguntas? Llámenos",
  nav_primary_phone_number: "1 (800) 511-5689",
  nav_primary_sign_in_label: "INGRESAR",
  nav_primary_support_label: "Soporte",
  nav_primary_switch_language: "English",
  nav_primary_vertical_consumer_label: null,
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "Para Estudiantes",
  nav_primary_vertical_education_homeschool_label: null,
  nav_primary_vertical_education_primary_label: "Para Educadores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresa",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "Quiero ser Partner",
  nav_secondary_enterprise_home_label: "Inicio",
  nav_secondary_enterprise_label: "Empresa",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluciones",
  // Solutions
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "Blog",
  nav_secondary_education_primary_custom_1_label: "Quiero ser Partner",
  nav_secondary_education_primary_home_label: "Inicio",
  nav_secondary_education_primary_label: "Educación",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "Blog",
  nav_secondary_education_secondary_custom_1_label: "Quiero ser Partner",
  nav_secondary_education_secondary_home_label: "Inicio",
  nav_secondary_education_secondary_label: "Educación Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Avalada durante 25+ años por las mejores organizaciones.",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Qué dice la gente de nosotros.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>La joya de la corona</em>entre los métodos de aprendizaje de idiomas por ordenador.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;”Me encanta el programa de Rosetta Stone y creo que su método para <em>aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot; “Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "¿Qué tipo de aprendiz eres?",
  verticals_education_primary: "Educación",
  verticals_education_secondary: "Educación Superior ",
  verticals_enterprise: "Empresa",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "Sign Up",
  footer_cta_email_main_label: "Sign up to stay in touch.",
  footer_cta_email_placeholder: "Sign Up",
  footer_cta_email_sub_label: "Get Rosetta Stone news and offers.",
  footer_cta_form_comments: "",
  footer_cta_form_country: "País",
  footer_cta_form_email: "E-mail profesional",
  footer_cta_form_firstname: "Nombre",
  footer_cta_form_lastname: "Apellidos",
  footer_cta_form_organization: "Nombre de la Organización",
  footer_cta_form_organizationsize: "Tamaño de la organización",
  footer_cta_form_organizationsize_100: "100 o Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Más",
  footer_cta_form_phone: "Numero de Teléfono (Opcional)",
  footer_cta_form_pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
  footer_cta_form_role: "Rol (o título)",
  footer_cta_form_role_boardmember: "Miembro de la Junta",
  footer_cta_form_role_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "Dirección General / Ejecutivo",
  footer_cta_form_role_individualcontributor: "Colaborador Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Director de la Escuela",
  footer_cta_form_role_superintendent: "Superintendente / Administrador de Distrito",
  footer_cta_form_role_teacher: "Profesor",
  footer_cta_form_role_techcoordinator: "Coordinador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vicepresidente",
  footer_cta_form_submit: "Consulta gratuita",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "En línea",
  footer_cta_how_hear_other: "Otro",
  footer_cta_how_hear_referral: "Remisión",
  footer_cta_how_hear_search: "Buscador",
  footer_cta_how_hear_social: "Medios Sociales",
  footer_cta_how_hear_title: "¿Como supiste de nosotros? (Opcional)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: " aquí",
  footer_cta_opt_in_learn_more_link_text_1: "aquí.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/es/pdfs/Spain_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para más información.",
  footer_cta_opt_in_text_before_button: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic",
  footer_cta_pricing_button: "CONSULTA DE PRECIOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
  footer_cta_pricing_thanks: "",
  footer_cta_pricing_title: "Obtenga las respuestas de precios que necesita.",
  // Menu
  footer_menu_about_about_us_label: "Acerca de Nosotros",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Empleo",
  footer_menu_about_contact_label: "Contáctanos",
  footer_menu_about_endangered_languages_label: "Idiomas en peligro de extinción",
  footer_menu_about_investor_relationss_label: "Investor Relations",
  footer_menu_about_investors_label: "Relaciones con Inversores",
  footer_menu_about_k12_reading_label: "Reading Solutions for K–12",
  footer_menu_about_label: "Acerca de",
  footer_menu_about_military_discount_label: "Descuento militar",
  footer_menu_about_press_label: "Prensa",
  footer_menu_about_retail_partners_label: "Tiendas Retail",
  footer_menu_about_student_discount_label: "Student Discount",
  footer_menu_buy_all_label: "Ver todos los idiomas",
  footer_menu_buy_chinese_label: "Comprar Chino",
  footer_menu_buy_english_label: "Comprar Inglés",
  footer_menu_buy_espanol_label: "Rosetta Stone Español",
  footer_menu_buy_french_label: "Comprar Francés",
  footer_menu_buy_german_label: "Comprar Alemán",
  footer_menu_buy_homeschool_label: "Rosetta Stone Homeschool",
  footer_menu_buy_ingles_label: "Inglés",
  footer_menu_buy_italian_label: "Comprar Italiano",
  footer_menu_buy_japanese_label: "Comprar Japonés",
  footer_menu_buy_label: "Comprar Idiomas",
  footer_menu_buy_spanish_label: "Comprar Español",
  footer_menu_gift_label: "Regalos",
  footer_menu_learn_chinese_label: "Learn Chinese",
  footer_menu_learn_english_label: "Aprender Ingles",
  footer_menu_learn_french_label: "Aprender Francés",
  footer_menu_learn_german_label: "Aprender Alemán",
  footer_menu_learn_ingles_label: "Aprende Inglés",
  footer_menu_learn_italian_label: "Aprender Italiano",
  footer_menu_learn_japanese_label: "Learn Japanese",
  footer_menu_learn_label: "Aprender Idiomas",
  footer_menu_learn_languages_label: "Learn a Language",
  footer_menu_learn_portuguese_label: "Aprender Portugués",
  footer_menu_products_demo_label: "Pruébalo gratis",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresa",
  footer_menu_products_label: "¿DÓNDE EMPEZAR?",
  footer_menu_products_mobile_label: "Apps para móvil",
  footer_menu_products_reviews_label: "Opiniones",
  footer_menu_start_activation_label: "Product Activation",
  footer_menu_start_blog_label: "Blog",
  footer_menu_start_demo_label: "Pruébalo Gratis",
  footer_menu_start_education_primary_label: "For Schools",
  footer_menu_start_enterprise_label: "For Enterprise",
  footer_menu_start_label: "Donde comenzar",
  footer_menu_start_mobile_label: "Aplicaciones Móviles",
  footer_menu_start_reviews_label: "Comentarios sobre Rosetta Stone",
  footer_menu_start_speech_label: "Speech Recognition",
  footer_menu_start_testamonials_label: "Testimonios de Rosetta Stone",
  footer_menu_start_translate_label: "Traduce Ahora",
  footer_menu_support_accessibility_statement_label: "Accessibility Statement",
  footer_menu_support_contact_us_label: "Contáctenos",
  footer_menu_support_faqs_label: "Preguntas Frecuentes",
  footer_menu_support_label: "Soporte",
  footer_menu_support_support_site_label: "Soporte Técnico",
  footer_menu_support_system_requirements_label: "Requisitos del sistema",
  // Meta
  footer_meta_agreements_label: "Acuerdos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configuración de Cookie",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone Ltd. Todos los derechos reservados.",
  footer_meta_privacy_policy_label: "Política de Privacidad",
  footer_meta_terms_conditions_label: "Términos y Condiciones",
  // Region
  footer_region_label: "Cambiar Región",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conéctate con nosotros",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube",
  // Mobile Apps Page Section Panels
  mobile_apps_top_section_one_title_content: "Aplicación de Rosetta Stone",
  mobile_apps_top_section_one_body_content: "Gracias a su variedad de lecciones y características enfocadas en los ejercicios orales, comentarios al instante sobre tu pronunciación con TruAccent, una amplia trayectoria de historias de éxito de personas que han conseguido hablar con confianza y casi cinco estrellas en la app store, la galardonada aplicación móvil de Rosetta Stone es la mejor forma de aprender nuevos idiomas.",
  mobile_apps_top_section_one_custom_cta_text: "Inicia tu prueba gratuita",
  mobile_apps_top_section_two_title_content: "Rosetta Stone te ayuda a hablar con confianza.",
  mobile_apps_top_section_two_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  mobile_apps_top_section_two_feature_heading_content_one: "Habla con confianza.",
  mobile_apps_top_section_two_feature_subheading_content_one: "La tecnología TruAccent® proporciona comentarios sobre tu pronunciación en tiempo real.",
  mobile_apps_top_section_two_feature_heading_content_two: "No te limites a memorizar.",
  mobile_apps_top_section_two_feature_subheading_content_two: "Aprende en contexto utilizando nuestro método Dynamic Immersion®.",
  mobile_apps_top_section_two_feature_heading_content_three: "Se adapta a cualquier horario.",
  mobile_apps_top_section_two_feature_subheading_content_three: "Toma una lección de 10 minutos en cualquier lugar, ya sea en línea o sin conexión.",
  mobile_apps_top_section_two_feature_heading_content_four: "Siempre está a tu lado.",
  mobile_apps_top_section_two_feature_subheading_content_four: "Practica aquí, allí o en cualquier lugar.",
  mobile_apps_top_section_two_feature_heading_content_five: "No te pierdas en la traducción.",
  mobile_apps_top_section_two_feature_subheading_content_five: "Mantén pulsado cualquier elemento de tus Lecciones principales para mostrar su traducción*.",
  mobile_apps_top_section_two_feature_subheading_content_six: "* Disponible con determinados idiomas en la aplicación Rosetta Stone: Aprende idiomas.",
  mobile_apps_top_section_three_title_content: "Características del Aprendizaje extendido.",
  mobile_apps_top_section_three_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  mobile_apps_top_section_three_feature_heading_content_one: "Aprende a hablar como un nativo.",
  mobile_apps_top_section_three_feature_subheading_content_one: "Practica tu pronunciación leyendo en voz alta mientras escuchas a hablantes nativos con las Historias.",
  mobile_apps_top_section_three_feature_heading_content_two: "Siempre sabrás qué decir.",
  mobile_apps_top_section_three_feature_subheading_content_two: "Aprende saludos, frases, expresiones, etc. fáciles de entender con la Guía de Conversación *. * Disponible en determinados idiomas en la aplicación Rosetta Stone: Aprende idiomas.",
  mobile_apps_top_section_three_feature_heading_content_three: "Entrena tu oído.",
  mobile_apps_top_section_three_feature_subheading_content_three: "Descansa la vista escuchando las lecciones de Audio Companion®.",
  mobile_apps_bottom_section_one_title_content: "¿Necesitas alguna otra razón más?",
  mobile_apps_bottom_section_one_body_content: "¿Por qué elegir la aplicación de Rosetta Stone? Porque la mejor manera de aprender un nuevo idioma es sumergirse en él, y esto es justo lo que puedes conseguir gracias al método Dynamic Immersion® de Rosetta Stone. Las lecciones interactivas y contextuales se combinan con las características de Aprendizaje extendido, que están literalmente al alcance de tu mano, en cualquier momento, en cualquier lugar y en cualquier dispositivo; ya sea en línea o sin conexión.",
  // Mobile Apps Page Os Logos
  mobile_apps_os_logos_title_content: "Consigue Rosetta Stone en todos tus dispositivos.",
  mobile_apps_os_logos_subtitle_content: "Tus lecciones te están esperando en la web o la aplicación, en cualquier momento y en cualquier lugar, en línea o sin conexión."
};

var strings_es_ES = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Árabe",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Alemán",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Griego",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglés",
  locale_en_gb_label_secondary: "británico",
  locale_en_us_label_primary: "Inglés",
  locale_en_us_label_secondary: "americano",
  locale_es_es_label_primary: "Español",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Español",
  locale_es_la_label_secondary: "latinoamérica",
  locale_fa_ir_label_primary: "Persa",
  locale_fa_ir_label_secondary: "farsi",
  locale_fr_fr_label_primary: "Francés",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandés",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebreo",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japonés",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Holandés",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polaco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portugués",
  locale_pt_br_label_secondary: "brasil",
  locale_ru_ru_label_primary: "Ruso",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Sueco",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "tagalo",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chino",
  locale_zn_cn_label_secondary: "",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Magazine",
  nav_primary_catalog_label: "Idiomas Y Precios",
  nav_primary_catalog_select_language_label: "Selecciona un idioma:",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "¿Tener preguntas? Llámanos",
  nav_primary_phone_number: "1 (800) ROSETTA",
  nav_primary_sign_in_label: "INGRESAR",
  nav_primary_support_label: "Asistencia",
  nav_primary_switch_language: "",
  nav_primary_vertical_consumer_label: "For You",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Para Educadores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresas",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Inicio",
  nav_secondary_enterprise_label: "Empresa",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Inicio",
  nav_secondary_education_primary_label: "Educación",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Inicio",
  nav_secondary_education_secondary_label: "Educación Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluciones",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Avalada durante 25+ años por las mejores organizaciones.",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Qué dice la gente de nosotros.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>La joya de la corona</em> entre los métodos de aprendizaje de idiomas por ordenador.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Me encanta el programa de Rosetta Stone y creo que su método para <em>aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Con su interfaz excelente para el usuario, instrucciones claras y una amplia gama de juegos y retos...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Que tipo de aluno você é?",
  verticals_education_primary: "Educação Basica",
  verticals_education_secondary: "Ensino Superior",
  verticals_enterprise: "Empresas",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "E-mail profesional",
  footer_cta_form_firstname: "Nombre",
  footer_cta_form_lastname: "Apellidos",
  footer_cta_form_organization: "Nombre de la Organización",
  footer_cta_form_organizationsize: "Tamaño de la organización",
  footer_cta_form_organizationsize_100: "100 o Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Más",
  footer_cta_form_phone: "Numero de Teléfono (Opcional)",
  footer_cta_form_pricing_thanks: "¡Gracias por tu interés! Alguien hará un seguimiento contigo en breve.",
  footer_cta_form_role: "Rol (o título)",
  footer_cta_form_role_boardmember: "Miembro de la Junta",
  footer_cta_form_role_curriculumdirector: "Director de Currículo / Coordinador de Instrucción",
  footer_cta_form_role_director: "Director",
  footer_cta_form_role_executive: "Dirección General / Ejecutivo",
  footer_cta_form_role_individualcontributor: "Colaborador Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Director de la Escuela",
  footer_cta_form_role_superintendent: "Superintendente / Administrador de Distrito",
  footer_cta_form_role_teacher: "Profesor",
  footer_cta_form_role_techcoordinator: "Coordinador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vicepresidente",
  footer_cta_form_submit: "CONSULTA GRATUITA",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "En línea",
  footer_cta_how_hear_other: "Otro",
  footer_cta_how_hear_referral: "Remisión",
  footer_cta_how_hear_search: "Buscador",
  footer_cta_how_hear_social: "Medios Sociales",
  footer_cta_how_hear_title: "¿Como supiste de nosotros? (Opcional)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: "aquí",
  footer_cta_opt_in_learn_more_link_text_1: "aquí.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone se compromete a proteger su privacidad. Nuestra completa política de privacidad está disponible ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para más información.",
  footer_cta_opt_in_text_before_button: "¡Sí! Me gustaría recibir actualizaciones de productos y marketing de Rosetta Stone. Haga clic ",
  footer_cta_pricing_button: "CONSULTA DE PRECIOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor complete y nos pondremos en contacto con usted de inmediato.",
  footer_cta_pricing_title: "Obtenga las respuestas sobre precios que necesita.",
  // Menu
  footer_menu_about_about_us_label: "Rosetta Stone",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Carrera profesional",
  footer_menu_about_contact_label: "Contacto",
  footer_menu_about_label: "SOBRE",
  footer_menu_about_press_label: "Prensa",
  footer_menu_products_demo_label: "Pruébalo gratis",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresas",
  footer_menu_products_label: "¿DÓNDE EMPEZAR?",
  footer_menu_products_mobile_label: "Apps Para Móvil",
  footer_menu_products_reviews_label: "Opiniones",
  footer_menu_support_faqs_label: "Preguntas más frecuentes",
  footer_menu_support_label: "Asistencia",
  footer_menu_support_support_site_label: "APOYO",
  footer_menu_support_system_requirements_label: "Requisitos del sistema",
  // Meta
  footer_meta_agreements_label: "Acuerdos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configuración de cookies",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_label: "Rosetta Stone Ltd. Todos los derechos reservados",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_privacy_policy_label: "Política de privacidad",
  footer_meta_terms_conditions_label: "Términos y condiciones",
  // Region
  footer_region_label: "Cambia Región",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conectate con nosotros",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_fr_FR = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "l'Arabe",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "l'Allemand",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "le Grec",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "l'Anglais",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "l'Anglais",
  locale_en_us_label_secondary: "Américain",
  locale_es_es_label_primary: "l'Espagnol",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "l'Espagnol",
  locale_es_la_label_secondary: "Amérique latine",
  locale_fa_ir_label_primary: "le Farsi",
  locale_fa_ir_label_secondary: "",
  locale_fr_fr_label_primary: "le Français",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "l'Irlandais",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "l'Hébreu",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "l'Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "l'Italien",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "le Japonais",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "le Coréen",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "le Néerlandais",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "le Polonais",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "le Portugais",
  locale_pt_br_label_secondary: "",
  locale_ru_ru_label_primary: "le Russe",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "le Suédois",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "le Filipino",
  locale_tl_ph_label_secondary: "",
  locale_tr_tr_label_primary: "le Turc",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "le Vietnamien",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "le Chinois",
  locale_zn_cn_label_secondary: "",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Magazine",
  nav_primary_catalog_label: "Langues Et Tarification",
  nav_primary_catalog_select_language_label: "Sélectionnez une langue:",
  nav_primary_contact_label: "Contact",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Avoir des questions? Appelez nous:",
  nav_primary_phone_number: "1 (800) ROSETTA",
  nav_primary_sign_in_label: "SE CONNECTER",
  nav_primary_support_label: "Assistance",
  nav_primary_switch_language: "Español",
  nav_primary_vertical_consumer_label: "",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Pour Les Éducateurs",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Pour Les Entreprises",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Accueil",
  nav_secondary_enterprise_label: "Entreprise",
  nav_secondary_enterprise_resources_label: "Ressources",
  nav_secondary_enterprise_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Accueil",
  nav_secondary_education_primary_label: "Éducation",
  nav_secondary_education_primary_resources_label: "Ressources",
  nav_secondary_education_primary_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Accueil",
  nav_secondary_education_secondary_label: "Éducation Supérieur",
  nav_secondary_education_secondary_resources_label: "Ressources",
  nav_secondary_education_secondary_solutions_label: "Solutions",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Reconnu depuis 25+ ans par les plus grandes organisations,",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Que disent les gens à notre propos.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>L'étalon d’or</em> de l'apprentissage interactif des langues.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;J'adore le logiciel de Rosetta Stone et je pense que <em>tl’approche de l'apprentissage linguistique fonctionne.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Grâce à l’excellente interface utilisateur, des instructions claires, la grande variété de jeux et défis,<em>Rosetta Stone est très attrayant.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "Keep Exploring",
  related_resources_button_label: "Read more",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Quel type d'apprenant êtes-vous?",
  verticals_education_primary: "Éducation",
  verticals_education_secondary: "Éducation Supérieur",
  verticals_enterprise: "Entreprise",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "Email",
  footer_cta_form_firstname: "Prénom",
  footer_cta_form_lastname: "Nom",
  footer_cta_form_organization: "Nom de l'Organisation",
  footer_cta_form_organizationsize: "Taille de l'Organisation",
  footer_cta_form_organizationsize_100: "100 ou Moins",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Plus",
  footer_cta_form_phone: "Numéro de Téléphone (Facultatif)",
  footer_cta_form_pricing_thanks: "Merci de votre intérêt! Quelqu'un vous suivra sous peu.",
  footer_cta_form_role: "Rôle (ou titre)",
  footer_cta_form_role_boardmember: "Membre d'Équipage",
  footer_cta_form_role_curriculumdirector: "Directeur du curriculum / coordinateur de l'instruction",
  footer_cta_form_role_director: "Réalisateur",
  footer_cta_form_role_executive: "Direction Générale / Executive",
  footer_cta_form_role_individualcontributor: "Contributeur Individuel",
  footer_cta_form_role_manager: "Directeur",
  footer_cta_form_role_principal: "Directeur d'École",
  footer_cta_form_role_superintendent: "Surintendant / Administrateur de district",
  footer_cta_form_role_teacher: "Professeur",
  footer_cta_form_role_techcoordinator: "Coordinateur Technologique",
  footer_cta_form_role_vicepresident: "Vice-Président",
  footer_cta_form_submit: "CONSULTATION GRATUITE",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Event",
  footer_cta_how_hear_online: "En ligne",
  footer_cta_how_hear_other: "Autre",
  footer_cta_how_hear_referral: "Référence",
  footer_cta_how_hear_search: "Moteur de recherche",
  footer_cta_how_hear_social: "Médias sociaux",
  footer_cta_how_hear_title: "Comment avez-vous entendu parler de nous? (Optionnel)",
  footer_cta_how_hear_webinar: "Séminaire en ligne",
  footer_cta_opt_in_learn_more_button_text: "ici",
  footer_cta_opt_in_learn_more_link_text_1: "ici.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/de/pdfs/website-privacy-policy-de.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone s'engage à protéger votre vie privée. Notre politique de confidentialité complète est disponible ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "pour plus d'informations.",
  footer_cta_opt_in_text_before_button: "Oui! J'aimerais recevoir les mises à jour et le marketing du produit de Rosetta Stone. Cliquez ",
  footer_cta_pricing_button: "DEMANDE DE TARIFS",
  footer_cta_pricing_label: "Vous cherchez une liste de pas?",
  footer_cta_pricing_subtitle: "S'il vous plaît compléter et nous vous contacterons immédiatement.",
  footer_cta_pricing_title: "Obtenez les informations sur nos tarifs.",
  // Menu
  footer_menu_about_about_us_label: "Rosetta Stone",
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Carrières",
  footer_menu_about_contact_label: "Contactez-nous",
  footer_menu_about_label: "À PROPOS",
  footer_menu_about_press_label: "Presse",
  footer_menu_products_demo_label: "Essayez gratuitement",
  footer_menu_products_education_primary_label: "Pour Les Éducateurs",
  footer_menu_products_education_secondary_label: "Pour les Éducateurs Supérieurs",
  footer_menu_products_enterprise_label: "Pour Les Entreprises",
  footer_menu_products_label: "PAR OÙ COMMENCER",
  footer_menu_products_mobile_label: "Applications Mobiles",
  footer_menu_products_reviews_label: "Avis Clients",
  footer_menu_support_faqs_label: "FAQ",
  footer_menu_support_label: "Assistance",
  footer_menu_support_support_site_label: "ASSISTANCE",
  footer_menu_support_system_requirements_label: "Configurations Requises",
  // Meta
  footer_meta_agreements_label: "Mentions Légales",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Paramètres des cookies",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone Ltd. Tous droits réservés",
  footer_meta_privacy_policy_label: "Politique de confidentialité",
  footer_meta_terms_conditions_label: "Modalités et Conditions",
  // Region
  footer_region_label: "Changer de région",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Connecte-toi avec nous",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_it_IT = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabo",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "Tedesco",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greco",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "Inglese",
  locale_en_gb_label_secondary: "",
  locale_en_us_label_primary: "Inglese",
  locale_en_us_label_secondary: "Americano",
  locale_es_es_label_primary: "Spagnolo",
  locale_es_es_label_secondary: "",
  locale_es_la_label_primary: "Spagnolo",
  locale_es_la_label_secondary: "America Latina",
  locale_fa_ir_label_primary: "Persiano",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "Francese",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irlandese",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Ebraico",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italiano",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Giapponese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Coreano",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Olandese",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polacco",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portoghese",
  locale_pt_br_label_secondary: "Brasile",
  locale_ru_ru_label_primary: "Russo",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Svedese",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Tagalog",
  locale_tl_ph_label_secondary: "Filippino",
  locale_tr_tr_label_primary: "Turco",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamita",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Cinese",
  locale_zn_cn_label_secondary: "Mandarino",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Lingue E Prezzi",
  nav_primary_catalog_select_language_label: "Seleziona una Lingua",
  nav_primary_contact_label: "Contatti",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Hai domande? Chiamaci",
  nav_primary_phone_number: "1 (800) ROSETTA",
  nav_primary_sign_in_label: "ACCEDI",
  nav_primary_support_label: "Assistenza",
  nav_primary_vertical_education_primary_label: "Per Gli Educatori",
  nav_primary_vertical_enterprise_label: "Per Le Aziende",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "Home",
  nav_secondary_enterprise_label: "Aziende",
  nav_secondary_enterprise_resources_label: "Risorse",
  nav_secondary_enterprise_solutions_label: "Soluzioni",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "Home",
  nav_secondary_education_primary_label: "Scuola Primaria e Secondaria",
  nav_secondary_education_primary_resources_label: "Risorse",
  nav_secondary_education_primary_solutions_label: "Soluzioni",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_custom_1_label: "",
  nav_secondary_education_secondary_home_label: "Home",
  nav_secondary_education_secondary_label: "Istruzione Superiore",
  nav_secondary_education_secondary_resources_label: "Risorse",
  nav_secondary_education_secondary_solutions_label: "Risorse",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Approvato per 25+ anni dalle migliori organizzazioni",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "Cosa dicono di noi.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>Il gioiello della corona</em> tra i metodi di apprendimento linguistico del computer.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Adoro il programma Rosetta Stone e penso che il tuo metodo per <em>L'apprendimento delle lingue funziona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Con la sua eccellente interfaccia per l'utente, istruzioni chiare e una vasta gamma di giochi e sfide ...  <em>Rosetta Stone sorprende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Che tipo di apprendista sei?",
  verticals_education_primary: "Scuola Primaria e Secondaria",
  verticals_education_secondary: "Istruzione Superiore",
  verticals_enterprise: "Aziende",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "Email Professionale",
  footer_cta_form_firstname: "Nome",
  footer_cta_form_lastname: "Cognome",
  footer_cta_form_organization: "Nome dell'istituto",
  footer_cta_form_organizationsize: "Dimensione dell'organizzazione",
  footer_cta_form_organizationsize_100: "100 o meno",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Altro",
  footer_cta_form_phone: "Numero di telefono (facoltativo)",
  footer_cta_form_pricing_thanks: "Grazie per il tuo interesse! Qualcuno ti seguirà a breve.",
  footer_cta_form_role: "Ruolo (o titolo)",
  footer_cta_form_role_boardmember: "Membro di bordo",
  footer_cta_form_role_curriculumdirector: "Direttore del Curriculum / Coordinatore delle Istruzioni",
  footer_cta_form_role_director: "Direttore",
  footer_cta_form_role_executive: "Gestione Generale / Esecutiva",
  footer_cta_form_role_individualcontributor: "Collaboratore individuale",
  footer_cta_form_role_manager: "Manager",
  footer_cta_form_role_principal: "Direttore della Scuola",
  footer_cta_form_role_superintendent: "Sovrintendente / Amministratore Distrettuale",
  footer_cta_form_role_teacher: "Professore",
  footer_cta_form_role_techcoordinator: "Coordinatore Tecnologico",
  footer_cta_form_role_vicepresident: "Vice Presidente",
  footer_cta_form_submit: "CONSULENZA GRATUITA",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "Email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "In linea",
  footer_cta_how_hear_other: "Altro",
  footer_cta_how_hear_referral: "Remissione",
  footer_cta_how_hear_search: "Cercatore",
  footer_cta_how_hear_social: "Social Media",
  footer_cta_how_hear_title: "Come hai saputo di noi? (Opzionale)",
  footer_cta_how_hear_webinar: "Seminario Web",
  footer_cta_opt_in_learn_more_button_text: " qui",
  footer_cta_opt_in_learn_more_link_text_1: "qui.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/it/pdfs/Italy_Privacy_Policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "Rosetta Stone si impegna a proteggere la tua privacy. La nostra completa informativa sulla privacy è disponibile",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "per maggiori informazioni.",
  footer_cta_opt_in_text_before_button: "Sì! Desidero ricevere aggiornamenti su prodotti e marketing da Rosetta Stone. Clicca",
  footer_cta_pricing_button: "CONSULTAZIONE DEI PREZZI",
  footer_cta_pricing_label: "Pronto per il prossimo passo?",
  footer_cta_pricing_subtitle: "Si prega di completare e ti contatteremo immediatamente.",
  footer_cta_pricing_title: "Ottieni informazioni sulle nostre tariffe.",
  // Menu
  footer_menu_about_about_us_label: "Rosetta Stone",
  footer_menu_about_careers_label: "Lavora Con Noi",
  footer_menu_about_contact_label: "Contatti",
  footer_menu_about_label: "Chi Siamo",
  footer_menu_about_press_label: "Stampa",
  footer_menu_products_demo_label: "Demo",
  footer_menu_products_education_primary_label: "Per gli Educatori",
  footer_menu_products_education_secondary_label: "Per gli Educatori Superiori",
  footer_menu_products_enterprise_label: "Per le Aziende",
  footer_menu_products_label: "Per Conoscerci Meglio",
  footer_menu_products_mobile_label: "Applicazioni Mobili",
  footer_menu_products_reviews_label: "Recensioni",
  footer_menu_support_faqs_label: "Domande frequenti",
  footer_menu_support_label: "Assistenza",
  footer_menu_support_support_site_label: "Supporto",
  footer_menu_support_system_requirements_label: "Requisiti di Sistema",
  // Meta
  footer_meta_agreements_label: "Condizioni generali di contratto",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Impostazioni cookie",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone GmbH. Tutti i diritti riservati.",
  footer_meta_privacy_policy_label: "Protezione dei dati",
  footer_meta_terms_conditions_label: "Informazioni legali",
  // Region
  footer_region_label: "Scegli il tuo paese",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Connettiti con noi",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_pt_BR = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabic",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "German",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greek",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "English",
  locale_en_gb_label_secondary: "British",
  locale_en_us_label_primary: "English",
  locale_en_us_label_secondary: "American",
  locale_es_es_label_primary: "Spanish",
  locale_es_es_label_secondary: "Spain",
  locale_es_la_label_primary: "Spanish",
  locale_es_la_label_secondary: "Latin America",
  locale_fa_ir_label_primary: "Persian",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "French",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irish",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebrew",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italian",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Korean",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Dutch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polish",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portuguese",
  locale_pt_br_label_secondary: "Brazil",
  locale_ru_ru_label_primary: "Russian",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Swedish",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "Tagalog",
  locale_tr_tr_label_primary: "Turkish",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamese",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinese",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_blog_label: "Blog",
  nav_primary_catalog_label: "Começar agora",
  nav_primary_catalog_select_language_label: "Selecione um idioma",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "Tem perguntas? Ligue para nós:",
  nav_primary_phone_number: "1-(800)-ROSETTA",
  nav_primary_sign_in_label: "ENTRAR",
  nav_primary_support_label: "Suporte",
  nav_primary_switch_language: "English",
  nav_primary_vertical_consumer_label: "Para Você",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "Para Professores",
  nav_primary_vertical_education_secondary_label: "",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "Para Empresas",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "Blog",
  nav_secondary_enterprise_custom_1_label: "Seja um Parceiro",
  nav_secondary_enterprise_home_label: "Inicial",
  nav_secondary_enterprise_label: "Empresas",
  nav_secondary_enterprise_resources_label: "Recursos",
  nav_secondary_enterprise_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_custom_1_label: "Seja um Parceiro",
  nav_secondary_education_primary_home_label: "Inicial",
  nav_secondary_education_primary_label: "Educação Basica",
  nav_secondary_education_primary_resources_label: "Recursos",
  nav_secondary_education_primary_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "Blog",
  nav_secondary_education_secondary_custom_1_label: "Seja um Parceiro",
  nav_secondary_education_secondary_home_label: "Inicial",
  nav_secondary_education_secondary_label: "Ensino Superior",
  nav_secondary_education_secondary_resources_label: "Recursos",
  nav_secondary_education_secondary_solutions_label: "Soluções",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "Aprovado há 25+ anos pelas melhores organizações.",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "O que as pessoas falam sobre nós.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;<em>A jóia da coroa</em> entre os métodos de aprendizado de idiomas.&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;Eu amo o programa Rosetta Stone e acho que <em>o método deles de aprender idiomas funciona.</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;Com sua excelente interface para o usuário, instruções claras e uma ampla gama de jogos e desafios ...  <em>Rosetta Stone surpreende.</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "Que tipo de aluno você é?",
  verticals_education_primary: "Educação Basica",
  verticals_education_secondary: "Ensino Superior",
  verticals_enterprise: "Empresas",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "",
  footer_cta_form_email: "Email",
  footer_cta_form_firstname: "Nome",
  footer_cta_form_lastname: "Sobrenome",
  footer_cta_form_organization: "Nome da Organização",
  footer_cta_form_organizationsize: "Tamanho da Organização",
  footer_cta_form_organizationsize_100: "100 ou Menos",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001 - Mais",
  footer_cta_form_phone: "Número de Telefone (Opcional)",
  footer_cta_form_pricing_thanks: "Obrigado pelo seu interesse! Alguém entrará em contato com você em breve.",
  footer_cta_form_role: "Função (ou título)",
  footer_cta_form_role_boardmember: "Membro do Conselho",
  footer_cta_form_role_curriculumdirector: "Diretor de Currículo / Coordenador de Instrução",
  footer_cta_form_role_director: "Diretor",
  footer_cta_form_role_executive: "Gerência Geral / Executiva",
  footer_cta_form_role_individualcontributor: "Contribuidor Individual",
  footer_cta_form_role_manager: "Gerente",
  footer_cta_form_role_principal: "Diretor da Escola",
  footer_cta_form_role_superintendent: "Superintendente / Administrador Distrital",
  footer_cta_form_role_teacher: "Professor",
  footer_cta_form_role_techcoordinator: "Coordenador de Tecnologia",
  footer_cta_form_role_vicepresident: "Vice Presidente",
  footer_cta_form_submit: "Consulta de preços",
  footer_cta_how_hear_blog: "Blog",
  footer_cta_how_hear_email: "O email",
  footer_cta_how_hear_event: "Evento",
  footer_cta_how_hear_online: "Conectados",
  footer_cta_how_hear_other: "De outros",
  footer_cta_how_hear_referral: "Referência",
  footer_cta_how_hear_search: "Motor de pesquisa",
  footer_cta_how_hear_social: "Mídia social",
  footer_cta_how_hear_title: "Como você ficou sabendo sobre nós? (Opcional)",
  footer_cta_how_hear_webinar: "Webinar",
  footer_cta_opt_in_learn_more_button_text: "aqui",
  footer_cta_opt_in_learn_more_link_text_1: "aqui.",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://resources.rosettastone.com/CDN/br/pdfs/br_privacy_policy.pdf",
  footer_cta_opt_in_learn_more_text_1: "A Rosetta Stone tem o compromisso de salvaguardar a sua privacidade. A nossa Política de Privacidade completa está disponível ",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: ".",
  footer_cta_opt_in_text_after_button: "para maiores informações.",
  footer_cta_opt_in_text_before_button: "Sim! Eu gostaria de receber atualizações de produtos e marketing da Rosetta Stone. Clique",
  footer_cta_pricing_button: "CONSULTA DE PREÇOS",
  footer_cta_pricing_label: "Listo para el siguiente paso?",
  footer_cta_pricing_subtitle: "Por favor, preencha e entraremos em contato imediatamente.",
  footer_cta_pricing_title: "Receba as informações que você precisa sobre os preços.",
  // Menu
  footer_menu_about_blog_label: "Blog",
  footer_menu_about_careers_label: "Carreiras",
  footer_menu_about_contact_label: "Contato",
  footer_menu_about_label: "Sobre",
  footer_menu_products_consumer_label: "Por onde começar?",
  footer_menu_products_education_primary_label: "Para Educadores",
  footer_menu_products_education_secondary_label: "Para Educadores Superiores",
  footer_menu_products_enterprise_label: "Para Empresas",
  footer_menu_products_label: "Por onde começar?",
  footer_menu_support_label: "Suporte",
  footer_menu_support_support_site_label: "Apoio",
  // Meta
  footer_meta_agreements_label: "Acordos",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Configurações de cookies",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "Rosetta Stone Ltd. Todos os direitos reservados.",
  footer_meta_privacy_policy_label: "Política de Privacidade",
  footer_meta_terms_conditions_label: "Termos e Condições",
  // Region
  footer_region_label: "Mudar de região",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conecte-se conosco",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var strings_zh_CN = {
  // ******************************************
  // Globals
  // ******************************************
  global_brand_name: "Rosetta Stone",
  product_name: "Rosetta Stone",
  // ******************************************
  // Globals - Locales
  // ******************************************
  locale_ar_ar_label_primary: "Arabic",
  locale_ar_ar_label_secondary: "",
  locale_de_de_label_primary: "German",
  locale_de_de_label_secondary: "",
  locale_el_gr_label_primary: "Greek",
  locale_el_gr_label_secondary: "",
  locale_en_gb_label_primary: "English",
  locale_en_gb_label_secondary: "British",
  locale_en_us_label_primary: "English",
  locale_en_us_label_secondary: "American",
  locale_es_es_label_primary: "Spanish",
  locale_es_es_label_secondary: "Spain",
  locale_es_la_label_primary: "Spanish",
  locale_es_la_label_secondary: "Latin America",
  locale_fa_ir_label_primary: "Persian",
  locale_fa_ir_label_secondary: "Farsi",
  locale_fr_fr_label_primary: "French",
  locale_fr_fr_label_secondary: "",
  locale_ga_ie_label_primary: "Irish",
  locale_ga_ie_label_secondary: "",
  locale_he_il_label_primary: "Hebrew",
  locale_he_il_label_secondary: "",
  locale_hi_in_label_primary: "Hindi",
  locale_hi_in_label_secondary: "",
  locale_it_it_label_primary: "Italian",
  locale_it_it_label_secondary: "",
  locale_ja_jp_label_primary: "Japanese",
  locale_ja_jp_label_secondary: "",
  locale_ko_kr_label_primary: "Korean",
  locale_ko_kr_label_secondary: "",
  locale_la_va_label_primary: "Latin",
  locale_la_va_label_secondary: "",
  locale_nl_nl_label_primary: "Dutch",
  locale_nl_nl_label_secondary: "",
  locale_pl_pl_label_primary: "Polish",
  locale_pl_pl_label_secondary: "",
  locale_pt_br_label_primary: "Portuguese",
  locale_pt_br_label_secondary: "Brazil",
  locale_ru_ru_label_primary: "Russian",
  locale_ru_ru_label_secondary: "",
  locale_sv_se_label_primary: "Swedish",
  locale_sv_se_label_secondary: "",
  locale_tl_ph_label_primary: "Filipino",
  locale_tl_ph_label_secondary: "Tagalog",
  locale_tr_tr_label_primary: "Turkish",
  locale_tr_tr_label_secondary: "",
  locale_vi_vn_label_primary: "Vietnamese",
  locale_vi_vn_label_secondary: "",
  locale_zn_cn_label_primary: "Chinese",
  locale_zn_cn_label_secondary: "Mandarin",
  // ******************************************
  // Nav Primary
  // ******************************************
  nav_primary_catalog_label: "",
  nav_primary_catalog_select_language_label: "",
  nav_primary_contact_label: "",
  nav_primary_logo_alt: "Rosetta Stone",
  nav_primary_phone_label: "你有问题吗？ 打电话给我们",
  nav_primary_phone_number: "Beijing (+86 10 5634 1576)",
  nav_primary_sign_in_label: "",
  nav_primary_support_label: "",
  nav_primary_switch_language: "",
  nav_primary_vertical_consumer_label: "",
  nav_primary_vertical_education_for_homeschool_label: "",
  nav_primary_vertical_education_for_students_label: "",
  nav_primary_vertical_education_homeschool_label: "",
  nav_primary_vertical_education_primary_label: "高等教育",
  nav_primary_vertical_education_secondary_label: "培训中心",
  nav_primary_vertical_education_students_label: "",
  nav_primary_vertical_enterprise_label: "企业",
  nav_primary_vertical_for_young_learners_label: "",
  // ******************************************
  // Nav Secondary - Enterprise
  // ******************************************
  nav_secondary_enterprise_blog_label: "",
  nav_secondary_enterprise_custom_1_label: "",
  nav_secondary_enterprise_home_label: "主页",
  nav_secondary_enterprise_label: "企业",
  nav_secondary_enterprise_resources_label: "资源",
  nav_secondary_enterprise_solutions_label: "语言解决方案",
  // ******************************************
  // Nav Secondary - Education Primary
  // ******************************************
  nav_secondary_education_primary_blog_label: "",
  nav_secondary_education_primary_home_label: "主页",
  nav_secondary_education_primary_label: "高等教育",
  nav_secondary_education_primary_resources_label: "资源",
  nav_secondary_education_primary_solutions_label: "语言解决方案",
  // ******************************************
  // Nav Secondary - Education Secondary
  // ******************************************
  nav_secondary_education_secondary_blog_label: "",
  nav_secondary_education_secondary_home_label: "主页",
  nav_secondary_education_secondary_label: "培训中心",
  nav_secondary_education_secondary_resources_label: "资源",
  nav_secondary_education_secondary_solutions_label: "语言解决方案",
  // ******************************************
  // Nav Secondary - Education Homeschool
  // ******************************************
  nav_secondary_education_homeschool_blog_label: "",
  nav_secondary_education_homeschool_home_label: "",
  nav_secondary_education_homeschool_label: "",
  nav_secondary_education_homeschool_resources_label: "",
  nav_secondary_education_homeschool_solutions_label: "",
  // ******************************************
  // Nav Secondary - Services
  // ******************************************
  nav_secondary_services_blog_label: "",
  nav_secondary_services_home_label: "",
  nav_secondary_services_label: "",
  nav_secondary_services_resources_label: "",
  nav_secondary_services_solutions_label: "",
  // ******************************************
  // Shared - Awards
  // ******************************************
  awards_header_label: "受到顶级组织信任超过25年",
  awards_bmw: "BMW",
  awards_lego: "Lego",
  awards_twitter: "Twitter",
  awards_uber: "Uber",
  awards_williams_sonoma: "Williams Sonoma",
  // ******************************************
  // Shared - Branded Quotes
  // ******************************************
  branded_quotes_header_label: "人们对我们的评价.",
  branded_quotes_cnn_name: "CNN",
  branded_quotes_cnn_quote: "&quot;“基于计算机的语言学习的<em>黄金标准。</em>&quot;",
  branded_quotes_cnn_type: "cnn",
  branded_quotes_macworld_name: "MacWorld",
  branded_quotes_macworld_quote: "&quot;“我喜欢Rosetta Stone的软件，<em>我认为他们学习语言的方法很有效。</em>&quot;",
  branded_quotes_macworld_type: "macworld",
  branded_quotes_techcrunch_name: "TechCrunch",
  branded_quotes_techcrunch_quote: "&quot;“凭借其出色的用户界面，清晰的指令，各种各样的游戏和挑战......<em>Rosetta Stone提供了这么多。</em>&quot;",
  branded_quotes_techcrunch_type: "techcrunch",
  // ******************************************
  // Shared - Related Resources
  // ******************************************
  related_resources_label: "",
  related_resources_button_label: "",
  // ******************************************
  // Shared - Verticals
  // ******************************************
  verticals_label: "你是什​​么类型的学习者？",
  verticals_education_primary: "培训中心",
  verticals_education_secondary: "高等教育",
  verticals_enterprise: "企业",
  verticals_publicsector: "",
  // ******************************************
  // Footer
  // ******************************************
  // CTA Form
  footer_cta_email_button: "",
  footer_cta_email_main_label: "",
  footer_cta_email_placeholder: "",
  footer_cta_email_sub_label: "",
  footer_cta_form_comments: "",
  footer_cta_form_country: "国家",
  footer_cta_form_email: "电子邮箱（学校）",
  footer_cta_form_firstname: "名",
  footer_cta_form_lastname: "姓",
  footer_cta_form_organization: "企业／机构名称",
  footer_cta_form_organizationsize: "组织规模",
  footer_cta_form_organizationsize_100: "100或更少",
  footer_cta_form_organizationsize_500: "101 - 500",
  footer_cta_form_organizationsize_1000: "501 - 1,000",
  footer_cta_form_organizationsize_5000: "1,001 - 5,000",
  footer_cta_form_organizationsize_10000: "5,001 - 10,000",
  footer_cta_form_organizationsize_25000: "10,001 - 25,000",
  footer_cta_form_organizationsize_50000: "25,001 - 50,000",
  footer_cta_form_organizationsize_more: "50,001  - 更多",
  footer_cta_form_phone: "电话 （可选的）",
  footer_cta_form_pricing_thanks: "感谢您对Rosetta Stone的关注！ 有人会尽快与您联系并提供有用的信息。",
  footer_cta_form_role: "角色（或头衔）",
  footer_cta_form_role_boardmember: "董事会成员",
  footer_cta_form_role_curriculumdirector: "课程总监/指导协调员",
  footer_cta_form_role_director: "主管",
  footer_cta_form_role_executive: "经理",
  footer_cta_form_role_individualcontributor: "独立工作员工",
  footer_cta_form_role_manager: "总经理",
  footer_cta_form_role_principal: "校长",
  footer_cta_form_role_superintendent: "学监/区行政长官",
  footer_cta_form_role_teacher: "老师",
  footer_cta_form_role_techcoordinator: "技术协调员",
  footer_cta_form_role_vicepresident: "副总裁",
  footer_cta_form_submit: "免费咨询",
  footer_cta_how_hear_blog: "",
  footer_cta_how_hear_email: "电子邮件",
  footer_cta_how_hear_event: "事件",
  footer_cta_how_hear_online: "线上",
  footer_cta_how_hear_other: "其他",
  footer_cta_how_hear_referral: "推荐",
  footer_cta_how_hear_search: "搜索引擎",
  footer_cta_how_hear_social: "社交媒体",
  footer_cta_how_hear_title: "您是怎么知道我们的？ （可选的）",
  footer_cta_how_hear_webinar: "网络研讨会",
  footer_cta_opt_in_learn_more_button_text: "更多信息在這裡。",
  footer_cta_opt_in_learn_more_link_text_1: "隐私政策",
  footer_cta_opt_in_learn_more_privacyemail: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_privacyUrl: "https://www.rosettastone.com/privacy",
  footer_cta_opt_in_learn_more_text_1: "通过确认，我同意接收有关Rosetta Stone产品和服务的新闻，更新以及Rosetta Stone活动邀请的信息和营销，我理解并同意Rosetta Stone可以处理并将我的信息传输给全球的附属公司 以及根据Rosetta Stone的规定，为Rosetta Stone提供服务的第三方实体",
  footer_cta_opt_in_learn_more_text_2: " privacyofficer@rosettastone.com",
  footer_cta_opt_in_learn_more_text_3: "。",
  footer_cta_opt_in_text_after_button: "",
  footer_cta_opt_in_text_before_button: "是! 我想收到Rosetta Stone的产品更新和营销。",
  footer_cta_pricing_button: "价格 ",
  footer_cta_pricing_label: "准备好下一步了吗？",
  footer_cta_pricing_subtitle: "请完成，我们会立即与您联系。",
  footer_cta_pricing_title: "了解您所需要的价格信息。",
  // Menu
  footer_menu_about_careers_label: "职业发展",
  footer_menu_about_contact_label: "联系我们",
  footer_menu_about_investors_label: "投资者关系",
  footer_menu_about_label: "关于我们",
  footer_menu_about_press_label: "新闻",
  footer_menu_products_consumer_label: "从哪里开始？",
  footer_menu_products_education_primary_label: "高等教育",
  footer_menu_products_education_secondary_label: "培训中心",
  footer_menu_products_enterprise_label: "企业",
  footer_menu_products_label: "从哪里开始？",
  footer_menu_support_label: "支持",
  footer_menu_support_support_site_label: "支持网站",
  // Meta
  footer_meta_agreements_label: "协议",
  footer_meta_ccpa_label: "Do Not Sell My Information",
  footer_meta_cookie_settings_label: "Cookie设置",
  footer_meta_copyright_alt: "Go to home page",
  footer_meta_copyright_IXL: "A division of IXL Learning",
  footer_meta_copyright_label: "1999-2021 Rosetta Stone Ltd.保留所有权利。 本网站使用cookies。 继续使用本网站即表示同意使用cookie。",
  footer_meta_icp_label: "京ICP备09009396号-7",
  footer_meta_icp_link: "https://beian.miit.gov.cn",
  footer_meta_privacy_policy_label: "隐私政策",
  footer_meta_terms_conditions_label: "条款和条件",
  // Region
  footer_region_label: "变更地区",
  footer_region_options_au_label: "Australia",
  footer_region_options_br_label: "Brasil",
  footer_region_options_cn_label: "中国",
  footer_region_options_de_label: "Deutschland",
  footer_region_options_es_label: "España",
  footer_region_options_eu_label: "Europe",
  footer_region_options_fr_label: "France",
  footer_region_options_it_label: "Italia",
  footer_region_options_jp_label: "日本",
  footer_region_options_kr_label: "대한민국",
  footer_region_options_la_label: "America Latina",
  footer_region_options_uk_label: "United Kingdom",
  footer_region_options_us_label: "United States",
  // Social
  footer_social_label: "Conecte-se conosco",
  footer_social_facebook_alt: "Facebook",
  footer_social_instagram_alt: "Instagram",
  footer_social_twitter_alt: "Twitter",
  footer_social_youtube_alt: "Youtube"
};

var configGenerator = (function (_ref) {
  var market = _ref.market,
      site = _ref.site,
      page = _ref.page,
      locale = _ref.locale;
  var strings;

  switch (locale) {
    case "de-DE":
      strings = strings_de_DE;
      break;

    case "en-GB":
      strings = strings_en_GB;
      break;

    case "es-419":
      strings = strings_es_419;
      break;

    case "es-ES":
      strings = strings_es_ES;
      break;

    case "fr-FR":
      strings = strings_fr_FR;
      break;

    case "it-IT":
      strings = strings_it_IT;
      break;

    case "pt-BR":
      strings = strings_pt_BR;
      break;

    case "zh-CN":
      strings = strings_zh_CN;
      break;

    default:
      strings = strings_en_US;
  }

  switch (market.toString().toLowerCase()) {
    case "cn":
      return cn({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "de":
      return de({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "es":
      return es({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "fr":
      return fr({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "it":
      return it({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "la":
      return la({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "pt":
      return pt({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "uk":
      return uk({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });

    case "us":
      return us({
        market: market,
        site: site,
        page: page,
        locale: locale,
        strings: strings
      });
  }
});

export default configGenerator;
